import { ReadingText } from "./type.app.js";

export const corpus = [
  {
    id: "letter-a",
    text: "a",
    level: 1,
    kind: "letter",
  },
  {
    id: "letter-t",
    text: "t",
    level: 1,
    kind: "letter",
  },
  {
    id: "letter-s",
    text: "s",
    level: 1,
    kind: "letter",
  },
  {
    id: "letter-i",
    text: "i",
    level: 1,
    kind: "letter",
  },
  {
    id: "letter-p",
    text: "p",
    level: 1,
    kind: "letter",
  },
  {
    id: "letter-n",
    text: "n",
    level: 2,
    kind: "letter",
  },
  {
    id: "letter-m",
    text: "m",
    level: 2,
    kind: "letter",
  },
  {
    id: "letter-d",
    text: "d",
    level: 2,
    kind: "letter",
  },
  {
    id: "letter-g",
    text: "g",
    level: 2,
    kind: "letter",
  },
  {
    id: "letter-o",
    text: "o",
    level: 2,
    kind: "letter",
  },
  {
    id: "letter-c",
    text: "c",
    level: 3,
    kind: "letter",
  },
  {
    id: "letter-k",
    text: "k",
    level: 3,
    kind: "letter",
  },
  {
    id: "letter-e",
    text: "e",
    level: 3,
    kind: "letter",
  },
  {
    id: "letter-u",
    text: "u",
    level: 3,
    kind: "letter",
  },
  {
    id: "letter-r",
    text: "r",
    level: 3,
    kind: "letter",
  },
  {
    id: "letter-h",
    text: "h",
    level: 4,
    kind: "letter",
  },
  {
    id: "letter-b",
    text: "b",
    level: 4,
    kind: "letter",
  },
  {
    id: "letter-f",
    text: "f",
    level: 4,
    kind: "letter",
  },
  {
    id: "letter-l",
    text: "l",
    level: 4,
    kind: "letter",
  },
  {
    id: "letter-j",
    text: "j",
    level: 4,
    kind: "letter",
  },
  {
    id: "letter-v",
    text: "v",
    level: 5,
    kind: "letter",
  },
  {
    id: "letter-w",
    text: "w",
    level: 5,
    kind: "letter",
  },
  {
    id: "letter-x",
    text: "x",
    level: 5,
    kind: "letter",
  },
  {
    id: "letter-y",
    text: "y",
    level: 5,
    kind: "letter",
  },
  {
    id: "letter-z",
    text: "z",
    level: 5,
    kind: "letter",
  },
  {
    id: "letter-qu",
    text: "qu",
    level: 6,
    kind: "letter",
  },
  {
    id: "letter-ck",
    text: "ck",
    level: 6,
    kind: "letter",
  },
  {
    id: "letter-sh",
    text: "sh",
    level: 6,
    kind: "letter",
  },
  {
    id: "letter-ch",
    text: "ch",
    level: 6,
    kind: "letter",
  },
  {
    id: "letter-th",
    text: "th",
    level: 6,
    kind: "letter",
  },
  {
    id: "letter-wh",
    text: "wh",
    level: 6,
    kind: "letter",
  },
  {
    id: "letter-ff",
    text: "ff",
    level: 7,
    kind: "letter",
  },
  {
    id: "letter-ll",
    text: "ll",
    level: 7,
    kind: "letter",
  },
  {
    id: "letter-ss",
    text: "ss",
    level: 7,
    kind: "letter",
  },
  {
    id: "letter-zz",
    text: "zz",
    level: 7,
    kind: "letter",
  },
  {
    id: "letter-ph",
    text: "ph",
    level: 7,
    kind: "letter",
  },
  {
    id: "letter-ng",
    text: "ng",
    level: 7,
    kind: "letter",
  },
  {
    id: "letter-nk",
    text: "nk",
    level: 7,
    kind: "letter",
  },
  {
    id: "letter-tch",
    text: "tch",
    level: 7,
    kind: "letter",
  },
  {
    id: "letter-bl",
    text: "bl",
    level: 8,
    kind: "letter",
  },
  {
    id: "letter-cl",
    text: "cl",
    level: 8,
    kind: "letter",
  },
  {
    id: "letter-fl",
    text: "fl",
    level: 8,
    kind: "letter",
  },
  {
    id: "letter-gl",
    text: "gl",
    level: 8,
    kind: "letter",
  },
  {
    id: "letter-pl",
    text: "pl",
    level: 8,
    kind: "letter",
  },
  {
    id: "letter-sl",
    text: "sl",
    level: 8,
    kind: "letter",
  },
  {
    id: "letter-sc",
    text: "sc",
    level: 8,
    kind: "letter",
  },
  {
    id: "letter-sk",
    text: "sk",
    level: 8,
    kind: "letter",
  },
  {
    id: "letter-sm",
    text: "sm",
    level: 8,
    kind: "letter",
  },
  {
    id: "letter-sn",
    text: "sn",
    level: 8,
    kind: "letter",
  },
  {
    id: "letter-ai",
    text: "ai",
    level: 8,
    kind: "letter",
  },
  {
    id: "letter-ay",
    text: "ay",
    level: 8,
    kind: "letter",
  },
  {
    id: "letter-ee",
    text: "ee",
    level: 8,
    kind: "letter",
  },
  {
    id: "letter-ea",
    text: "ea",
    level: 8,
    kind: "letter",
  },
  {
    id: "letter-oa",
    text: "oa",
    level: 8,
    kind: "letter",
  },
  {
    id: "letter-ow",
    text: "ow",
    level: 8,
    kind: "letter",
  },
  {
    id: "letter-oe",
    text: "oe",
    level: 8,
    kind: "letter",
  },
  {
    id: "letter-ie",
    text: "ie",
    level: 8,
    kind: "letter",
  },
  {
    id: "letter-igh",
    text: "igh",
    level: 8,
    kind: "letter",
  },
  {
    id: "letter-ue",
    text: "ue",
    level: 8,
    kind: "letter",
  },
  {
    id: "letter-br",
    text: "br",
    level: 9,
    kind: "letter",
  },
  {
    id: "letter-cr",
    text: "cr",
    level: 9,
    kind: "letter",
  },
  {
    id: "letter-dr",
    text: "dr",
    level: 9,
    kind: "letter",
  },
  {
    id: "letter-fr",
    text: "fr",
    level: 9,
    kind: "letter",
  },
  {
    id: "letter-gr",
    text: "gr",
    level: 9,
    kind: "letter",
  },
  {
    id: "letter-pr",
    text: "pr",
    level: 9,
    kind: "letter",
  },
  {
    id: "letter-tr",
    text: "tr",
    level: 9,
    kind: "letter",
  },
  {
    id: "letter-tw",
    text: "tw",
    level: 9,
    kind: "letter",
  },
  {
    id: "letter-sw",
    text: "sw",
    level: 9,
    kind: "letter",
  },
  {
    id: "letter-st",
    text: "st",
    level: 9,
    kind: "letter",
  },
  {
    id: "letter-ew",
    text: "ew",
    level: 9,
    kind: "letter",
  },
  {
    id: "letter-oo",
    text: "oo",
    level: 9,
    kind: "letter",
  },
  {
    id: "letter-ou",
    text: "ou",
    level: 9,
    kind: "letter",
  },
  {
    id: "letter-oi",
    text: "oi",
    level: 9,
    kind: "letter",
  },
  {
    id: "letter-oy",
    text: "oy",
    level: 9,
    kind: "letter",
  },
  {
    id: "letter-au",
    text: "au",
    level: 9,
    kind: "letter",
  },
  {
    id: "letter-aw",
    text: "aw",
    level: 9,
    kind: "letter",
  },
  {
    id: "letter-ui",
    text: "ui",
    level: 9,
    kind: "letter",
  },
  {
    id: "letter-ey",
    text: "ey",
    level: 9,
    kind: "letter",
  },
  {
    id: "letter-eigh",
    text: "eigh",
    level: 9,
    kind: "letter",
  },
  {
    id: "letter-sp",
    text: "sp",
    level: 10,
    kind: "letter",
  },
  {
    id: "letter-str",
    text: "str",
    level: 10,
    kind: "letter",
  },
  {
    id: "letter-spr",
    text: "spr",
    level: 10,
    kind: "letter",
  },
  {
    id: "letter-spl",
    text: "spl",
    level: 10,
    kind: "letter",
  },
  {
    id: "letter-scr",
    text: "scr",
    level: 10,
    kind: "letter",
  },
  {
    id: "letter-shr",
    text: "shr",
    level: 10,
    kind: "letter",
  },
  {
    id: "letter-thr",
    text: "thr",
    level: 10,
    kind: "letter",
  },
  {
    id: "letter-squ",
    text: "squ",
    level: 10,
    kind: "letter",
  },
  {
    id: "letter-nd",
    text: "nd",
    level: 10,
    kind: "letter",
  },
  {
    id: "letter-nt",
    text: "nt",
    level: 10,
    kind: "letter",
  },
  {
    id: "letter-ar",
    text: "ar",
    level: 10,
    kind: "letter",
  },
  {
    id: "letter-or",
    text: "or",
    level: 10,
    kind: "letter",
  },
  {
    id: "letter-er",
    text: "er",
    level: 10,
    kind: "letter",
  },
  {
    id: "letter-ir",
    text: "ir",
    level: 10,
    kind: "letter",
  },
  {
    id: "letter-ur",
    text: "ur",
    level: 10,
    kind: "letter",
  },
  {
    id: "letter-air",
    text: "air",
    level: 10,
    kind: "letter",
  },
  {
    id: "letter-ear",
    text: "ear",
    level: 10,
    kind: "letter",
  },
  {
    id: "letter-ore",
    text: "ore",
    level: 10,
    kind: "letter",
  },
  {
    id: "letter-ure",
    text: "ure",
    level: 10,
    kind: "letter",
  },
  {
    id: "letter-oor",
    text: "oor",
    level: 10,
    kind: "letter",
  },
  {
    id: "l008-020",
    text: "cat",
    level: 8,
    kind: "word",
  },
  {
    id: "l008-021",
    text: "hat",
    level: 8,
    kind: "word",
  },
  {
    id: "l008-022",
    text: "sat",
    level: 8,
    kind: "word",
  },
  {
    id: "l008-023",
    text: "mat",
    level: 8,
    kind: "word",
  },
  {
    id: "l008-024",
    text: "bat",
    level: 8,
    kind: "word",
  },
  {
    id: "l008-025",
    text: "rat",
    level: 8,
    kind: "word",
  },
  {
    id: "l008-026",
    text: "pat",
    level: 8,
    kind: "word",
  },
  {
    id: "l008-027",
    text: "a",
    level: 8,
    kind: "word",
  },
  {
    id: "l008-028",
    text: "I",
    level: 8,
    kind: "word",
  },
  {
    id: "l008-029",
    text: "at",
    level: 8,
    kind: "word",
  },
  {
    id: "l009-020",
    text: "dog",
    level: 9,
    kind: "word",
  },
  {
    id: "l009-021",
    text: "hog",
    level: 9,
    kind: "word",
  },
  {
    id: "l009-022",
    text: "log",
    level: 9,
    kind: "word",
  },
  {
    id: "l009-023",
    text: "fog",
    level: 9,
    kind: "word",
  },
  {
    id: "l009-024",
    text: "mom",
    level: 9,
    kind: "word",
  },
  {
    id: "l009-025",
    text: "pop",
    level: 9,
    kind: "word",
  },
  {
    id: "l009-026",
    text: "hop",
    level: 9,
    kind: "word",
  },
  {
    id: "l009-027",
    text: "top",
    level: 9,
    kind: "word",
  },
  {
    id: "l009-028",
    text: "mop",
    level: 9,
    kind: "word",
  },
  {
    id: "l009-029",
    text: "pot",
    level: 9,
    kind: "word",
  },
  {
    id: "l010-020",
    text: "pig",
    level: 10,
    kind: "word",
  },
  {
    id: "l010-021",
    text: "big",
    level: 10,
    kind: "word",
  },
  {
    id: "l010-022",
    text: "dig",
    level: 10,
    kind: "word",
  },
  {
    id: "l010-023",
    text: "wig",
    level: 10,
    kind: "word",
  },
  {
    id: "l010-024",
    text: "sit",
    level: 10,
    kind: "word",
  },
  {
    id: "l010-025",
    text: "hit",
    level: 10,
    kind: "word",
  },
  {
    id: "l010-026",
    text: "bit",
    level: 10,
    kind: "word",
  },
  {
    id: "l010-027",
    text: "kit",
    level: 10,
    kind: "word",
  },
  {
    id: "l010-028",
    text: "lit",
    level: 10,
    kind: "word",
  },
  {
    id: "l010-029",
    text: "it",
    level: 10,
    kind: "word",
  },
  {
    id: "l011-000",
    text: "cat",
    level: 11,
    kind: "word",
  },
  {
    id: "l011-001",
    text: "hat",
    level: 11,
    kind: "word",
  },
  {
    id: "l011-002",
    text: "sat",
    level: 11,
    kind: "word",
  },
  {
    id: "l011-003",
    text: "mat",
    level: 11,
    kind: "word",
  },
  {
    id: "l011-004",
    text: "bat",
    level: 11,
    kind: "word",
  },
  {
    id: "l011-005",
    text: "rat",
    level: 11,
    kind: "word",
  },
  {
    id: "l011-006",
    text: "pat",
    level: 11,
    kind: "word",
  },
  {
    id: "l011-007",
    text: "a",
    level: 11,
    kind: "word",
  },
  {
    id: "l011-008",
    text: "I",
    level: 11,
    kind: "word",
  },
  {
    id: "l011-009",
    text: "at",
    level: 11,
    kind: "word",
  },
  {
    id: "l012-000",
    text: "dog",
    level: 12,
    kind: "word",
  },
  {
    id: "l012-001",
    text: "hog",
    level: 12,
    kind: "word",
  },
  {
    id: "l012-002",
    text: "log",
    level: 12,
    kind: "word",
  },
  {
    id: "l012-003",
    text: "fog",
    level: 12,
    kind: "word",
  },
  {
    id: "l012-004",
    text: "mom",
    level: 12,
    kind: "word",
  },
  {
    id: "l012-005",
    text: "pop",
    level: 12,
    kind: "word",
  },
  {
    id: "l012-006",
    text: "hop",
    level: 12,
    kind: "word",
  },
  {
    id: "l012-007",
    text: "top",
    level: 12,
    kind: "word",
  },
  {
    id: "l012-008",
    text: "mop",
    level: 12,
    kind: "word",
  },
  {
    id: "l012-009",
    text: "pot",
    level: 12,
    kind: "word",
  },
  {
    id: "l013-000",
    text: "pig",
    level: 13,
    kind: "word",
  },
  {
    id: "l013-001",
    text: "big",
    level: 13,
    kind: "word",
  },
  {
    id: "l013-002",
    text: "dig",
    level: 13,
    kind: "word",
  },
  {
    id: "l013-003",
    text: "wig",
    level: 13,
    kind: "word",
  },
  {
    id: "l013-004",
    text: "sit",
    level: 13,
    kind: "word",
  },
  {
    id: "l013-005",
    text: "hit",
    level: 13,
    kind: "word",
  },
  {
    id: "l013-006",
    text: "bit",
    level: 13,
    kind: "word",
  },
  {
    id: "l013-007",
    text: "kit",
    level: 13,
    kind: "word",
  },
  {
    id: "l013-008",
    text: "lit",
    level: 13,
    kind: "word",
  },
  {
    id: "l013-009",
    text: "it",
    level: 13,
    kind: "word",
  },
  {
    id: "l014-000",
    text: "sun",
    level: 14,
    kind: "word",
  },
  {
    id: "l014-001",
    text: "run",
    level: 14,
    kind: "word",
  },
  {
    id: "l014-002",
    text: "fun",
    level: 14,
    kind: "word",
  },
  {
    id: "l014-003",
    text: "bun",
    level: 14,
    kind: "word",
  },
  {
    id: "l014-004",
    text: "cup",
    level: 14,
    kind: "word",
  },
  {
    id: "l014-005",
    text: "pup",
    level: 14,
    kind: "word",
  },
  {
    id: "l014-006",
    text: "up",
    level: 14,
    kind: "word",
  },
  {
    id: "l014-007",
    text: "bug",
    level: 14,
    kind: "word",
  },
  {
    id: "l014-008",
    text: "hug",
    level: 14,
    kind: "word",
  },
  {
    id: "l014-009",
    text: "mug",
    level: 14,
    kind: "word",
  },
  {
    id: "l015-000",
    text: "red",
    level: 15,
    kind: "word",
  },
  {
    id: "l015-001",
    text: "bed",
    level: 15,
    kind: "word",
  },
  {
    id: "l015-002",
    text: "fed",
    level: 15,
    kind: "word",
  },
  {
    id: "l015-003",
    text: "hen",
    level: 15,
    kind: "word",
  },
  {
    id: "l015-004",
    text: "pen",
    level: 15,
    kind: "word",
  },
  {
    id: "l015-005",
    text: "ten",
    level: 15,
    kind: "word",
  },
  {
    id: "l015-006",
    text: "net",
    level: 15,
    kind: "word",
  },
  {
    id: "l015-007",
    text: "wet",
    level: 15,
    kind: "word",
  },
  {
    id: "l015-008",
    text: "pet",
    level: 15,
    kind: "word",
  },
  {
    id: "l015-009",
    text: "let",
    level: 15,
    kind: "word",
  },
  {
    id: "l015-010",
    text: "man",
    level: 15,
    kind: "word",
  },
  {
    id: "l015-011",
    text: "can",
    level: 15,
    kind: "word",
  },
  {
    id: "l015-012",
    text: "pan",
    level: 15,
    kind: "word",
  },
  {
    id: "l015-013",
    text: "ran",
    level: 15,
    kind: "word",
  },
  {
    id: "l015-014",
    text: "van",
    level: 15,
    kind: "word",
  },
  {
    id: "l015-015",
    text: "cap",
    level: 15,
    kind: "word",
  },
  {
    id: "l015-016",
    text: "map",
    level: 15,
    kind: "word",
  },
  {
    id: "l015-017",
    text: "nap",
    level: 15,
    kind: "word",
  },
  {
    id: "l015-018",
    text: "jam",
    level: 15,
    kind: "word",
  },
  {
    id: "l015-019",
    text: "ham",
    level: 15,
    kind: "word",
  },
  {
    id: "l016-000",
    text: "see",
    level: 16,
    kind: "word",
  },
  {
    id: "l016-001",
    text: "me",
    level: 16,
    kind: "word",
  },
  {
    id: "l016-002",
    text: "we",
    level: 16,
    kind: "word",
  },
  {
    id: "l016-003",
    text: "he",
    level: 16,
    kind: "word",
  },
  {
    id: "l016-004",
    text: "she",
    level: 16,
    kind: "word",
  },
  {
    id: "l016-005",
    text: "go",
    level: 16,
    kind: "word",
  },
  {
    id: "l016-006",
    text: "no",
    level: 16,
    kind: "word",
  },
  {
    id: "l016-007",
    text: "so",
    level: 16,
    kind: "word",
  },
  {
    id: "l016-008",
    text: "my",
    level: 16,
    kind: "word",
  },
  {
    id: "l016-009",
    text: "by",
    level: 16,
    kind: "word",
  },
  {
    id: "l017-000",
    text: "the",
    level: 17,
    kind: "word",
  },
  {
    id: "l017-001",
    text: "and",
    level: 17,
    kind: "word",
  },
  {
    id: "l017-002",
    text: "you",
    level: 17,
    kind: "word",
  },
  {
    id: "l017-003",
    text: "is",
    level: 17,
    kind: "word",
  },
  {
    id: "l017-004",
    text: "in",
    level: 17,
    kind: "word",
  },
  {
    id: "l017-005",
    text: "on",
    level: 17,
    kind: "word",
  },
  {
    id: "l017-006",
    text: "to",
    level: 17,
    kind: "word",
  },
  {
    id: "l017-007",
    text: "do",
    level: 17,
    kind: "word",
  },
  {
    id: "l017-008",
    text: "yes",
    level: 17,
    kind: "word",
  },
  {
    id: "l017-009",
    text: "not",
    level: 17,
    kind: "word",
  },
  {
    id: "l018-000",
    text: "box",
    level: 18,
    kind: "word",
  },
  {
    id: "l018-001",
    text: "fox",
    level: 18,
    kind: "word",
  },
  {
    id: "l018-002",
    text: "six",
    level: 18,
    kind: "word",
  },
  {
    id: "l018-003",
    text: "mix",
    level: 18,
    kind: "word",
  },
  {
    id: "l018-004",
    text: "fix",
    level: 18,
    kind: "word",
  },
  {
    id: "l018-005",
    text: "zip",
    level: 18,
    kind: "word",
  },
  {
    id: "l018-006",
    text: "lip",
    level: 18,
    kind: "word",
  },
  {
    id: "l018-007",
    text: "sip",
    level: 18,
    kind: "word",
  },
  {
    id: "l018-008",
    text: "tip",
    level: 18,
    kind: "word",
  },
  {
    id: "l018-009",
    text: "dip",
    level: 18,
    kind: "word",
  },
  {
    id: "l019-000",
    text: "ship",
    level: 19,
    kind: "word",
  },
  {
    id: "l019-001",
    text: "shop",
    level: 19,
    kind: "word",
  },
  {
    id: "l019-002",
    text: "fish",
    level: 19,
    kind: "word",
  },
  {
    id: "l019-003",
    text: "wish",
    level: 19,
    kind: "word",
  },
  {
    id: "l019-004",
    text: "cash",
    level: 19,
    kind: "word",
  },
  {
    id: "l019-005",
    text: "dash",
    level: 19,
    kind: "word",
  },
  {
    id: "l019-006",
    text: "shut",
    level: 19,
    kind: "word",
  },
  {
    id: "l019-007",
    text: "chin",
    level: 19,
    kind: "word",
  },
  {
    id: "l019-008",
    text: "chip",
    level: 19,
    kind: "word",
  },
  {
    id: "l019-009",
    text: "chat",
    level: 19,
    kind: "word",
  },
  {
    id: "l020-000",
    text: "frog",
    level: 20,
    kind: "word",
  },
  {
    id: "l020-001",
    text: "flag",
    level: 20,
    kind: "word",
  },
  {
    id: "l020-002",
    text: "clap",
    level: 20,
    kind: "word",
  },
  {
    id: "l020-003",
    text: "slip",
    level: 20,
    kind: "word",
  },
  {
    id: "l020-004",
    text: "sled",
    level: 20,
    kind: "word",
  },
  {
    id: "l020-005",
    text: "stop",
    level: 20,
    kind: "word",
  },
  {
    id: "l020-006",
    text: "spot",
    level: 20,
    kind: "word",
  },
  {
    id: "l020-007",
    text: "spin",
    level: 20,
    kind: "word",
  },
  {
    id: "l020-008",
    text: "crab",
    level: 20,
    kind: "word",
  },
  {
    id: "l020-009",
    text: "drum",
    level: 20,
    kind: "word",
  },
  {
    id: "l021-000",
    text: "tree",
    level: 21,
    kind: "word",
  },
  {
    id: "l021-001",
    text: "bee",
    level: 21,
    kind: "word",
  },
  {
    id: "l021-002",
    text: "see",
    level: 21,
    kind: "word",
  },
  {
    id: "l021-003",
    text: "feet",
    level: 21,
    kind: "word",
  },
  {
    id: "l021-004",
    text: "seed",
    level: 21,
    kind: "word",
  },
  {
    id: "l021-005",
    text: "keep",
    level: 21,
    kind: "word",
  },
  {
    id: "l021-006",
    text: "green",
    level: 21,
    kind: "word",
  },
  {
    id: "l021-007",
    text: "sleep",
    level: 21,
    kind: "word",
  },
  {
    id: "l021-008",
    text: "three",
    level: 21,
    kind: "word",
  },
  {
    id: "l021-009",
    text: "sheep",
    level: 21,
    kind: "word",
  },
  {
    id: "l022-000",
    text: "rain",
    level: 22,
    kind: "word",
  },
  {
    id: "l022-001",
    text: "sail",
    level: 22,
    kind: "word",
  },
  {
    id: "l022-002",
    text: "mail",
    level: 22,
    kind: "word",
  },
  {
    id: "l022-003",
    text: "pain",
    level: 22,
    kind: "word",
  },
  {
    id: "l022-004",
    text: "wait",
    level: 22,
    kind: "word",
  },
  {
    id: "l022-005",
    text: "day",
    level: 22,
    kind: "word",
  },
  {
    id: "l022-006",
    text: "play",
    level: 22,
    kind: "word",
  },
  {
    id: "l022-007",
    text: "say",
    level: 22,
    kind: "word",
  },
  {
    id: "l022-008",
    text: "way",
    level: 22,
    kind: "word",
  },
  {
    id: "l022-009",
    text: "may",
    level: 22,
    kind: "word",
  },
  {
    id: "l023-000",
    text: "boat",
    level: 23,
    kind: "word",
  },
  {
    id: "l023-001",
    text: "coat",
    level: 23,
    kind: "word",
  },
  {
    id: "l023-002",
    text: "road",
    level: 23,
    kind: "word",
  },
  {
    id: "l023-003",
    text: "toad",
    level: 23,
    kind: "word",
  },
  {
    id: "l023-004",
    text: "soap",
    level: 23,
    kind: "word",
  },
  {
    id: "l023-005",
    text: "oak",
    level: 23,
    kind: "word",
  },
  {
    id: "l023-006",
    text: "low",
    level: 23,
    kind: "word",
  },
  {
    id: "l023-007",
    text: "show",
    level: 23,
    kind: "word",
  },
  {
    id: "l023-008",
    text: "grow",
    level: 23,
    kind: "word",
  },
  {
    id: "l023-009",
    text: "snow",
    level: 23,
    kind: "word",
  },
  {
    id: "l024-000",
    text: "bird",
    level: 24,
    kind: "word",
  },
  {
    id: "l024-001",
    text: "girl",
    level: 24,
    kind: "word",
  },
  {
    id: "l024-002",
    text: "turn",
    level: 24,
    kind: "word",
  },
  {
    id: "l024-003",
    text: "hurt",
    level: 24,
    kind: "word",
  },
  {
    id: "l024-004",
    text: "fur",
    level: 24,
    kind: "word",
  },
  {
    id: "l024-005",
    text: "her",
    level: 24,
    kind: "word",
  },
  {
    id: "l024-006",
    text: "were",
    level: 24,
    kind: "word",
  },
  {
    id: "l024-007",
    text: "first",
    level: 24,
    kind: "word",
  },
  {
    id: "l024-008",
    text: "dirt",
    level: 24,
    kind: "word",
  },
  {
    id: "l024-009",
    text: "burn",
    level: 24,
    kind: "word",
  },
  {
    id: "l024-010",
    text: "cake",
    level: 24,
    kind: "word",
  },
  {
    id: "l024-011",
    text: "make",
    level: 24,
    kind: "word",
  },
  {
    id: "l024-012",
    text: "take",
    level: 24,
    kind: "word",
  },
  {
    id: "l024-013",
    text: "name",
    level: 24,
    kind: "word",
  },
  {
    id: "l024-014",
    text: "game",
    level: 24,
    kind: "word",
  },
  {
    id: "l024-015",
    text: "came",
    level: 24,
    kind: "word",
  },
  {
    id: "l024-016",
    text: "lake",
    level: 24,
    kind: "word",
  },
  {
    id: "l024-017",
    text: "gate",
    level: 24,
    kind: "word",
  },
  {
    id: "l024-018",
    text: "late",
    level: 24,
    kind: "word",
  },
  {
    id: "l024-019",
    text: "same",
    level: 24,
    kind: "word",
  },
  {
    id: "l025-000",
    text: "bike",
    level: 25,
    kind: "word",
  },
  {
    id: "l025-001",
    text: "like",
    level: 25,
    kind: "word",
  },
  {
    id: "l025-002",
    text: "time",
    level: 25,
    kind: "word",
  },
  {
    id: "l025-003",
    text: "ride",
    level: 25,
    kind: "word",
  },
  {
    id: "l025-004",
    text: "hide",
    level: 25,
    kind: "word",
  },
  {
    id: "l025-005",
    text: "kite",
    level: 25,
    kind: "word",
  },
  {
    id: "l025-006",
    text: "five",
    level: 25,
    kind: "word",
  },
  {
    id: "l025-007",
    text: "nine",
    level: 25,
    kind: "word",
  },
  {
    id: "l025-008",
    text: "line",
    level: 25,
    kind: "word",
  },
  {
    id: "l025-009",
    text: "mine",
    level: 25,
    kind: "word",
  },
  {
    id: "l026-000",
    text: "home",
    level: 26,
    kind: "word",
  },
  {
    id: "l026-001",
    text: "bone",
    level: 26,
    kind: "word",
  },
  {
    id: "l026-002",
    text: "nose",
    level: 26,
    kind: "word",
  },
  {
    id: "l026-003",
    text: "rose",
    level: 26,
    kind: "word",
  },
  {
    id: "l026-004",
    text: "hope",
    level: 26,
    kind: "word",
  },
  {
    id: "l026-005",
    text: "rope",
    level: 26,
    kind: "word",
  },
  {
    id: "l026-006",
    text: "note",
    level: 26,
    kind: "word",
  },
  {
    id: "l026-007",
    text: "joke",
    level: 26,
    kind: "word",
  },
  {
    id: "l026-008",
    text: "hole",
    level: 26,
    kind: "word",
  },
  {
    id: "l026-009",
    text: "cone",
    level: 26,
    kind: "word",
  },
  {
    id: "l027-000",
    text: "jump",
    level: 27,
    kind: "word",
  },
  {
    id: "l027-001",
    text: "just",
    level: 27,
    kind: "word",
  },
  {
    id: "l027-002",
    text: "hand",
    level: 27,
    kind: "word",
  },
  {
    id: "l027-003",
    text: "land",
    level: 27,
    kind: "word",
  },
  {
    id: "l027-004",
    text: "sand",
    level: 27,
    kind: "word",
  },
  {
    id: "l027-005",
    text: "fast",
    level: 27,
    kind: "word",
  },
  {
    id: "l027-006",
    text: "last",
    level: 27,
    kind: "word",
  },
  {
    id: "l027-007",
    text: "best",
    level: 27,
    kind: "word",
  },
  {
    id: "l027-008",
    text: "nest",
    level: 27,
    kind: "word",
  },
  {
    id: "l027-009",
    text: "help",
    level: 27,
    kind: "word",
  },
  {
    id: "l028-000",
    text: "little",
    level: 28,
    kind: "word",
  },
  {
    id: "l028-001",
    text: "yellow",
    level: 28,
    kind: "word",
  },
  {
    id: "l028-002",
    text: "purple",
    level: 28,
    kind: "word",
  },
  {
    id: "l028-003",
    text: "orange",
    level: 28,
    kind: "word",
  },
  {
    id: "l028-004",
    text: "after",
    level: 28,
    kind: "word",
  },
  {
    id: "l028-005",
    text: "under",
    level: 28,
    kind: "word",
  },
  {
    id: "l028-006",
    text: "over",
    level: 28,
    kind: "word",
  },
  {
    id: "l028-007",
    text: "water",
    level: 28,
    kind: "word",
  },
  {
    id: "l028-008",
    text: "happy",
    level: 28,
    kind: "word",
  },
  {
    id: "l028-009",
    text: "funny",
    level: 28,
    kind: "word",
  },
  {
    id: "l029-000",
    text: "a cat",
    level: 29,
    kind: "phrase",
  },
  {
    id: "l029-001",
    text: "the hat",
    level: 29,
    kind: "phrase",
  },
  {
    id: "l029-002",
    text: "my dog",
    level: 29,
    kind: "phrase",
  },
  {
    id: "l029-003",
    text: "a sun",
    level: 29,
    kind: "phrase",
  },
  {
    id: "l029-004",
    text: "the cup",
    level: 29,
    kind: "phrase",
  },
  {
    id: "l029-005",
    text: "my mom",
    level: 29,
    kind: "phrase",
  },
  {
    id: "l029-006",
    text: "a bug",
    level: 29,
    kind: "phrase",
  },
  {
    id: "l029-007",
    text: "the hen",
    level: 29,
    kind: "phrase",
  },
  {
    id: "l029-008",
    text: "my dad",
    level: 29,
    kind: "phrase",
  },
  {
    id: "l029-009",
    text: "a fox",
    level: 29,
    kind: "phrase",
  },
  {
    id: "l030-000",
    text: "the cat",
    level: 30,
    kind: "phrase",
  },
  {
    id: "l030-001",
    text: "a big dog",
    level: 30,
    kind: "phrase",
  },
  {
    id: "l030-002",
    text: "my red hat",
    level: 30,
    kind: "phrase",
  },
  {
    id: "l030-003",
    text: "the wet hen",
    level: 30,
    kind: "phrase",
  },
  {
    id: "l030-004",
    text: "a hot sun",
    level: 30,
    kind: "phrase",
  },
  {
    id: "l030-005",
    text: "the tan pup",
    level: 30,
    kind: "phrase",
  },
  {
    id: "l030-006",
    text: "my old map",
    level: 30,
    kind: "phrase",
  },
  {
    id: "l030-007",
    text: "a fat pig",
    level: 30,
    kind: "phrase",
  },
  {
    id: "l030-008",
    text: "the sad man",
    level: 30,
    kind: "phrase",
  },
  {
    id: "l030-009",
    text: "my new pen",
    level: 30,
    kind: "phrase",
  },
  {
    id: "l031-000",
    text: "I see",
    level: 31,
    kind: "phrase",
  },
  {
    id: "l031-001",
    text: "we go",
    level: 31,
    kind: "phrase",
  },
  {
    id: "l031-002",
    text: "you sit",
    level: 31,
    kind: "phrase",
  },
  {
    id: "l031-003",
    text: "he ran",
    level: 31,
    kind: "phrase",
  },
  {
    id: "l031-004",
    text: "she sat",
    level: 31,
    kind: "phrase",
  },
  {
    id: "l031-005",
    text: "I hop",
    level: 31,
    kind: "phrase",
  },
  {
    id: "l031-006",
    text: "we run",
    level: 31,
    kind: "phrase",
  },
  {
    id: "l031-007",
    text: "you can",
    level: 31,
    kind: "phrase",
  },
  {
    id: "l031-008",
    text: "he hid",
    level: 31,
    kind: "phrase",
  },
  {
    id: "l031-009",
    text: "she won",
    level: 31,
    kind: "phrase",
  },
  {
    id: "l032-000",
    text: "big cat",
    level: 32,
    kind: "phrase",
  },
  {
    id: "l032-001",
    text: "red hat",
    level: 32,
    kind: "phrase",
  },
  {
    id: "l032-002",
    text: "hot sun",
    level: 32,
    kind: "phrase",
  },
  {
    id: "l032-003",
    text: "wet dog",
    level: 32,
    kind: "phrase",
  },
  {
    id: "l032-004",
    text: "sad hen",
    level: 32,
    kind: "phrase",
  },
  {
    id: "l032-005",
    text: "fun pig",
    level: 32,
    kind: "phrase",
  },
  {
    id: "l032-006",
    text: "old box",
    level: 32,
    kind: "phrase",
  },
  {
    id: "l032-007",
    text: "new cup",
    level: 32,
    kind: "phrase",
  },
  {
    id: "l032-008",
    text: "tan fox",
    level: 32,
    kind: "phrase",
  },
  {
    id: "l032-009",
    text: "bad bug",
    level: 32,
    kind: "phrase",
  },
  {
    id: "l033-000",
    text: "the red cat",
    level: 33,
    kind: "phrase",
  },
  {
    id: "l033-001",
    text: "a big dog",
    level: 33,
    kind: "phrase",
  },
  {
    id: "l033-002",
    text: "my tan hat",
    level: 33,
    kind: "phrase",
  },
  {
    id: "l033-003",
    text: "the hot sun",
    level: 33,
    kind: "phrase",
  },
  {
    id: "l033-004",
    text: "a wet log",
    level: 33,
    kind: "phrase",
  },
  {
    id: "l033-005",
    text: "my fun map",
    level: 33,
    kind: "phrase",
  },
  {
    id: "l033-006",
    text: "the old van",
    level: 33,
    kind: "phrase",
  },
  {
    id: "l033-007",
    text: "a new bed",
    level: 33,
    kind: "phrase",
  },
  {
    id: "l033-008",
    text: "the fat hen",
    level: 33,
    kind: "phrase",
  },
  {
    id: "l033-009",
    text: "my sad pup",
    level: 33,
    kind: "phrase",
  },
  {
    id: "l033-010",
    text: "I see it",
    level: 33,
    kind: "phrase",
  },
  {
    id: "l033-011",
    text: "we can go",
    level: 33,
    kind: "phrase",
  },
  {
    id: "l033-012",
    text: "you did it",
    level: 33,
    kind: "phrase",
  },
  {
    id: "l033-013",
    text: "he can run",
    level: 33,
    kind: "phrase",
  },
  {
    id: "l033-014",
    text: "she can hop",
    level: 33,
    kind: "phrase",
  },
  {
    id: "l033-015",
    text: "I like it",
    level: 33,
    kind: "phrase",
  },
  {
    id: "l033-016",
    text: "we see you",
    level: 33,
    kind: "phrase",
  },
  {
    id: "l033-017",
    text: "you can sit",
    level: 33,
    kind: "phrase",
  },
  {
    id: "l033-018",
    text: "he is up",
    level: 33,
    kind: "phrase",
  },
  {
    id: "l033-019",
    text: "she is in",
    level: 33,
    kind: "phrase",
  },
  {
    id: "l034-000",
    text: "on the mat",
    level: 34,
    kind: "phrase",
  },
  {
    id: "l034-001",
    text: "in the box",
    level: 34,
    kind: "phrase",
  },
  {
    id: "l034-002",
    text: "up the hill",
    level: 34,
    kind: "phrase",
  },
  {
    id: "l034-003",
    text: "by the bed",
    level: 34,
    kind: "phrase",
  },
  {
    id: "l034-004",
    text: "to the van",
    level: 34,
    kind: "phrase",
  },
  {
    id: "l034-005",
    text: "in my cup",
    level: 34,
    kind: "phrase",
  },
  {
    id: "l034-006",
    text: "on my hat",
    level: 34,
    kind: "phrase",
  },
  {
    id: "l034-007",
    text: "by the log",
    level: 34,
    kind: "phrase",
  },
  {
    id: "l034-008",
    text: "in the sun",
    level: 34,
    kind: "phrase",
  },
  {
    id: "l034-009",
    text: "to the shop",
    level: 34,
    kind: "phrase",
  },
  {
    id: "l035-000",
    text: "a red ball",
    level: 35,
    kind: "phrase",
  },
  {
    id: "l035-001",
    text: "the big bus",
    level: 35,
    kind: "phrase",
  },
  {
    id: "l035-002",
    text: "my old book",
    level: 35,
    kind: "phrase",
  },
  {
    id: "l035-003",
    text: "a tan duck",
    level: 35,
    kind: "phrase",
  },
  {
    id: "l035-004",
    text: "the wet frog",
    level: 35,
    kind: "phrase",
  },
  {
    id: "l035-005",
    text: "my fun kite",
    level: 35,
    kind: "phrase",
  },
  {
    id: "l035-006",
    text: "a hot cake",
    level: 35,
    kind: "phrase",
  },
  {
    id: "l035-007",
    text: "the sad bird",
    level: 35,
    kind: "phrase",
  },
  {
    id: "l035-008",
    text: "my new bike",
    level: 35,
    kind: "phrase",
  },
  {
    id: "l035-009",
    text: "a fast ant",
    level: 35,
    kind: "phrase",
  },
  {
    id: "l036-000",
    text: "look at me",
    level: 36,
    kind: "phrase",
  },
  {
    id: "l036-001",
    text: "come with us",
    level: 36,
    kind: "phrase",
  },
  {
    id: "l036-002",
    text: "go to bed",
    level: 36,
    kind: "phrase",
  },
  {
    id: "l036-003",
    text: "sit with me",
    level: 36,
    kind: "phrase",
  },
  {
    id: "l036-004",
    text: "run to mom",
    level: 36,
    kind: "phrase",
  },
  {
    id: "l036-005",
    text: "jump with dad",
    level: 36,
    kind: "phrase",
  },
  {
    id: "l036-006",
    text: "play with me",
    level: 36,
    kind: "phrase",
  },
  {
    id: "l036-007",
    text: "look at it",
    level: 36,
    kind: "phrase",
  },
  {
    id: "l036-008",
    text: "come and see",
    level: 36,
    kind: "phrase",
  },
  {
    id: "l036-009",
    text: "go and play",
    level: 36,
    kind: "phrase",
  },
  {
    id: "l037-000",
    text: "the little cat",
    level: 37,
    kind: "phrase",
  },
  {
    id: "l037-001",
    text: "a funny dog",
    level: 37,
    kind: "phrase",
  },
  {
    id: "l037-002",
    text: "my yellow hat",
    level: 37,
    kind: "phrase",
  },
  {
    id: "l037-003",
    text: "the purple cup",
    level: 37,
    kind: "phrase",
  },
  {
    id: "l037-004",
    text: "a happy hen",
    level: 37,
    kind: "phrase",
  },
  {
    id: "l037-005",
    text: "my orange ball",
    level: 37,
    kind: "phrase",
  },
  {
    id: "l037-006",
    text: "the little pig",
    level: 37,
    kind: "phrase",
  },
  {
    id: "l037-007",
    text: "a funny bug",
    level: 37,
    kind: "phrase",
  },
  {
    id: "l037-008",
    text: "my happy pup",
    level: 37,
    kind: "phrase",
  },
  {
    id: "l037-009",
    text: "the yellow sun",
    level: 37,
    kind: "phrase",
  },
  {
    id: "l038-000",
    text: "I see a cat",
    level: 38,
    kind: "phrase",
  },
  {
    id: "l038-001",
    text: "we like the dog",
    level: 38,
    kind: "phrase",
  },
  {
    id: "l038-002",
    text: "you have a hat",
    level: 38,
    kind: "phrase",
  },
  {
    id: "l038-003",
    text: "he has a cup",
    level: 38,
    kind: "phrase",
  },
  {
    id: "l038-004",
    text: "she has a pen",
    level: 38,
    kind: "phrase",
  },
  {
    id: "l038-005",
    text: "I want a book",
    level: 38,
    kind: "phrase",
  },
  {
    id: "l038-006",
    text: "we have a ball",
    level: 38,
    kind: "phrase",
  },
  {
    id: "l038-007",
    text: "you like the sun",
    level: 38,
    kind: "phrase",
  },
  {
    id: "l038-008",
    text: "he likes the pig",
    level: 38,
    kind: "phrase",
  },
  {
    id: "l038-009",
    text: "she likes the hen",
    level: 38,
    kind: "phrase",
  },
  {
    id: "l039-000",
    text: "the cat sat down",
    level: 39,
    kind: "phrase",
  },
  {
    id: "l039-001",
    text: "a dog ran off",
    level: 39,
    kind: "phrase",
  },
  {
    id: "l039-002",
    text: "my hat is red",
    level: 39,
    kind: "phrase",
  },
  {
    id: "l039-003",
    text: "the sun is hot",
    level: 39,
    kind: "phrase",
  },
  {
    id: "l039-004",
    text: "a bug is on it",
    level: 39,
    kind: "phrase",
  },
  {
    id: "l039-005",
    text: "my mom can help",
    level: 39,
    kind: "phrase",
  },
  {
    id: "l039-006",
    text: "the hen is wet",
    level: 39,
    kind: "phrase",
  },
  {
    id: "l039-007",
    text: "a fox is fast",
    level: 39,
    kind: "phrase",
  },
  {
    id: "l039-008",
    text: "my dad is here",
    level: 39,
    kind: "phrase",
  },
  {
    id: "l039-009",
    text: "the pig is big",
    level: 39,
    kind: "phrase",
  },
  {
    id: "l040-000",
    text: "look at the cat",
    level: 40,
    kind: "phrase",
  },
  {
    id: "l040-001",
    text: "come to the van",
    level: 40,
    kind: "phrase",
  },
  {
    id: "l040-002",
    text: "go up the hill",
    level: 40,
    kind: "phrase",
  },
  {
    id: "l040-003",
    text: "sit on the mat",
    level: 40,
    kind: "phrase",
  },
  {
    id: "l040-004",
    text: "run to the shop",
    level: 40,
    kind: "phrase",
  },
  {
    id: "l040-005",
    text: "jump on the bed",
    level: 40,
    kind: "phrase",
  },
  {
    id: "l040-006",
    text: "play in the sun",
    level: 40,
    kind: "phrase",
  },
  {
    id: "l040-007",
    text: "look in the box",
    level: 40,
    kind: "phrase",
  },
  {
    id: "l040-008",
    text: "come and see it",
    level: 40,
    kind: "phrase",
  },
  {
    id: "l040-009",
    text: "go with my mom",
    level: 40,
    kind: "phrase",
  },
  {
    id: "l041-000",
    text: "a cat and a dog",
    level: 41,
    kind: "phrase",
  },
  {
    id: "l041-001",
    text: "the hen and the pig",
    level: 41,
    kind: "phrase",
  },
  {
    id: "l041-002",
    text: "my hat and my cup",
    level: 41,
    kind: "phrase",
  },
  {
    id: "l041-003",
    text: "the sun and the fog",
    level: 41,
    kind: "phrase",
  },
  {
    id: "l041-004",
    text: "a bug and a bee",
    level: 41,
    kind: "phrase",
  },
  {
    id: "l041-005",
    text: "my mom and my dad",
    level: 41,
    kind: "phrase",
  },
  {
    id: "l041-006",
    text: "the box and the lid",
    level: 41,
    kind: "phrase",
  },
  {
    id: "l041-007",
    text: "a fish and a frog",
    level: 41,
    kind: "phrase",
  },
  {
    id: "l041-008",
    text: "my book and my pen",
    level: 41,
    kind: "phrase",
  },
  {
    id: "l041-009",
    text: "the bus and the van",
    level: 41,
    kind: "phrase",
  },
  {
    id: "l042-000",
    text: "I can see it now",
    level: 42,
    kind: "phrase",
  },
  {
    id: "l042-001",
    text: "we can go with you",
    level: 42,
    kind: "phrase",
  },
  {
    id: "l042-002",
    text: "you can sit by me",
    level: 42,
    kind: "phrase",
  },
  {
    id: "l042-003",
    text: "he can run so fast",
    level: 42,
    kind: "phrase",
  },
  {
    id: "l042-004",
    text: "she can hop so high",
    level: 42,
    kind: "phrase",
  },
  {
    id: "l042-005",
    text: "I can help my mom",
    level: 42,
    kind: "phrase",
  },
  {
    id: "l042-006",
    text: "we can play at home",
    level: 42,
    kind: "phrase",
  },
  {
    id: "l042-007",
    text: "you can look at this",
    level: 42,
    kind: "phrase",
  },
  {
    id: "l042-008",
    text: "he can find the cat",
    level: 42,
    kind: "phrase",
  },
  {
    id: "l042-009",
    text: "she can make a cake",
    level: 42,
    kind: "phrase",
  },
  {
    id: "l042-010",
    text: "the big red ball",
    level: 42,
    kind: "phrase",
  },
  {
    id: "l042-011",
    text: "a little tan dog",
    level: 42,
    kind: "phrase",
  },
  {
    id: "l042-012",
    text: "my old yellow hat",
    level: 42,
    kind: "phrase",
  },
  {
    id: "l042-013",
    text: "the hot white sun",
    level: 42,
    kind: "phrase",
  },
  {
    id: "l042-014",
    text: "a funny little bug",
    level: 42,
    kind: "phrase",
  },
  {
    id: "l042-015",
    text: "my new green book",
    level: 42,
    kind: "phrase",
  },
  {
    id: "l042-016",
    text: "the wet brown log",
    level: 42,
    kind: "phrase",
  },
  {
    id: "l042-017",
    text: "a fast black ant",
    level: 42,
    kind: "phrase",
  },
  {
    id: "l042-018",
    text: "my big blue cup",
    level: 42,
    kind: "phrase",
  },
  {
    id: "l042-019",
    text: "the sad little hen",
    level: 42,
    kind: "phrase",
  },
  {
    id: "l043-000",
    text: "up on the hill",
    level: 43,
    kind: "phrase",
  },
  {
    id: "l043-001",
    text: "down in the pond",
    level: 43,
    kind: "phrase",
  },
  {
    id: "l043-002",
    text: "out in the rain",
    level: 43,
    kind: "phrase",
  },
  {
    id: "l043-003",
    text: "back to the barn",
    level: 43,
    kind: "phrase",
  },
  {
    id: "l043-004",
    text: "over the log",
    level: 43,
    kind: "phrase",
  },
  {
    id: "l043-005",
    text: "under the bed",
    level: 43,
    kind: "phrase",
  },
  {
    id: "l043-006",
    text: "into the shop",
    level: 43,
    kind: "phrase",
  },
  {
    id: "l043-007",
    text: "out of the box",
    level: 43,
    kind: "phrase",
  },
  {
    id: "l043-008",
    text: "along the path",
    level: 43,
    kind: "phrase",
  },
  {
    id: "l043-009",
    text: "across the yard",
    level: 43,
    kind: "phrase",
  },
  {
    id: "l044-000",
    text: "let us go now",
    level: 44,
    kind: "phrase",
  },
  {
    id: "l044-001",
    text: "come and see this",
    level: 44,
    kind: "phrase",
  },
  {
    id: "l044-002",
    text: "look at that dog",
    level: 44,
    kind: "phrase",
  },
  {
    id: "l044-003",
    text: "here is my hat",
    level: 44,
    kind: "phrase",
  },
  {
    id: "l044-004",
    text: "this is the sun",
    level: 44,
    kind: "phrase",
  },
  {
    id: "l044-005",
    text: "that is a bug",
    level: 44,
    kind: "phrase",
  },
  {
    id: "l044-006",
    text: "here comes the bus",
    level: 44,
    kind: "phrase",
  },
  {
    id: "l044-007",
    text: "this is my book",
    level: 44,
    kind: "phrase",
  },
  {
    id: "l044-008",
    text: "that is my mom",
    level: 44,
    kind: "phrase",
  },
  {
    id: "l044-009",
    text: "here is a cake",
    level: 44,
    kind: "phrase",
  },
  {
    id: "l045-000",
    text: "the cat is on the mat",
    level: 45,
    kind: "phrase",
  },
  {
    id: "l045-001",
    text: "a dog is in the van",
    level: 45,
    kind: "phrase",
  },
  {
    id: "l045-002",
    text: "my hat is on the bed",
    level: 45,
    kind: "phrase",
  },
  {
    id: "l045-003",
    text: "the sun is in the sky",
    level: 45,
    kind: "phrase",
  },
  {
    id: "l045-004",
    text: "a bug is on the log",
    level: 45,
    kind: "phrase",
  },
  {
    id: "l045-005",
    text: "my cup is on the map",
    level: 45,
    kind: "phrase",
  },
  {
    id: "l045-006",
    text: "the hen is in the nest",
    level: 45,
    kind: "phrase",
  },
  {
    id: "l045-007",
    text: "a fox is in the box",
    level: 45,
    kind: "phrase",
  },
  {
    id: "l045-008",
    text: "my pen is in the bag",
    level: 45,
    kind: "phrase",
  },
  {
    id: "l045-009",
    text: "the pig is in the mud",
    level: 45,
    kind: "phrase",
  },
  {
    id: "l046-000",
    text: "I see the little cat",
    level: 46,
    kind: "phrase",
  },
  {
    id: "l046-001",
    text: "we like the funny dog",
    level: 46,
    kind: "phrase",
  },
  {
    id: "l046-002",
    text: "you have a yellow hat",
    level: 46,
    kind: "phrase",
  },
  {
    id: "l046-003",
    text: "he has a green book",
    level: 46,
    kind: "phrase",
  },
  {
    id: "l046-004",
    text: "she has a red ball",
    level: 46,
    kind: "phrase",
  },
  {
    id: "l046-005",
    text: "I want the blue cup",
    level: 46,
    kind: "phrase",
  },
  {
    id: "l046-006",
    text: "we have a happy pup",
    level: 46,
    kind: "phrase",
  },
  {
    id: "l046-007",
    text: "you like the hot sun",
    level: 46,
    kind: "phrase",
  },
  {
    id: "l046-008",
    text: "he likes the wet frog",
    level: 46,
    kind: "phrase",
  },
  {
    id: "l046-009",
    text: "she likes the tan hen",
    level: 46,
    kind: "phrase",
  },
  {
    id: "l020-010",
    text: "I sat.",
    level: 20,
    kind: "sentence",
  },
  {
    id: "l020-011",
    text: "I ran.",
    level: 20,
    kind: "sentence",
  },
  {
    id: "l021-010",
    text: "We sat.",
    level: 21,
    kind: "sentence",
  },
  {
    id: "l021-011",
    text: "He sat.",
    level: 21,
    kind: "sentence",
  },
  {
    id: "l022-010",
    text: "She sat.",
    level: 22,
    kind: "sentence",
  },
  {
    id: "l022-011",
    text: "I hop.",
    level: 22,
    kind: "sentence",
  },
  {
    id: "l023-010",
    text: "We ran.",
    level: 23,
    kind: "sentence",
  },
  {
    id: "l023-011",
    text: "I see.",
    level: 23,
    kind: "sentence",
  },
  {
    id: "l023-012",
    text: "Look up.",
    level: 23,
    kind: "sentence",
  },
  {
    id: "l024-020",
    text: "Come in.",
    level: 24,
    kind: "sentence",
  },
  {
    id: "l024-021",
    text: "I can.",
    level: 24,
    kind: "sentence",
  },
  {
    id: "l024-022",
    text: "We go.",
    level: 24,
    kind: "sentence",
  },
  {
    id: "l025-010",
    text: "I see it.",
    level: 25,
    kind: "sentence",
  },
  {
    id: "l025-011",
    text: "I like it.",
    level: 25,
    kind: "sentence",
  },
  {
    id: "l025-012",
    text: "We can go.",
    level: 25,
    kind: "sentence",
  },
  {
    id: "l026-010",
    text: "He is up.",
    level: 26,
    kind: "sentence",
  },
  {
    id: "l026-011",
    text: "She is in.",
    level: 26,
    kind: "sentence",
  },
  {
    id: "l026-012",
    text: "The cat sat.",
    level: 26,
    kind: "sentence",
  },
  {
    id: "l026-013",
    text: "The dog ran.",
    level: 26,
    kind: "sentence",
  },
  {
    id: "l027-010",
    text: "A pig sat.",
    level: 27,
    kind: "sentence",
  },
  {
    id: "l027-011",
    text: "I can hop.",
    level: 27,
    kind: "sentence",
  },
  {
    id: "l027-012",
    text: "We can run.",
    level: 27,
    kind: "sentence",
  },
  {
    id: "l027-013",
    text: "Look at me.",
    level: 27,
    kind: "sentence",
  },
  {
    id: "l028-010",
    text: "Come with us.",
    level: 28,
    kind: "sentence",
  },
  {
    id: "l028-011",
    text: "The sun is hot.",
    level: 28,
    kind: "sentence",
  },
  {
    id: "l028-012",
    text: "A bug ran.",
    level: 28,
    kind: "sentence",
  },
  {
    id: "l028-013",
    text: "I see you.",
    level: 28,
    kind: "sentence",
  },
  {
    id: "l029-010",
    text: "We like it.",
    level: 29,
    kind: "sentence",
  },
  {
    id: "l029-011",
    text: "He can hop.",
    level: 29,
    kind: "sentence",
  },
  {
    id: "l029-012",
    text: "She can run.",
    level: 29,
    kind: "sentence",
  },
  {
    id: "l029-013",
    text: "The hen sat.",
    level: 29,
    kind: "sentence",
  },
  {
    id: "l029-014",
    text: "My dog ran.",
    level: 29,
    kind: "sentence",
  },
  {
    id: "l030-010",
    text: "I am in.",
    level: 30,
    kind: "sentence",
  },
  {
    id: "l030-011",
    text: "We are up.",
    level: 30,
    kind: "sentence",
  },
  {
    id: "l030-012",
    text: "The cat is big.",
    level: 30,
    kind: "sentence",
  },
  {
    id: "l030-013",
    text: "A fox ran.",
    level: 30,
    kind: "sentence",
  },
  {
    id: "l030-014",
    text: "I see a cat.",
    level: 30,
    kind: "sentence",
  },
  {
    id: "l031-010",
    text: "We see a dog.",
    level: 31,
    kind: "sentence",
  },
  {
    id: "l031-011",
    text: "The pig is big.",
    level: 31,
    kind: "sentence",
  },
  {
    id: "l031-012",
    text: "My hat is red.",
    level: 31,
    kind: "sentence",
  },
  {
    id: "l031-013",
    text: "The cup is hot.",
    level: 31,
    kind: "sentence",
  },
  {
    id: "l031-014",
    text: "I can see it.",
    level: 31,
    kind: "sentence",
  },
  {
    id: "l032-010",
    text: "We can sit.",
    level: 32,
    kind: "sentence",
  },
  {
    id: "l032-011",
    text: "He can run.",
    level: 32,
    kind: "sentence",
  },
  {
    id: "l032-012",
    text: "She can hop.",
    level: 32,
    kind: "sentence",
  },
  {
    id: "l032-013",
    text: "The dog is wet.",
    level: 32,
    kind: "sentence",
  },
  {
    id: "l032-014",
    text: "A cat sat down.",
    level: 32,
    kind: "sentence",
  },
  {
    id: "l032-015",
    text: "I like the sun.",
    level: 32,
    kind: "sentence",
  },
  {
    id: "l033-020",
    text: "We like the dog.",
    level: 33,
    kind: "sentence",
  },
  {
    id: "l033-021",
    text: "Look at the cat.",
    level: 33,
    kind: "sentence",
  },
  {
    id: "l033-022",
    text: "Come to the van.",
    level: 33,
    kind: "sentence",
  },
  {
    id: "l033-023",
    text: "The hen is wet.",
    level: 33,
    kind: "sentence",
  },
  {
    id: "l033-024",
    text: "My mom can help.",
    level: 33,
    kind: "sentence",
  },
  {
    id: "l033-025",
    text: "The pig is in mud.",
    level: 33,
    kind: "sentence",
  },
  {
    id: "l034-010",
    text: "I see my dad.",
    level: 34,
    kind: "sentence",
  },
  {
    id: "l034-011",
    text: "We can play.",
    level: 34,
    kind: "sentence",
  },
  {
    id: "l034-012",
    text: "He is in the van.",
    level: 34,
    kind: "sentence",
  },
  {
    id: "l034-013",
    text: "She sat on the mat.",
    level: 34,
    kind: "sentence",
  },
  {
    id: "l034-014",
    text: "The sun is up.",
    level: 34,
    kind: "sentence",
  },
  {
    id: "l034-015",
    text: "A bug is on it.",
    level: 34,
    kind: "sentence",
  },
  {
    id: "l035-010",
    text: "I can help.",
    level: 35,
    kind: "sentence",
  },
  {
    id: "l035-011",
    text: "We can see you.",
    level: 35,
    kind: "sentence",
  },
  {
    id: "l035-012",
    text: "The cat sat on the mat.",
    level: 35,
    kind: "sentence",
  },
  {
    id: "l035-013",
    text: "My dog ran to me.",
    level: 35,
    kind: "sentence",
  },
  {
    id: "l035-014",
    text: "The fox is fast.",
    level: 35,
    kind: "sentence",
  },
  {
    id: "l035-015",
    text: "I like my hat.",
    level: 35,
    kind: "sentence",
  },
  {
    id: "l035-016",
    text: "We sat in the sun.",
    level: 35,
    kind: "sentence",
  },
  {
    id: "l036-010",
    text: "He hid in the box.",
    level: 36,
    kind: "sentence",
  },
  {
    id: "l036-011",
    text: "She sat by the bed.",
    level: 36,
    kind: "sentence",
  },
  {
    id: "l036-012",
    text: "The pup is fun.",
    level: 36,
    kind: "sentence",
  },
  {
    id: "l036-013",
    text: "A hen sat in the nest.",
    level: 36,
    kind: "sentence",
  },
  {
    id: "l036-014",
    text: "I see the big dog.",
    level: 36,
    kind: "sentence",
  },
  {
    id: "l036-015",
    text: "We like the red hat.",
    level: 36,
    kind: "sentence",
  },
  {
    id: "l036-016",
    text: "The bus is here.",
    level: 36,
    kind: "sentence",
  },
  {
    id: "l037-010",
    text: "My dad is here.",
    level: 37,
    kind: "sentence",
  },
  {
    id: "l037-011",
    text: "The log is wet.",
    level: 37,
    kind: "sentence",
  },
  {
    id: "l037-012",
    text: "I can run so fast.",
    level: 37,
    kind: "sentence",
  },
  {
    id: "l037-013",
    text: "We can hop so high.",
    level: 37,
    kind: "sentence",
  },
  {
    id: "l037-014",
    text: "The cat is on my bed.",
    level: 37,
    kind: "sentence",
  },
  {
    id: "l037-015",
    text: "A dog ran off.",
    level: 37,
    kind: "sentence",
  },
  {
    id: "l037-016",
    text: "Look in the box.",
    level: 37,
    kind: "sentence",
  },
  {
    id: "l038-010",
    text: "Come and see it.",
    level: 38,
    kind: "sentence",
  },
  {
    id: "l038-011",
    text: "Go with my mom.",
    level: 38,
    kind: "sentence",
  },
  {
    id: "l038-012",
    text: "The sun is in the sky.",
    level: 38,
    kind: "sentence",
  },
  {
    id: "l038-013",
    text: "My pen is in the bag.",
    level: 38,
    kind: "sentence",
  },
  {
    id: "l038-014",
    text: "The pig is in the mud.",
    level: 38,
    kind: "sentence",
  },
  {
    id: "l038-015",
    text: "I want a book.",
    level: 38,
    kind: "sentence",
  },
  {
    id: "l038-016",
    text: "We have a ball.",
    level: 38,
    kind: "sentence",
  },
  {
    id: "l038-017",
    text: "You can sit by me.",
    level: 38,
    kind: "sentence",
  },
  {
    id: "l039-010",
    text: "He can find the cat.",
    level: 39,
    kind: "sentence",
  },
  {
    id: "l039-011",
    text: "She can make a cake.",
    level: 39,
    kind: "sentence",
  },
  {
    id: "l039-012",
    text: "The big dog ran.",
    level: 39,
    kind: "sentence",
  },
  {
    id: "l039-013",
    text: "A little cat sat.",
    level: 39,
    kind: "sentence",
  },
  {
    id: "l039-014",
    text: "My red hat is on the bed.",
    level: 39,
    kind: "sentence",
  },
  {
    id: "l039-015",
    text: "The hot sun is up.",
    level: 39,
    kind: "sentence",
  },
  {
    id: "l039-016",
    text: "I see a big pig.",
    level: 39,
    kind: "sentence",
  },
  {
    id: "l039-017",
    text: "We like the wet frog.",
    level: 39,
    kind: "sentence",
  },
  {
    id: "l040-010",
    text: "The tan hen sat.",
    level: 40,
    kind: "sentence",
  },
  {
    id: "l040-011",
    text: "A fast ant ran.",
    level: 40,
    kind: "sentence",
  },
  {
    id: "l040-012",
    text: "Look at that dog.",
    level: 40,
    kind: "sentence",
  },
  {
    id: "l040-013",
    text: "Here is my hat.",
    level: 40,
    kind: "sentence",
  },
  {
    id: "l040-014",
    text: "This is the sun.",
    level: 40,
    kind: "sentence",
  },
  {
    id: "l040-015",
    text: "That is a bug.",
    level: 40,
    kind: "sentence",
  },
  {
    id: "l040-016",
    text: "Here comes the bus.",
    level: 40,
    kind: "sentence",
  },
  {
    id: "l040-017",
    text: "This is my book.",
    level: 40,
    kind: "sentence",
  },
  {
    id: "l041-010",
    text: "I sat on the mat.",
    level: 41,
    kind: "sentence",
  },
  {
    id: "l041-011",
    text: "We ran to the shop.",
    level: 41,
    kind: "sentence",
  },
  {
    id: "l041-012",
    text: "He sat in the van.",
    level: 41,
    kind: "sentence",
  },
  {
    id: "l041-013",
    text: "She ran up the hill.",
    level: 41,
    kind: "sentence",
  },
  {
    id: "l041-014",
    text: "The cat hid in the box.",
    level: 41,
    kind: "sentence",
  },
  {
    id: "l041-015",
    text: "My pup sat by me.",
    level: 41,
    kind: "sentence",
  },
  {
    id: "l041-016",
    text: "The frog sat on a log.",
    level: 41,
    kind: "sentence",
  },
  {
    id: "l041-017",
    text: "I can see the sun.",
    level: 41,
    kind: "sentence",
  },
  {
    id: "l041-018",
    text: "We can go to bed.",
    level: 41,
    kind: "sentence",
  },
  {
    id: "l042-020",
    text: "The hen sat on an egg.",
    level: 42,
    kind: "sentence",
  },
  {
    id: "l042-021",
    text: "A duck sat in the pond.",
    level: 42,
    kind: "sentence",
  },
  {
    id: "l042-022",
    text: "I like my red cup.",
    level: 42,
    kind: "sentence",
  },
  {
    id: "l042-023",
    text: "We sat by the log.",
    level: 42,
    kind: "sentence",
  },
  {
    id: "l042-024",
    text: "The dog sat with me.",
    level: 42,
    kind: "sentence",
  },
  {
    id: "l042-025",
    text: "A cat ran to dad.",
    level: 42,
    kind: "sentence",
  },
  {
    id: "l042-026",
    text: "I hop to mom.",
    level: 42,
    kind: "sentence",
  },
  {
    id: "l042-027",
    text: "We ran to dad.",
    level: 42,
    kind: "sentence",
  },
  {
    id: "l042-028",
    text: "The cat hid.",
    level: 42,
    kind: "sentence",
  },
  {
    id: "l043-010",
    text: "A dog sat.",
    level: 43,
    kind: "sentence",
  },
  {
    id: "l043-011",
    text: "I see a pig.",
    level: 43,
    kind: "sentence",
  },
  {
    id: "l043-012",
    text: "We see a hen.",
    level: 43,
    kind: "sentence",
  },
  {
    id: "l043-013",
    text: "He sat up.",
    level: 43,
    kind: "sentence",
  },
  {
    id: "l043-014",
    text: "She ran in.",
    level: 43,
    kind: "sentence",
  },
  {
    id: "l043-015",
    text: "The pup sat down.",
    level: 43,
    kind: "sentence",
  },
  {
    id: "l043-016",
    text: "My cat is fat.",
    level: 43,
    kind: "sentence",
  },
  {
    id: "l043-017",
    text: "The bed is soft.",
    level: 43,
    kind: "sentence",
  },
  {
    id: "l043-018",
    text: "A box is big.",
    level: 43,
    kind: "sentence",
  },
  {
    id: "l044-010",
    text: "I sat by mom.",
    level: 44,
    kind: "sentence",
  },
  {
    id: "l044-011",
    text: "We ran with dad.",
    level: 44,
    kind: "sentence",
  },
  {
    id: "l044-012",
    text: "The frog can hop.",
    level: 44,
    kind: "sentence",
  },
  {
    id: "l044-013",
    text: "A duck can sit.",
    level: 44,
    kind: "sentence",
  },
  {
    id: "l044-014",
    text: "Look at my cup.",
    level: 44,
    kind: "sentence",
  },
  {
    id: "l044-015",
    text: "Come and sit.",
    level: 44,
    kind: "sentence",
  },
  {
    id: "l044-016",
    text: "The van is tan.",
    level: 44,
    kind: "sentence",
  },
  {
    id: "l044-017",
    text: "My book is old.",
    level: 44,
    kind: "sentence",
  },
  {
    id: "l044-018",
    text: "I like the pig.",
    level: 44,
    kind: "sentence",
  },
  {
    id: "l044-019",
    text: "We like the hen.",
    level: 44,
    kind: "sentence",
  },
  {
    id: "l045-010",
    text: "He sat on a log.",
    level: 45,
    kind: "sentence",
  },
  {
    id: "l045-011",
    text: "She hid in a box.",
    level: 45,
    kind: "sentence",
  },
  {
    id: "l045-012",
    text: "The ant is little.",
    level: 45,
    kind: "sentence",
  },
  {
    id: "l045-013",
    text: "A moth sat still.",
    level: 45,
    kind: "sentence",
  },
  {
    id: "l045-014",
    text: "I can sit now.",
    level: 45,
    kind: "sentence",
  },
  {
    id: "l045-015",
    text: "We can go now.",
    level: 45,
    kind: "sentence",
  },
  {
    id: "l045-016",
    text: "The cat can nap.",
    level: 45,
    kind: "sentence",
  },
  {
    id: "l045-017",
    text: "My dog can sit.",
    level: 45,
    kind: "sentence",
  },
  {
    id: "l045-018",
    text: "I see a red hat.",
    level: 45,
    kind: "sentence",
  },
  {
    id: "l045-019",
    text: "We see a tan pup.",
    level: 45,
    kind: "sentence",
  },
  {
    id: "l046-010",
    text: "The sun went down.",
    level: 46,
    kind: "sentence",
  },
  {
    id: "l046-011",
    text: "A bee sat on me.",
    level: 46,
    kind: "sentence",
  },
  {
    id: "l046-012",
    text: "Look at my dog.",
    level: 46,
    kind: "sentence",
  },
  {
    id: "l046-013",
    text: "Here is a cup.",
    level: 46,
    kind: "sentence",
  },
  {
    id: "l046-014",
    text: "This is my hat.",
    level: 46,
    kind: "sentence",
  },
  {
    id: "l046-015",
    text: "That is my dad.",
    level: 46,
    kind: "sentence",
  },
  {
    id: "l046-016",
    text: "I ran to the hill.",
    level: 46,
    kind: "sentence",
  },
  {
    id: "l046-017",
    text: "We sat in the van.",
    level: 46,
    kind: "sentence",
  },
  {
    id: "l046-018",
    text: "The pig sat in mud.",
    level: 46,
    kind: "sentence",
  },
  {
    id: "l046-019",
    text: "My hen sat in hay.",
    level: 46,
    kind: "sentence",
  },
  {
    id: "l047-000",
    text: "Sam saw the big cat ran to the mat with Sam.",
    level: 47,
    kind: "sentence",
  },
  {
    id: "l047-001",
    text: "Mia saw the big cat ran to the mat with Sam.",
    level: 47,
    kind: "sentence",
  },
  {
    id: "l047-002",
    text: "Ben saw the big cat ran to the mat with Sam.",
    level: 47,
    kind: "sentence",
  },
  {
    id: "l047-003",
    text: "Ava saw the big cat ran to the mat with Sam.",
    level: 47,
    kind: "sentence",
  },
  {
    id: "l047-004",
    text: "Leo saw the big cat ran to the mat with Sam.",
    level: 47,
    kind: "sentence",
  },
  {
    id: "l047-005",
    text: "Zoe saw the big cat ran to the mat with Sam.",
    level: 47,
    kind: "sentence",
  },
  {
    id: "l047-006",
    text: "Max saw the big cat ran to the mat with Sam.",
    level: 47,
    kind: "sentence",
  },
  {
    id: "l047-007",
    text: "Ivy saw the big cat ran to the mat with Sam.",
    level: 47,
    kind: "sentence",
  },
  {
    id: "l047-008",
    text: "Eli saw the big cat ran to the mat with Sam.",
    level: 47,
    kind: "sentence",
  },
  {
    id: "l047-009",
    text: "Ana saw the big cat ran to the mat with Sam.",
    level: 47,
    kind: "sentence",
  },
  {
    id: "l047-010",
    text: "Ned saw the big cat ran to the mat with Sam.",
    level: 47,
    kind: "sentence",
  },
  {
    id: "l047-011",
    text: "Kim saw the big cat ran to the mat with Sam.",
    level: 47,
    kind: "sentence",
  },
  {
    id: "l048-000",
    text: "Owen saw the big cat ran to the mat with Sam.",
    level: 48,
    kind: "sentence",
  },
  {
    id: "l048-001",
    text: "Lila saw the big cat ran to the mat with Sam.",
    level: 48,
    kind: "sentence",
  },
  {
    id: "l048-002",
    text: "Tess saw the big cat ran to the mat with Sam.",
    level: 48,
    kind: "sentence",
  },
  {
    id: "l048-003",
    text: "Nia saw the big cat ran to the mat with Sam.",
    level: 48,
    kind: "sentence",
  },
  {
    id: "l048-004",
    text: "Cal saw the big cat ran to the mat with Sam.",
    level: 48,
    kind: "sentence",
  },
  {
    id: "l048-005",
    text: "Jude saw the big cat ran to the mat with Sam.",
    level: 48,
    kind: "sentence",
  },
  {
    id: "l048-006",
    text: "Remy saw the big cat ran to the mat with Sam.",
    level: 48,
    kind: "sentence",
  },
  {
    id: "l048-007",
    text: "Pia saw the big cat ran to the mat with Sam.",
    level: 48,
    kind: "sentence",
  },
  {
    id: "l048-008",
    text: "Sam saw the big dog ran to the mat with Sam.",
    level: 48,
    kind: "sentence",
  },
  {
    id: "l048-009",
    text: "Mia saw the big dog ran to the mat with Sam.",
    level: 48,
    kind: "sentence",
  },
  {
    id: "l048-010",
    text: "Ben saw the big dog ran to the mat with Sam.",
    level: 48,
    kind: "sentence",
  },
  {
    id: "l048-011",
    text: "Ava saw the big dog ran to the mat with Sam.",
    level: 48,
    kind: "sentence",
  },
  {
    id: "l049-000",
    text: "Leo saw the big dog ran to the mat with Sam.",
    level: 49,
    kind: "sentence",
  },
  {
    id: "l049-001",
    text: "Zoe saw the big dog ran to the mat with Sam.",
    level: 49,
    kind: "sentence",
  },
  {
    id: "l049-002",
    text: "Max saw the big dog ran to the mat with Sam.",
    level: 49,
    kind: "sentence",
  },
  {
    id: "l049-003",
    text: "Ivy saw the big dog ran to the mat with Sam.",
    level: 49,
    kind: "sentence",
  },
  {
    id: "l049-004",
    text: "Eli saw the big dog ran to the mat with Sam.",
    level: 49,
    kind: "sentence",
  },
  {
    id: "l049-005",
    text: "Ana saw the big dog ran to the mat with Sam.",
    level: 49,
    kind: "sentence",
  },
  {
    id: "l049-006",
    text: "Ned saw the big dog ran to the mat with Sam.",
    level: 49,
    kind: "sentence",
  },
  {
    id: "l049-007",
    text: "Kim saw the big dog ran to the mat with Sam.",
    level: 49,
    kind: "sentence",
  },
  {
    id: "l049-008",
    text: "Owen saw the big dog ran to the mat with Sam.",
    level: 49,
    kind: "sentence",
  },
  {
    id: "l049-009",
    text: "Lila saw the big dog ran to the mat with Sam.",
    level: 49,
    kind: "sentence",
  },
  {
    id: "l049-010",
    text: "Tess saw the big dog ran to the mat with Sam.",
    level: 49,
    kind: "sentence",
  },
  {
    id: "l049-011",
    text: "Nia saw the big dog ran to the mat with Sam.",
    level: 49,
    kind: "sentence",
  },
  {
    id: "l050-000",
    text: "Cal saw the big dog ran to the mat with Sam.",
    level: 50,
    kind: "sentence",
  },
  {
    id: "l050-001",
    text: "Jude saw the big dog ran to the mat with Sam.",
    level: 50,
    kind: "sentence",
  },
  {
    id: "l050-002",
    text: "Remy saw the big dog ran to the mat with Sam.",
    level: 50,
    kind: "sentence",
  },
  {
    id: "l050-003",
    text: "Pia saw the big dog ran to the mat with Sam.",
    level: 50,
    kind: "sentence",
  },
  {
    id: "l050-004",
    text: "Sam saw the big hen ran to the mat with Sam.",
    level: 50,
    kind: "sentence",
  },
  {
    id: "l050-005",
    text: "Mia saw the big hen ran to the mat with Sam.",
    level: 50,
    kind: "sentence",
  },
  {
    id: "l050-006",
    text: "Ben saw the big hen ran to the mat with Sam.",
    level: 50,
    kind: "sentence",
  },
  {
    id: "l050-007",
    text: "Ava saw the big hen ran to the mat with Sam.",
    level: 50,
    kind: "sentence",
  },
  {
    id: "l050-008",
    text: "Leo saw the big hen ran to the mat with Sam.",
    level: 50,
    kind: "sentence",
  },
  {
    id: "l050-009",
    text: "Zoe saw the big hen ran to the mat with Sam.",
    level: 50,
    kind: "sentence",
  },
  {
    id: "l050-010",
    text: "Max saw the big hen ran to the mat with Sam.",
    level: 50,
    kind: "sentence",
  },
  {
    id: "l050-011",
    text: "Ivy saw the big hen ran to the mat with Sam.",
    level: 50,
    kind: "sentence",
  },
  {
    id: "l051-000",
    text: "Eli saw the big hen ran to the mat with Sam.",
    level: 51,
    kind: "sentence",
  },
  {
    id: "l051-001",
    text: "Ana saw the big hen ran to the mat with Sam.",
    level: 51,
    kind: "sentence",
  },
  {
    id: "l051-002",
    text: "Ned saw the big hen ran to the mat with Sam.",
    level: 51,
    kind: "sentence",
  },
  {
    id: "l051-003",
    text: "Kim saw the big hen ran to the mat with Sam.",
    level: 51,
    kind: "sentence",
  },
  {
    id: "l051-004",
    text: "Owen saw the big hen ran to the mat with Sam.",
    level: 51,
    kind: "sentence",
  },
  {
    id: "l051-005",
    text: "Lila saw the big hen ran to the mat with Sam.",
    level: 51,
    kind: "sentence",
  },
  {
    id: "l051-006",
    text: "Tess saw the big hen ran to the mat with Sam.",
    level: 51,
    kind: "sentence",
  },
  {
    id: "l051-007",
    text: "Nia saw the big hen ran to the mat with Sam.",
    level: 51,
    kind: "sentence",
  },
  {
    id: "l051-008",
    text: "Cal saw the big hen ran to the mat with Sam.",
    level: 51,
    kind: "sentence",
  },
  {
    id: "l051-009",
    text: "Jude saw the big hen ran to the mat with Sam.",
    level: 51,
    kind: "sentence",
  },
  {
    id: "l051-010",
    text: "Remy saw the big hen ran to the mat with Sam.",
    level: 51,
    kind: "sentence",
  },
  {
    id: "l051-011",
    text: "Pia saw the big hen ran to the mat with Sam.",
    level: 51,
    kind: "sentence",
  },
  {
    id: "l051-012",
    text: "Sam saw the big pig ran to the mat with Sam.",
    level: 51,
    kind: "sentence",
  },
  {
    id: "l051-013",
    text: "Mia saw the big pig ran to the mat with Sam.",
    level: 51,
    kind: "sentence",
  },
  {
    id: "l051-014",
    text: "Ben saw the big pig ran to the mat with Sam.",
    level: 51,
    kind: "sentence",
  },
  {
    id: "l051-015",
    text: "Ava saw the big pig ran to the mat with Sam.",
    level: 51,
    kind: "sentence",
  },
  {
    id: "l051-016",
    text: "Leo saw the big pig ran to the mat with Sam.",
    level: 51,
    kind: "sentence",
  },
  {
    id: "l051-017",
    text: "Zoe saw the big pig ran to the mat with Sam.",
    level: 51,
    kind: "sentence",
  },
  {
    id: "l051-018",
    text: "Max saw the big pig ran to the mat with Sam.",
    level: 51,
    kind: "sentence",
  },
  {
    id: "l051-019",
    text: "Ivy saw the big pig ran to the mat with Sam.",
    level: 51,
    kind: "sentence",
  },
  {
    id: "l051-020",
    text: "Eli saw the big pig ran to the mat with Sam.",
    level: 51,
    kind: "sentence",
  },
  {
    id: "l051-021",
    text: "Ana saw the big pig ran to the mat with Sam.",
    level: 51,
    kind: "sentence",
  },
  {
    id: "l051-022",
    text: "Ned saw the big pig ran to the mat with Sam.",
    level: 51,
    kind: "sentence",
  },
  {
    id: "l051-023",
    text: "Kim saw the big pig ran to the mat with Sam.",
    level: 51,
    kind: "sentence",
  },
  {
    id: "l052-000",
    text: "Owen saw the big pig ran to the mat with Sam.",
    level: 52,
    kind: "sentence",
  },
  {
    id: "l052-001",
    text: "Lila saw the big pig ran to the mat with Sam.",
    level: 52,
    kind: "sentence",
  },
  {
    id: "l052-002",
    text: "Tess saw the big pig ran to the mat with Sam.",
    level: 52,
    kind: "sentence",
  },
  {
    id: "l052-003",
    text: "Nia saw the big pig ran to the mat with Sam.",
    level: 52,
    kind: "sentence",
  },
  {
    id: "l052-004",
    text: "Cal saw the big pig ran to the mat with Sam.",
    level: 52,
    kind: "sentence",
  },
  {
    id: "l052-005",
    text: "Jude saw the big pig ran to the mat with Sam.",
    level: 52,
    kind: "sentence",
  },
  {
    id: "l052-006",
    text: "Remy saw the big pig ran to the mat with Sam.",
    level: 52,
    kind: "sentence",
  },
  {
    id: "l052-007",
    text: "Pia saw the big pig ran to the mat with Sam.",
    level: 52,
    kind: "sentence",
  },
  {
    id: "l052-008",
    text: "Sam saw the big fox ran to the mat with Sam.",
    level: 52,
    kind: "sentence",
  },
  {
    id: "l052-009",
    text: "Mia saw the big fox ran to the mat with Sam.",
    level: 52,
    kind: "sentence",
  },
  {
    id: "l052-010",
    text: "Ben saw the big fox ran to the mat with Sam.",
    level: 52,
    kind: "sentence",
  },
  {
    id: "l052-011",
    text: "Ava saw the big fox ran to the mat with Sam.",
    level: 52,
    kind: "sentence",
  },
  {
    id: "l053-000",
    text: "Leo saw the big fox ran to the mat with Sam.",
    level: 53,
    kind: "sentence",
  },
  {
    id: "l053-001",
    text: "Zoe saw the big fox ran to the mat with Sam.",
    level: 53,
    kind: "sentence",
  },
  {
    id: "l053-002",
    text: "Max saw the big fox ran to the mat with Sam.",
    level: 53,
    kind: "sentence",
  },
  {
    id: "l053-003",
    text: "Ivy saw the big fox ran to the mat with Sam.",
    level: 53,
    kind: "sentence",
  },
  {
    id: "l053-004",
    text: "Eli saw the big fox ran to the mat with Sam.",
    level: 53,
    kind: "sentence",
  },
  {
    id: "l053-005",
    text: "Ana saw the big fox ran to the mat with Sam.",
    level: 53,
    kind: "sentence",
  },
  {
    id: "l053-006",
    text: "Ned saw the big fox ran to the mat with Sam.",
    level: 53,
    kind: "sentence",
  },
  {
    id: "l053-007",
    text: "Kim saw the big fox ran to the mat with Sam.",
    level: 53,
    kind: "sentence",
  },
  {
    id: "l053-008",
    text: "Owen saw the big fox ran to the mat with Sam.",
    level: 53,
    kind: "sentence",
  },
  {
    id: "l053-009",
    text: "Lila saw the big fox ran to the mat with Sam.",
    level: 53,
    kind: "sentence",
  },
  {
    id: "l053-010",
    text: "Tess saw the big fox ran to the mat with Sam.",
    level: 53,
    kind: "sentence",
  },
  {
    id: "l053-011",
    text: "Nia saw the big fox ran to the mat with Sam.",
    level: 53,
    kind: "sentence",
  },
  {
    id: "l054-000",
    text: "Cal saw the big fox ran to the mat with Sam.",
    level: 54,
    kind: "sentence",
  },
  {
    id: "l054-001",
    text: "Jude saw the big fox ran to the mat with Sam.",
    level: 54,
    kind: "sentence",
  },
  {
    id: "l054-002",
    text: "Remy saw the big fox ran to the mat with Sam.",
    level: 54,
    kind: "sentence",
  },
  {
    id: "l054-003",
    text: "Pia saw the big fox ran to the mat with Sam.",
    level: 54,
    kind: "sentence",
  },
  {
    id: "l054-004",
    text: "Sam saw the big bug ran to the mat with Sam.",
    level: 54,
    kind: "sentence",
  },
  {
    id: "l054-005",
    text: "Mia saw the big bug ran to the mat with Sam.",
    level: 54,
    kind: "sentence",
  },
  {
    id: "l054-006",
    text: "Ben saw the big bug ran to the mat with Sam.",
    level: 54,
    kind: "sentence",
  },
  {
    id: "l054-007",
    text: "Ava saw the big bug ran to the mat with Sam.",
    level: 54,
    kind: "sentence",
  },
  {
    id: "l054-008",
    text: "Leo saw the big bug ran to the mat with Sam.",
    level: 54,
    kind: "sentence",
  },
  {
    id: "l054-009",
    text: "Zoe saw the big bug ran to the mat with Sam.",
    level: 54,
    kind: "sentence",
  },
  {
    id: "l054-010",
    text: "Max saw the big bug ran to the mat with Sam.",
    level: 54,
    kind: "sentence",
  },
  {
    id: "l054-011",
    text: "Ivy saw the big bug ran to the mat with Sam.",
    level: 54,
    kind: "sentence",
  },
  {
    id: "l055-000",
    text: "Eli saw the big bug ran to the mat with Sam.",
    level: 55,
    kind: "sentence",
  },
  {
    id: "l055-001",
    text: "Ana saw the big bug ran to the mat with Sam.",
    level: 55,
    kind: "sentence",
  },
  {
    id: "l055-002",
    text: "Ned saw the big bug ran to the mat with Sam.",
    level: 55,
    kind: "sentence",
  },
  {
    id: "l055-003",
    text: "Kim saw the big bug ran to the mat with Sam.",
    level: 55,
    kind: "sentence",
  },
  {
    id: "l055-004",
    text: "Owen saw the big bug ran to the mat with Sam.",
    level: 55,
    kind: "sentence",
  },
  {
    id: "l055-005",
    text: "Lila saw the big bug ran to the mat with Sam.",
    level: 55,
    kind: "sentence",
  },
  {
    id: "l055-006",
    text: "Tess saw the big bug ran to the mat with Sam.",
    level: 55,
    kind: "sentence",
  },
  {
    id: "l055-007",
    text: "Nia saw the big bug ran to the mat with Sam.",
    level: 55,
    kind: "sentence",
  },
  {
    id: "l055-008",
    text: "Cal saw the big bug ran to the mat with Sam.",
    level: 55,
    kind: "sentence",
  },
  {
    id: "l055-009",
    text: "Jude saw the big bug ran to the mat with Sam.",
    level: 55,
    kind: "sentence",
  },
  {
    id: "l055-010",
    text: "Remy saw the big bug ran to the mat with Sam.",
    level: 55,
    kind: "sentence",
  },
  {
    id: "l055-011",
    text: "Pia saw the big bug ran to the mat with Sam.",
    level: 55,
    kind: "sentence",
  },
  {
    id: "l056-000",
    text: "Sam saw the big bee ran to the mat with Sam.",
    level: 56,
    kind: "sentence",
  },
  {
    id: "l056-001",
    text: "Mia saw the big bee ran to the mat with Sam.",
    level: 56,
    kind: "sentence",
  },
  {
    id: "l056-002",
    text: "Ben saw the big bee ran to the mat with Sam.",
    level: 56,
    kind: "sentence",
  },
  {
    id: "l056-003",
    text: "Ava saw the big bee ran to the mat with Sam.",
    level: 56,
    kind: "sentence",
  },
  {
    id: "l056-004",
    text: "Leo saw the big bee ran to the mat with Sam.",
    level: 56,
    kind: "sentence",
  },
  {
    id: "l056-005",
    text: "Zoe saw the big bee ran to the mat with Sam.",
    level: 56,
    kind: "sentence",
  },
  {
    id: "l056-006",
    text: "Max saw the big bee ran to the mat with Sam.",
    level: 56,
    kind: "sentence",
  },
  {
    id: "l056-007",
    text: "Ivy saw the big bee ran to the mat with Sam.",
    level: 56,
    kind: "sentence",
  },
  {
    id: "l056-008",
    text: "Eli saw the big bee ran to the mat with Sam.",
    level: 56,
    kind: "sentence",
  },
  {
    id: "l056-009",
    text: "Ana saw the big bee ran to the mat with Sam.",
    level: 56,
    kind: "sentence",
  },
  {
    id: "l056-010",
    text: "Ned saw the big bee ran to the mat with Sam.",
    level: 56,
    kind: "sentence",
  },
  {
    id: "l056-011",
    text: "Kim saw the big bee ran to the mat with Sam.",
    level: 56,
    kind: "sentence",
  },
  {
    id: "l057-000",
    text: "Owen saw the big bee ran to the mat with Sam.",
    level: 57,
    kind: "sentence",
  },
  {
    id: "l057-001",
    text: "Lila saw the big bee ran to the mat with Sam.",
    level: 57,
    kind: "sentence",
  },
  {
    id: "l057-002",
    text: "Tess saw the big bee ran to the mat with Sam.",
    level: 57,
    kind: "sentence",
  },
  {
    id: "l057-003",
    text: "Nia saw the big bee ran to the mat with Sam.",
    level: 57,
    kind: "sentence",
  },
  {
    id: "l057-004",
    text: "Cal saw the big bee ran to the mat with Sam.",
    level: 57,
    kind: "sentence",
  },
  {
    id: "l057-005",
    text: "Jude saw the big bee ran to the mat with Sam.",
    level: 57,
    kind: "sentence",
  },
  {
    id: "l057-006",
    text: "Remy saw the big bee ran to the mat with Sam.",
    level: 57,
    kind: "sentence",
  },
  {
    id: "l057-007",
    text: "Pia saw the big bee ran to the mat with Sam.",
    level: 57,
    kind: "sentence",
  },
  {
    id: "l057-008",
    text: "Sam saw the big duck ran to the mat with Sam.",
    level: 57,
    kind: "sentence",
  },
  {
    id: "l057-009",
    text: "Mia saw the big duck ran to the mat with Sam.",
    level: 57,
    kind: "sentence",
  },
  {
    id: "l057-010",
    text: "Ben saw the big duck ran to the mat with Sam.",
    level: 57,
    kind: "sentence",
  },
  {
    id: "l057-011",
    text: "Ava saw the big duck ran to the mat with Sam.",
    level: 57,
    kind: "sentence",
  },
  {
    id: "l058-000",
    text: "Leo saw the big duck ran to the mat with Sam.",
    level: 58,
    kind: "sentence",
  },
  {
    id: "l058-001",
    text: "Zoe saw the big duck ran to the mat with Sam.",
    level: 58,
    kind: "sentence",
  },
  {
    id: "l058-002",
    text: "Max saw the big duck ran to the mat with Sam.",
    level: 58,
    kind: "sentence",
  },
  {
    id: "l058-003",
    text: "Ivy saw the big duck ran to the mat with Sam.",
    level: 58,
    kind: "sentence",
  },
  {
    id: "l058-004",
    text: "Eli saw the big duck ran to the mat with Sam.",
    level: 58,
    kind: "sentence",
  },
  {
    id: "l058-005",
    text: "Ana saw the big duck ran to the mat with Sam.",
    level: 58,
    kind: "sentence",
  },
  {
    id: "l058-006",
    text: "Ned saw the big duck ran to the mat with Sam.",
    level: 58,
    kind: "sentence",
  },
  {
    id: "l058-007",
    text: "Kim saw the big duck ran to the mat with Sam.",
    level: 58,
    kind: "sentence",
  },
  {
    id: "l058-008",
    text: "Owen saw the big duck ran to the mat with Sam.",
    level: 58,
    kind: "sentence",
  },
  {
    id: "l058-009",
    text: "Lila saw the big duck ran to the mat with Sam.",
    level: 58,
    kind: "sentence",
  },
  {
    id: "l058-010",
    text: "Tess saw the big duck ran to the mat with Sam.",
    level: 58,
    kind: "sentence",
  },
  {
    id: "l058-011",
    text: "Nia saw the big duck ran to the mat with Sam.",
    level: 58,
    kind: "sentence",
  },
  {
    id: "l059-000",
    text: "Cal saw the big duck ran to the mat with Sam.",
    level: 59,
    kind: "sentence",
  },
  {
    id: "l059-001",
    text: "Jude saw the big duck ran to the mat with Sam.",
    level: 59,
    kind: "sentence",
  },
  {
    id: "l059-002",
    text: "Remy saw the big duck ran to the mat with Sam.",
    level: 59,
    kind: "sentence",
  },
  {
    id: "l059-003",
    text: "Pia saw the big duck ran to the mat with Sam.",
    level: 59,
    kind: "sentence",
  },
  {
    id: "l059-004",
    text: "Sam saw the big frog ran to the mat with Sam.",
    level: 59,
    kind: "sentence",
  },
  {
    id: "l059-005",
    text: "Mia saw the big frog ran to the mat with Sam.",
    level: 59,
    kind: "sentence",
  },
  {
    id: "l059-006",
    text: "Ben saw the big frog ran to the mat with Sam.",
    level: 59,
    kind: "sentence",
  },
  {
    id: "l059-007",
    text: "Ava saw the big frog ran to the mat with Sam.",
    level: 59,
    kind: "sentence",
  },
  {
    id: "l059-008",
    text: "Leo saw the big frog ran to the mat with Sam.",
    level: 59,
    kind: "sentence",
  },
  {
    id: "l059-009",
    text: "Zoe saw the big frog ran to the mat with Sam.",
    level: 59,
    kind: "sentence",
  },
  {
    id: "l059-010",
    text: "Max saw the big frog ran to the mat with Sam.",
    level: 59,
    kind: "sentence",
  },
  {
    id: "l059-011",
    text: "Ivy saw the big frog ran to the mat with Sam.",
    level: 59,
    kind: "sentence",
  },
  {
    id: "l060-000",
    text: "Eli saw the big frog as it ran down the path to the mat with Sam.",
    level: 60,
    kind: "sentence",
  },
  {
    id: "l060-001",
    text: "Ana saw the big frog as it ran down the path to the mat with Sam.",
    level: 60,
    kind: "sentence",
  },
  {
    id: "l060-002",
    text: "Ned saw the big frog as it ran down the path to the mat with Sam.",
    level: 60,
    kind: "sentence",
  },
  {
    id: "l060-003",
    text: "Kim saw the big frog as it ran down the path to the mat with Sam.",
    level: 60,
    kind: "sentence",
  },
  {
    id: "l060-004",
    text: "Owen saw the big frog as it ran down the path to the mat with Sam.",
    level: 60,
    kind: "sentence",
  },
  {
    id: "l060-005",
    text: "Lila saw the big frog as it ran down the path to the mat with Sam.",
    level: 60,
    kind: "sentence",
  },
  {
    id: "l060-006",
    text: "Tess saw the big frog as it ran down the path to the mat with Sam.",
    level: 60,
    kind: "sentence",
  },
  {
    id: "l060-007",
    text: "Nia saw the big frog as it ran down the path to the mat with Sam.",
    level: 60,
    kind: "sentence",
  },
  {
    id: "l060-008",
    text: "Cal saw the big frog as it ran down the path to the mat with Sam.",
    level: 60,
    kind: "sentence",
  },
  {
    id: "l060-009",
    text: "Jude saw the big frog as it ran down the path to the mat with Sam.",
    level: 60,
    kind: "sentence",
  },
  {
    id: "l060-010",
    text: "Remy saw the big frog as it ran down the path to the mat with Sam.",
    level: 60,
    kind: "sentence",
  },
  {
    id: "l060-011",
    text: "Pia saw the big frog as it ran down the path to the mat with Sam.",
    level: 60,
    kind: "sentence",
  },
  {
    id: "l060-012",
    text: "Sam saw the big bird as it ran down the path to the mat with Sam.",
    level: 60,
    kind: "sentence",
  },
  {
    id: "l060-013",
    text: "Mia saw the big bird as it ran down the path to the mat with Sam.",
    level: 60,
    kind: "sentence",
  },
  {
    id: "l060-014",
    text: "Ben saw the big bird as it ran down the path to the mat with Sam.",
    level: 60,
    kind: "sentence",
  },
  {
    id: "l060-015",
    text: "Ava saw the big bird as it ran down the path to the mat with Sam.",
    level: 60,
    kind: "sentence",
  },
  {
    id: "l060-016",
    text: "Leo saw the big bird as it ran down the path to the mat with Sam.",
    level: 60,
    kind: "sentence",
  },
  {
    id: "l060-017",
    text: "Zoe saw the big bird as it ran down the path to the mat with Sam.",
    level: 60,
    kind: "sentence",
  },
  {
    id: "l060-018",
    text: "Max saw the big bird as it ran down the path to the mat with Sam.",
    level: 60,
    kind: "sentence",
  },
  {
    id: "l060-019",
    text: "Ivy saw the big bird as it ran down the path to the mat with Sam.",
    level: 60,
    kind: "sentence",
  },
  {
    id: "l060-020",
    text: "Eli saw the big bird as it ran down the path to the mat with Sam.",
    level: 60,
    kind: "sentence",
  },
  {
    id: "l060-021",
    text: "Ana saw the big bird as it ran down the path to the mat with Sam.",
    level: 60,
    kind: "sentence",
  },
  {
    id: "l060-022",
    text: "Ned saw the big bird as it ran down the path to the mat with Sam.",
    level: 60,
    kind: "sentence",
  },
  {
    id: "l060-023",
    text: "Kim saw the big bird as it ran down the path to the mat with Sam.",
    level: 60,
    kind: "sentence",
  },
  {
    id: "l061-000",
    text: "Owen saw the big bird as it ran down the path to the mat with Sam.",
    level: 61,
    kind: "sentence",
  },
  {
    id: "l061-001",
    text: "Lila saw the big bird as it ran down the path to the mat with Sam.",
    level: 61,
    kind: "sentence",
  },
  {
    id: "l061-002",
    text: "Tess saw the big bird as it ran down the path to the mat with Sam.",
    level: 61,
    kind: "sentence",
  },
  {
    id: "l061-003",
    text: "Nia saw the big bird as it ran down the path to the mat with Sam.",
    level: 61,
    kind: "sentence",
  },
  {
    id: "l061-004",
    text: "Cal saw the big bird as it ran down the path to the mat with Sam.",
    level: 61,
    kind: "sentence",
  },
  {
    id: "l061-005",
    text: "Jude saw the big bird as it ran down the path to the mat with Sam.",
    level: 61,
    kind: "sentence",
  },
  {
    id: "l061-006",
    text: "Remy saw the big bird as it ran down the path to the mat with Sam.",
    level: 61,
    kind: "sentence",
  },
  {
    id: "l061-007",
    text: "Pia saw the big bird as it ran down the path to the mat with Sam.",
    level: 61,
    kind: "sentence",
  },
  {
    id: "l061-008",
    text: "Sam saw the big pup as it ran down the path to the mat with Sam.",
    level: 61,
    kind: "sentence",
  },
  {
    id: "l061-009",
    text: "Mia saw the big pup as it ran down the path to the mat with Sam.",
    level: 61,
    kind: "sentence",
  },
  {
    id: "l061-010",
    text: "Ben saw the big pup as it ran down the path to the mat with Sam.",
    level: 61,
    kind: "sentence",
  },
  {
    id: "l061-011",
    text: "Ava saw the big pup as it ran down the path to the mat with Sam.",
    level: 61,
    kind: "sentence",
  },
  {
    id: "l062-000",
    text: "Leo saw the big pup as it ran down the path to the mat with Sam.",
    level: 62,
    kind: "sentence",
  },
  {
    id: "l062-001",
    text: "Zoe saw the big pup as it ran down the path to the mat with Sam.",
    level: 62,
    kind: "sentence",
  },
  {
    id: "l062-002",
    text: "Max saw the big pup as it ran down the path to the mat with Sam.",
    level: 62,
    kind: "sentence",
  },
  {
    id: "l062-003",
    text: "Ivy saw the big pup as it ran down the path to the mat with Sam.",
    level: 62,
    kind: "sentence",
  },
  {
    id: "l062-004",
    text: "Eli saw the big pup as it ran down the path to the mat with Sam.",
    level: 62,
    kind: "sentence",
  },
  {
    id: "l062-005",
    text: "Ana saw the big pup as it ran down the path to the mat with Sam.",
    level: 62,
    kind: "sentence",
  },
  {
    id: "l062-006",
    text: "Ned saw the big pup as it ran down the path to the mat with Sam.",
    level: 62,
    kind: "sentence",
  },
  {
    id: "l062-007",
    text: "Kim saw the big pup as it ran down the path to the mat with Sam.",
    level: 62,
    kind: "sentence",
  },
  {
    id: "l062-008",
    text: "Owen saw the big pup as it ran down the path to the mat with Sam.",
    level: 62,
    kind: "sentence",
  },
  {
    id: "l062-009",
    text: "Lila saw the big pup as it ran down the path to the mat with Sam.",
    level: 62,
    kind: "sentence",
  },
  {
    id: "l062-010",
    text: "Tess saw the big pup as it ran down the path to the mat with Sam.",
    level: 62,
    kind: "sentence",
  },
  {
    id: "l062-011",
    text: "Nia saw the big pup as it ran down the path to the mat with Sam.",
    level: 62,
    kind: "sentence",
  },
  {
    id: "l063-000",
    text: "Cal saw the big pup as it ran down the path to the mat with Sam.",
    level: 63,
    kind: "sentence",
  },
  {
    id: "l063-001",
    text: "Jude saw the big pup as it ran down the path to the mat with Sam.",
    level: 63,
    kind: "sentence",
  },
  {
    id: "l063-002",
    text: "Remy saw the big pup as it ran down the path to the mat with Sam.",
    level: 63,
    kind: "sentence",
  },
  {
    id: "l063-003",
    text: "Pia saw the big pup as it ran down the path to the mat with Sam.",
    level: 63,
    kind: "sentence",
  },
  {
    id: "l063-004",
    text: "Sam saw the big ant as it ran down the path to the mat with Sam.",
    level: 63,
    kind: "sentence",
  },
  {
    id: "l063-005",
    text: "Mia saw the big ant as it ran down the path to the mat with Sam.",
    level: 63,
    kind: "sentence",
  },
  {
    id: "l063-006",
    text: "Ben saw the big ant as it ran down the path to the mat with Sam.",
    level: 63,
    kind: "sentence",
  },
  {
    id: "l063-007",
    text: "Ava saw the big ant as it ran down the path to the mat with Sam.",
    level: 63,
    kind: "sentence",
  },
  {
    id: "l063-008",
    text: "Leo saw the big ant as it ran down the path to the mat with Sam.",
    level: 63,
    kind: "sentence",
  },
  {
    id: "l063-009",
    text: "Zoe saw the big ant as it ran down the path to the mat with Sam.",
    level: 63,
    kind: "sentence",
  },
  {
    id: "l063-010",
    text: "Max saw the big ant as it ran down the path to the mat with Sam.",
    level: 63,
    kind: "sentence",
  },
  {
    id: "l063-011",
    text: "Ivy saw the big ant as it ran down the path to the mat with Sam.",
    level: 63,
    kind: "sentence",
  },
  {
    id: "l064-000",
    text: "Eli saw the big ant as it ran down the path to the mat with Sam.",
    level: 64,
    kind: "sentence",
  },
  {
    id: "l064-001",
    text: "Ana saw the big ant as it ran down the path to the mat with Sam.",
    level: 64,
    kind: "sentence",
  },
  {
    id: "l064-002",
    text: "Ned saw the big ant as it ran down the path to the mat with Sam.",
    level: 64,
    kind: "sentence",
  },
  {
    id: "l064-003",
    text: "Kim saw the big ant as it ran down the path to the mat with Sam.",
    level: 64,
    kind: "sentence",
  },
  {
    id: "l064-004",
    text: "Owen saw the big ant as it ran down the path to the mat with Sam.",
    level: 64,
    kind: "sentence",
  },
  {
    id: "l064-005",
    text: "Lila saw the big ant as it ran down the path to the mat with Sam.",
    level: 64,
    kind: "sentence",
  },
  {
    id: "l064-006",
    text: "Tess saw the big ant as it ran down the path to the mat with Sam.",
    level: 64,
    kind: "sentence",
  },
  {
    id: "l064-007",
    text: "Nia saw the big ant as it ran down the path to the mat with Sam.",
    level: 64,
    kind: "sentence",
  },
  {
    id: "l064-008",
    text: "Cal saw the big ant as it ran down the path to the mat with Sam.",
    level: 64,
    kind: "sentence",
  },
  {
    id: "l064-009",
    text: "Jude saw the big ant as it ran down the path to the mat with Sam.",
    level: 64,
    kind: "sentence",
  },
  {
    id: "l064-010",
    text: "Remy saw the big ant as it ran down the path to the mat with Sam.",
    level: 64,
    kind: "sentence",
  },
  {
    id: "l064-011",
    text: "Pia saw the big ant as it ran down the path to the mat with Sam.",
    level: 64,
    kind: "sentence",
  },
  {
    id: "l065-000",
    text: "Sam saw the big fish as it ran down the path to the mat with Sam.",
    level: 65,
    kind: "sentence",
  },
  {
    id: "l065-001",
    text: "Mia saw the big fish as it ran down the path to the mat with Sam.",
    level: 65,
    kind: "sentence",
  },
  {
    id: "l065-002",
    text: "Ben saw the big fish as it ran down the path to the mat with Sam.",
    level: 65,
    kind: "sentence",
  },
  {
    id: "l065-003",
    text: "Ava saw the big fish as it ran down the path to the mat with Sam.",
    level: 65,
    kind: "sentence",
  },
  {
    id: "l065-004",
    text: "Leo saw the big fish as it ran down the path to the mat with Sam.",
    level: 65,
    kind: "sentence",
  },
  {
    id: "l065-005",
    text: "Zoe saw the big fish as it ran down the path to the mat with Sam.",
    level: 65,
    kind: "sentence",
  },
  {
    id: "l065-006",
    text: "Max saw the big fish as it ran down the path to the mat with Sam.",
    level: 65,
    kind: "sentence",
  },
  {
    id: "l065-007",
    text: "Ivy saw the big fish as it ran down the path to the mat with Sam.",
    level: 65,
    kind: "sentence",
  },
  {
    id: "l065-008",
    text: "Eli saw the big fish as it ran down the path to the mat with Sam.",
    level: 65,
    kind: "sentence",
  },
  {
    id: "l065-009",
    text: "Ana saw the big fish as it ran down the path to the mat with Sam.",
    level: 65,
    kind: "sentence",
  },
  {
    id: "l065-010",
    text: "Ned saw the big fish as it ran down the path to the mat with Sam.",
    level: 65,
    kind: "sentence",
  },
  {
    id: "l065-011",
    text: "Kim saw the big fish as it ran down the path to the mat with Sam.",
    level: 65,
    kind: "sentence",
  },
  {
    id: "l066-000",
    text: "Owen saw the big fish as it ran down the path to the mat with Sam.",
    level: 66,
    kind: "sentence",
  },
  {
    id: "l066-001",
    text: "Lila saw the big fish as it ran down the path to the mat with Sam.",
    level: 66,
    kind: "sentence",
  },
  {
    id: "l066-002",
    text: "Tess saw the big fish as it ran down the path to the mat with Sam.",
    level: 66,
    kind: "sentence",
  },
  {
    id: "l066-003",
    text: "Nia saw the big fish as it ran down the path to the mat with Sam.",
    level: 66,
    kind: "sentence",
  },
  {
    id: "l066-004",
    text: "Cal saw the big fish as it ran down the path to the mat with Sam.",
    level: 66,
    kind: "sentence",
  },
  {
    id: "l066-005",
    text: "Jude saw the big fish as it ran down the path to the mat with Sam.",
    level: 66,
    kind: "sentence",
  },
  {
    id: "l066-006",
    text: "Remy saw the big fish as it ran down the path to the mat with Sam.",
    level: 66,
    kind: "sentence",
  },
  {
    id: "l066-007",
    text: "Pia saw the big fish as it ran down the path to the mat with Sam.",
    level: 66,
    kind: "sentence",
  },
  {
    id: "l066-008",
    text: "Sam saw the big bat as it ran down the path to the mat with Sam.",
    level: 66,
    kind: "sentence",
  },
  {
    id: "l066-009",
    text: "Mia saw the big bat as it ran down the path to the mat with Sam.",
    level: 66,
    kind: "sentence",
  },
  {
    id: "l066-010",
    text: "Ben saw the big bat as it ran down the path to the mat with Sam.",
    level: 66,
    kind: "sentence",
  },
  {
    id: "l066-011",
    text: "Ava saw the big bat as it ran down the path to the mat with Sam.",
    level: 66,
    kind: "sentence",
  },
  {
    id: "l067-000",
    text: "Leo saw the big bat as it ran down the path to the mat with Sam.",
    level: 67,
    kind: "sentence",
  },
  {
    id: "l067-001",
    text: "Zoe saw the big bat as it ran down the path to the mat with Sam.",
    level: 67,
    kind: "sentence",
  },
  {
    id: "l067-002",
    text: "Max saw the big bat as it ran down the path to the mat with Sam.",
    level: 67,
    kind: "sentence",
  },
  {
    id: "l067-003",
    text: "Ivy saw the big bat as it ran down the path to the mat with Sam.",
    level: 67,
    kind: "sentence",
  },
  {
    id: "l067-004",
    text: "Eli saw the big bat as it ran down the path to the mat with Sam.",
    level: 67,
    kind: "sentence",
  },
  {
    id: "l067-005",
    text: "Ana saw the big bat as it ran down the path to the mat with Sam.",
    level: 67,
    kind: "sentence",
  },
  {
    id: "l067-006",
    text: "Ned saw the big bat as it ran down the path to the mat with Sam.",
    level: 67,
    kind: "sentence",
  },
  {
    id: "l067-007",
    text: "Kim saw the big bat as it ran down the path to the mat with Sam.",
    level: 67,
    kind: "sentence",
  },
  {
    id: "l067-008",
    text: "Owen saw the big bat as it ran down the path to the mat with Sam.",
    level: 67,
    kind: "sentence",
  },
  {
    id: "l067-009",
    text: "Lila saw the big bat as it ran down the path to the mat with Sam.",
    level: 67,
    kind: "sentence",
  },
  {
    id: "l067-010",
    text: "Tess saw the big bat as it ran down the path to the mat with Sam.",
    level: 67,
    kind: "sentence",
  },
  {
    id: "l067-011",
    text: "Nia saw the big bat as it ran down the path to the mat with Sam.",
    level: 67,
    kind: "sentence",
  },
  {
    id: "l068-000",
    text: "After a long walk, Cal and Sam found the big bat resting beside the mat.",
    level: 68,
    kind: "sentence",
  },
  {
    id: "l068-001",
    text: "After a long walk, Jude and Sam found the big bat resting beside the mat.",
    level: 68,
    kind: "sentence",
  },
  {
    id: "l068-002",
    text: "After a long walk, Remy and Sam found the big bat resting beside the mat.",
    level: 68,
    kind: "sentence",
  },
  {
    id: "l068-003",
    text: "After a long walk, Pia and Sam found the big bat resting beside the mat.",
    level: 68,
    kind: "sentence",
  },
  {
    id: "l068-004",
    text: "After a long walk, Sam and Sam found the big goat resting beside the mat.",
    level: 68,
    kind: "sentence",
  },
  {
    id: "l068-005",
    text: "After a long walk, Mia and Sam found the big goat resting beside the mat.",
    level: 68,
    kind: "sentence",
  },
  {
    id: "l068-006",
    text: "After a long walk, Ben and Sam found the big goat resting beside the mat.",
    level: 68,
    kind: "sentence",
  },
  {
    id: "l068-007",
    text: "After a long walk, Ava and Sam found the big goat resting beside the mat.",
    level: 68,
    kind: "sentence",
  },
  {
    id: "l068-008",
    text: "After a long walk, Leo and Sam found the big goat resting beside the mat.",
    level: 68,
    kind: "sentence",
  },
  {
    id: "l068-009",
    text: "After a long walk, Zoe and Sam found the big goat resting beside the mat.",
    level: 68,
    kind: "sentence",
  },
  {
    id: "l068-010",
    text: "After a long walk, Max and Sam found the big goat resting beside the mat.",
    level: 68,
    kind: "sentence",
  },
  {
    id: "l068-011",
    text: "After a long walk, Ivy and Sam found the big goat resting beside the mat.",
    level: 68,
    kind: "sentence",
  },
  {
    id: "l069-000",
    text: "After a long walk, Eli and Sam found the big goat resting beside the mat.",
    level: 69,
    kind: "sentence",
  },
  {
    id: "l069-001",
    text: "After a long walk, Ana and Sam found the big goat resting beside the mat.",
    level: 69,
    kind: "sentence",
  },
  {
    id: "l069-002",
    text: "After a long walk, Ned and Sam found the big goat resting beside the mat.",
    level: 69,
    kind: "sentence",
  },
  {
    id: "l069-003",
    text: "After a long walk, Kim and Sam found the big goat resting beside the mat.",
    level: 69,
    kind: "sentence",
  },
  {
    id: "l069-004",
    text: "After a long walk, Owen and Sam found the big goat resting beside the mat.",
    level: 69,
    kind: "sentence",
  },
  {
    id: "l069-005",
    text: "After a long walk, Lila and Sam found the big goat resting beside the mat.",
    level: 69,
    kind: "sentence",
  },
  {
    id: "l069-006",
    text: "After a long walk, Tess and Sam found the big goat resting beside the mat.",
    level: 69,
    kind: "sentence",
  },
  {
    id: "l069-007",
    text: "After a long walk, Nia and Sam found the big goat resting beside the mat.",
    level: 69,
    kind: "sentence",
  },
  {
    id: "l069-008",
    text: "After a long walk, Cal and Sam found the big goat resting beside the mat.",
    level: 69,
    kind: "sentence",
  },
  {
    id: "l069-009",
    text: "After a long walk, Jude and Sam found the big goat resting beside the mat.",
    level: 69,
    kind: "sentence",
  },
  {
    id: "l069-010",
    text: "After a long walk, Remy and Sam found the big goat resting beside the mat.",
    level: 69,
    kind: "sentence",
  },
  {
    id: "l069-011",
    text: "After a long walk, Pia and Sam found the big goat resting beside the mat.",
    level: 69,
    kind: "sentence",
  },
  {
    id: "l069-012",
    text: "After a long walk, Sam and Sam found the big lamb resting beside the mat.",
    level: 69,
    kind: "sentence",
  },
  {
    id: "l069-013",
    text: "After a long walk, Mia and Sam found the big lamb resting beside the mat.",
    level: 69,
    kind: "sentence",
  },
  {
    id: "l069-014",
    text: "After a long walk, Ben and Sam found the big lamb resting beside the mat.",
    level: 69,
    kind: "sentence",
  },
  {
    id: "l069-015",
    text: "After a long walk, Ava and Sam found the big lamb resting beside the mat.",
    level: 69,
    kind: "sentence",
  },
  {
    id: "l069-016",
    text: "After a long walk, Leo and Sam found the big lamb resting beside the mat.",
    level: 69,
    kind: "sentence",
  },
  {
    id: "l069-017",
    text: "After a long walk, Zoe and Sam found the big lamb resting beside the mat.",
    level: 69,
    kind: "sentence",
  },
  {
    id: "l069-018",
    text: "After a long walk, Max and Sam found the big lamb resting beside the mat.",
    level: 69,
    kind: "sentence",
  },
  {
    id: "l069-019",
    text: "After a long walk, Ivy and Sam found the big lamb resting beside the mat.",
    level: 69,
    kind: "sentence",
  },
  {
    id: "l069-020",
    text: "After a long walk, Eli and Sam found the big lamb resting beside the mat.",
    level: 69,
    kind: "sentence",
  },
  {
    id: "l069-021",
    text: "After a long walk, Ana and Sam found the big lamb resting beside the mat.",
    level: 69,
    kind: "sentence",
  },
  {
    id: "l069-022",
    text: "After a long walk, Ned and Sam found the big lamb resting beside the mat.",
    level: 69,
    kind: "sentence",
  },
  {
    id: "l069-023",
    text: "After a long walk, Kim and Sam found the big lamb resting beside the mat.",
    level: 69,
    kind: "sentence",
  },
  {
    id: "l070-000",
    text: "After a long walk, Owen and Sam found the big lamb resting beside the mat.",
    level: 70,
    kind: "sentence",
  },
  {
    id: "l070-001",
    text: "After a long walk, Lila and Sam found the big lamb resting beside the mat.",
    level: 70,
    kind: "sentence",
  },
  {
    id: "l070-002",
    text: "After a long walk, Tess and Sam found the big lamb resting beside the mat.",
    level: 70,
    kind: "sentence",
  },
  {
    id: "l070-003",
    text: "After a long walk, Nia and Sam found the big lamb resting beside the mat.",
    level: 70,
    kind: "sentence",
  },
  {
    id: "l070-004",
    text: "After a long walk, Cal and Sam found the big lamb resting beside the mat.",
    level: 70,
    kind: "sentence",
  },
  {
    id: "l070-005",
    text: "After a long walk, Jude and Sam found the big lamb resting beside the mat.",
    level: 70,
    kind: "sentence",
  },
  {
    id: "l070-006",
    text: "After a long walk, Remy and Sam found the big lamb resting beside the mat.",
    level: 70,
    kind: "sentence",
  },
  {
    id: "l070-007",
    text: "After a long walk, Pia and Sam found the big lamb resting beside the mat.",
    level: 70,
    kind: "sentence",
  },
  {
    id: "l070-008",
    text: "After a long walk, Sam and Sam found the big cub resting beside the mat.",
    level: 70,
    kind: "sentence",
  },
  {
    id: "l070-009",
    text: "After a long walk, Mia and Sam found the big cub resting beside the mat.",
    level: 70,
    kind: "sentence",
  },
  {
    id: "l070-010",
    text: "After a long walk, Ben and Sam found the big cub resting beside the mat.",
    level: 70,
    kind: "sentence",
  },
  {
    id: "l070-011",
    text: "After a long walk, Ava and Sam found the big cub resting beside the mat.",
    level: 70,
    kind: "sentence",
  },
  {
    id: "l071-000",
    text: "After a long walk, Leo and Sam found the big cub resting beside the mat.",
    level: 71,
    kind: "sentence",
  },
  {
    id: "l071-001",
    text: "After a long walk, Zoe and Sam found the big cub resting beside the mat.",
    level: 71,
    kind: "sentence",
  },
  {
    id: "l071-002",
    text: "After a long walk, Max and Sam found the big cub resting beside the mat.",
    level: 71,
    kind: "sentence",
  },
  {
    id: "l071-003",
    text: "After a long walk, Ivy and Sam found the big cub resting beside the mat.",
    level: 71,
    kind: "sentence",
  },
  {
    id: "l071-004",
    text: "After a long walk, Eli and Sam found the big cub resting beside the mat.",
    level: 71,
    kind: "sentence",
  },
  {
    id: "l071-005",
    text: "After a long walk, Ana and Sam found the big cub resting beside the mat.",
    level: 71,
    kind: "sentence",
  },
  {
    id: "l071-006",
    text: "After a long walk, Ned and Sam found the big cub resting beside the mat.",
    level: 71,
    kind: "sentence",
  },
  {
    id: "l071-007",
    text: "After a long walk, Kim and Sam found the big cub resting beside the mat.",
    level: 71,
    kind: "sentence",
  },
  {
    id: "l071-008",
    text: "After a long walk, Owen and Sam found the big cub resting beside the mat.",
    level: 71,
    kind: "sentence",
  },
  {
    id: "l071-009",
    text: "After a long walk, Lila and Sam found the big cub resting beside the mat.",
    level: 71,
    kind: "sentence",
  },
  {
    id: "l071-010",
    text: "After a long walk, Tess and Sam found the big cub resting beside the mat.",
    level: 71,
    kind: "sentence",
  },
  {
    id: "l071-011",
    text: "After a long walk, Nia and Sam found the big cub resting beside the mat.",
    level: 71,
    kind: "sentence",
  },
  {
    id: "l072-000",
    text: "After a long walk, Cal and Sam found the big cub resting beside the mat.",
    level: 72,
    kind: "sentence",
  },
  {
    id: "l072-001",
    text: "After a long walk, Jude and Sam found the big cub resting beside the mat.",
    level: 72,
    kind: "sentence",
  },
  {
    id: "l072-002",
    text: "After a long walk, Remy and Sam found the big cub resting beside the mat.",
    level: 72,
    kind: "sentence",
  },
  {
    id: "l072-003",
    text: "After a long walk, Pia and Sam found the big cub resting beside the mat.",
    level: 72,
    kind: "sentence",
  },
  {
    id: "l072-004",
    text: "After a long walk, Sam and Sam found the big colt resting beside the mat.",
    level: 72,
    kind: "sentence",
  },
  {
    id: "l072-005",
    text: "After a long walk, Mia and Sam found the big colt resting beside the mat.",
    level: 72,
    kind: "sentence",
  },
  {
    id: "l072-006",
    text: "After a long walk, Ben and Sam found the big colt resting beside the mat.",
    level: 72,
    kind: "sentence",
  },
  {
    id: "l072-007",
    text: "After a long walk, Ava and Sam found the big colt resting beside the mat.",
    level: 72,
    kind: "sentence",
  },
  {
    id: "l072-008",
    text: "After a long walk, Leo and Sam found the big colt resting beside the mat.",
    level: 72,
    kind: "sentence",
  },
  {
    id: "l072-009",
    text: "After a long walk, Zoe and Sam found the big colt resting beside the mat.",
    level: 72,
    kind: "sentence",
  },
  {
    id: "l072-010",
    text: "After a long walk, Max and Sam found the big colt resting beside the mat.",
    level: 72,
    kind: "sentence",
  },
  {
    id: "l072-011",
    text: "After a long walk, Ivy and Sam found the big colt resting beside the mat.",
    level: 72,
    kind: "sentence",
  },
  {
    id: "l073-000",
    text: "After a long walk, Eli and Sam found the big colt resting beside the mat.",
    level: 73,
    kind: "sentence",
  },
  {
    id: "l073-001",
    text: "After a long walk, Ana and Sam found the big colt resting beside the mat.",
    level: 73,
    kind: "sentence",
  },
  {
    id: "l073-002",
    text: "After a long walk, Ned and Sam found the big colt resting beside the mat.",
    level: 73,
    kind: "sentence",
  },
  {
    id: "l073-003",
    text: "After a long walk, Kim and Sam found the big colt resting beside the mat.",
    level: 73,
    kind: "sentence",
  },
  {
    id: "l073-004",
    text: "After a long walk, Owen and Sam found the big colt resting beside the mat.",
    level: 73,
    kind: "sentence",
  },
  {
    id: "l073-005",
    text: "After a long walk, Lila and Sam found the big colt resting beside the mat.",
    level: 73,
    kind: "sentence",
  },
  {
    id: "l073-006",
    text: "After a long walk, Tess and Sam found the big colt resting beside the mat.",
    level: 73,
    kind: "sentence",
  },
  {
    id: "l073-007",
    text: "After a long walk, Nia and Sam found the big colt resting beside the mat.",
    level: 73,
    kind: "sentence",
  },
  {
    id: "l073-008",
    text: "After a long walk, Cal and Sam found the big colt resting beside the mat.",
    level: 73,
    kind: "sentence",
  },
  {
    id: "l073-009",
    text: "After a long walk, Jude and Sam found the big colt resting beside the mat.",
    level: 73,
    kind: "sentence",
  },
  {
    id: "l073-010",
    text: "After a long walk, Remy and Sam found the big colt resting beside the mat.",
    level: 73,
    kind: "sentence",
  },
  {
    id: "l073-011",
    text: "After a long walk, Pia and Sam found the big colt resting beside the mat.",
    level: 73,
    kind: "sentence",
  },
  {
    id: "l074-000",
    text: "Tess has a big cat. The cat ran to the mat. Ava saw the cat too.",
    level: 74,
    kind: "book",
  },
  {
    id: "l074-001",
    text: "Rain fell on the mat. Kim and Leo ran inside. They sat by the cat.",
    level: 74,
    kind: "book",
  },
  {
    id: "l074-002",
    text: "Eli went to help Zoe. Zoe had a big job at the mat. They picked up the cat.",
    level: 74,
    kind: "book",
  },
  {
    id: "l074-003",
    text: "Zoe looked up at the stars. Max sat on the mat. The night was big.",
    level: 74,
    kind: "book",
  },
  {
    id: "l074-004",
    text: "Ben went to the mat. Ivy came too. They got a cat.",
    level: 74,
    kind: "book",
  },
  {
    id: "l074-005",
    text: "Pia and Ivy made a fort. They used a cat and a dog. The fort was by the mat.",
    level: 74,
    kind: "book",
  },
  {
    id: "l074-006",
    text: "Cal came to the mat. The water was big. Eli was on the other side.",
    level: 74,
    kind: "book",
  },
  {
    id: "l074-007",
    text: "Lila got a letter. It was from Ana. The letter said to come to the mat.",
    level: 74,
    kind: "book",
  },
  {
    id: "l074-008",
    text: "Ned dug in the mat. Ned helped. They found a cat.",
    level: 74,
    kind: "book",
  },
  {
    id: "l074-009",
    text: "Ivy went to a new mat. Kim went too. It was big and big.",
    level: 74,
    kind: "book",
  },
  {
    id: "l074-010",
    text: "Leo got in the boat. Owen got in too. The mat was big.",
    level: 74,
    kind: "book",
  },
  {
    id: "l074-011",
    text: "Mia and Lila were lost. The mat looked the same each way. They sat by a cat.",
    level: 74,
    kind: "book",
  },
  {
    id: "l075-000",
    text: "Ana has a big cat. The cat ran to the mat. Tess saw the cat too.",
    level: 75,
    kind: "book",
  },
  {
    id: "l075-001",
    text: "Rain fell on the mat. Max and Nia ran inside. They sat by the cat.",
    level: 75,
    kind: "book",
  },
  {
    id: "l075-002",
    text: "Ava went to help Cal. Cal had a big job at the mat. They picked up the cat.",
    level: 75,
    kind: "book",
  },
  {
    id: "l075-003",
    text: "Sam looked up at the stars. Jude sat on the mat. The night was big.",
    level: 75,
    kind: "book",
  },
  {
    id: "l075-004",
    text: "Jude went to the mat. Jude came too. They got a cat.",
    level: 75,
    kind: "book",
  },
  {
    id: "l075-005",
    text: "Tess and Remy made a fort. They used a cat and a dog. The fort was by the mat.",
    level: 75,
    kind: "book",
  },
  {
    id: "l075-006",
    text: "Kim came to the mat. The water was big. Pia was on the other side.",
    level: 75,
    kind: "book",
  },
  {
    id: "l075-007",
    text: "Eli got a letter. It was from Sam. The letter said to come to the mat.",
    level: 75,
    kind: "book",
  },
  {
    id: "l075-008",
    text: "Zoe dug in the mat. Mia helped. They found a cat.",
    level: 75,
    kind: "book",
  },
  {
    id: "l075-009",
    text: "Ben went to a new mat. Ben went too. It was big and big.",
    level: 75,
    kind: "book",
  },
  {
    id: "l075-010",
    text: "Pia got in the boat. Ben got in too. The mat was big.",
    level: 75,
    kind: "book",
  },
  {
    id: "l075-011",
    text: "Cal and Ava were lost. The mat looked the same each way. They sat by a cat.",
    level: 75,
    kind: "book",
  },
  {
    id: "l076-000",
    text: "Leo has a big cat. The cat ran to the mat. Zoe saw the cat too.",
    level: 76,
    kind: "book",
  },
  {
    id: "l076-001",
    text: "Rain fell on the mat. Mia and Max ran inside. They sat by the cat.",
    level: 76,
    kind: "book",
  },
  {
    id: "l076-002",
    text: "Remy went to help Max. Max had a big job at the mat. They picked up the cat.",
    level: 76,
    kind: "book",
  },
  {
    id: "l076-003",
    text: "Nia looked up at the stars. Ivy sat on the mat. The night was big.",
    level: 76,
    kind: "book",
  },
  {
    id: "l076-004",
    text: "Owen went to the mat. Eli came too. They got a cat.",
    level: 76,
    kind: "book",
  },
  {
    id: "l076-005",
    text: "Ana and Ana made a fort. They used a cat and a dog. The fort was by the mat.",
    level: 76,
    kind: "book",
  },
  {
    id: "l076-006",
    text: "Max came to the mat. The water was big. Ned was on the other side.",
    level: 76,
    kind: "book",
  },
  {
    id: "l076-007",
    text: "Ava got a letter. It was from Kim. The letter said to come to the mat.",
    level: 76,
    kind: "book",
  },
  {
    id: "l076-008",
    text: "Sam dug in the mat. Owen helped. They found a cat.",
    level: 76,
    kind: "book",
  },
  {
    id: "l076-009",
    text: "Jude went to a new mat. Owen went too. It was big and big.",
    level: 76,
    kind: "book",
  },
  {
    id: "l076-010",
    text: "Tess got in the boat. Lila got in too. The mat was big.",
    level: 76,
    kind: "book",
  },
  {
    id: "l076-011",
    text: "Kim and Tess were lost. The mat looked the same each way. They sat by a cat.",
    level: 76,
    kind: "book",
  },
  {
    id: "l077-000",
    text: "Pia has a big cat. The cat ran to the mat. Nia saw the cat too. Pia and Nia ran after it.",
    level: 77,
    kind: "book",
  },
  {
    id: "l077-001",
    text: "Rain fell on the mat. Cal and Cal ran inside. They sat by the cat. The rain was loud.",
    level: 77,
    kind: "book",
  },
  {
    id: "l077-002",
    text: "Lila went to help Jude. Jude had a big job at the mat. They picked up the cat. Then they picked up the dog.",
    level: 77,
    kind: "book",
  },
  {
    id: "l077-003",
    text: "Ned looked up at the stars. Remy sat on the mat. The night was big. They saw a cat.",
    level: 77,
    kind: "book",
  },
  {
    id: "l077-004",
    text: "Ivy went to the mat. Pia came too. They got a cat. They got a dog.",
    level: 77,
    kind: "book",
  },
  {
    id: "l077-005",
    text: "Leo and Sam made a fort. They used a cat and a dog. The fort was by the mat. It was big and small.",
    level: 77,
    kind: "book",
  },
  {
    id: "l077-006",
    text: "Mia came to the mat. The water was big. Mia was on the other side. They saw a cat.",
    level: 77,
    kind: "book",
  },
  {
    id: "l077-007",
    text: "Remy got a letter. It was from Mia. The letter said to come to the mat. Remy put on a big hat.",
    level: 77,
    kind: "book",
  },
  {
    id: "l077-008",
    text: "Nia dug in the mat. Ben helped. They found a cat. Then they found a dog.",
    level: 77,
    kind: "book",
  },
  {
    id: "l077-009",
    text: "Owen went to a new mat. Ava went too. It was big and big. They saw a cat.",
    level: 77,
    kind: "book",
  },
  {
    id: "l077-010",
    text: "Ana got in the boat. Leo got in too. The mat was big. They saw a cat.",
    level: 77,
    kind: "book",
  },
  {
    id: "l077-011",
    text: "Max and Zoe were lost. The mat looked the same each way. They sat by a cat. Max did not cry.",
    level: 77,
    kind: "book",
  },
  {
    id: "l078-000",
    text: "Tess has a big cat. The cat ran to the mat. Max saw the cat too. Tess and Max ran after it.",
    level: 78,
    kind: "book",
  },
  {
    id: "l078-001",
    text: "Rain fell on the mat. Kim and Ivy ran inside. They sat by the cat. The rain was loud.",
    level: 78,
    kind: "book",
  },
  {
    id: "l078-002",
    text: "Eli went to help Eli. Eli had a big job at the mat. They picked up the cat. Then they picked up the dog.",
    level: 78,
    kind: "book",
  },
  {
    id: "l078-003",
    text: "Zoe looked up at the stars. Ana sat on the mat. The night was big. They saw a cat.",
    level: 78,
    kind: "book",
  },
  {
    id: "l078-004",
    text: "Ben went to the mat. Ned came too. They got a cat. They got a dog.",
    level: 78,
    kind: "book",
  },
  {
    id: "l078-005",
    text: "Pia and Ned made a fort. They used a cat and a dog. The fort was by the mat. It was big and small.",
    level: 78,
    kind: "book",
  },
  {
    id: "l078-006",
    text: "Cal came to the mat. The water was big. Kim was on the other side. They saw a cat.",
    level: 78,
    kind: "book",
  },
  {
    id: "l078-007",
    text: "Lila got a letter. It was from Owen. The letter said to come to the mat. Lila put on a big hat.",
    level: 78,
    kind: "book",
  },
  {
    id: "l078-008",
    text: "Ned dug in the mat. Lila helped. They found a cat. Then they found a dog.",
    level: 78,
    kind: "book",
  },
  {
    id: "l078-009",
    text: "Ivy went to a new mat. Tess went too. It was big and big. They saw a cat.",
    level: 78,
    kind: "book",
  },
  {
    id: "l078-010",
    text: "Leo got in the boat. Nia got in too. The mat was big. They saw a cat.",
    level: 78,
    kind: "book",
  },
  {
    id: "l078-011",
    text: "Mia and Cal were lost. The mat looked the same each way. They sat by a cat. Mia did not cry.",
    level: 78,
    kind: "book",
  },
  {
    id: "l079-000",
    text: "Ana has a big cat. The cat ran to the mat. Jude saw the cat too. Ana and Jude ran after it.",
    level: 79,
    kind: "book",
  },
  {
    id: "l079-001",
    text: "Rain fell on the mat. Max and Remy ran inside. They sat by the cat. The rain was loud.",
    level: 79,
    kind: "book",
  },
  {
    id: "l079-002",
    text: "Ava went to help Pia. Pia had a big job at the mat. They picked up the cat. Then they picked up the dog.",
    level: 79,
    kind: "book",
  },
  {
    id: "l079-003",
    text: "Sam looked up at the stars. Sam sat on the mat. The night was big. They saw a cat.",
    level: 79,
    kind: "book",
  },
  {
    id: "l079-004",
    text: "Jude went to the mat. Sam came too. They got a cat. They got a dog.",
    level: 79,
    kind: "book",
  },
  {
    id: "l079-005",
    text: "Tess and Mia made a fort. They used a cat and a dog. The fort was by the mat. It was big and small.",
    level: 79,
    kind: "book",
  },
  {
    id: "l079-006",
    text: "Kim came to the mat. The water was big. Ben was on the other side. They saw a cat.",
    level: 79,
    kind: "book",
  },
  {
    id: "l079-007",
    text: "Eli got a letter. It was from Ava. The letter said to come to the mat. Eli put on a big hat.",
    level: 79,
    kind: "book",
  },
  {
    id: "l079-008",
    text: "Zoe dug in the mat. Leo helped. They found a cat. Then they found a dog.",
    level: 79,
    kind: "book",
  },
  {
    id: "l079-009",
    text: "Ben went to a new mat. Zoe went too. It was big and big. They saw a cat.",
    level: 79,
    kind: "book",
  },
  {
    id: "l079-010",
    text: "Pia got in the boat. Zoe got in too. The mat was big. They saw a cat.",
    level: 79,
    kind: "book",
  },
  {
    id: "l079-011",
    text: "Cal and Max were lost. The mat looked the same each way. They sat by a cat. Cal did not cry.",
    level: 79,
    kind: "book",
  },
  {
    id: "l080-000",
    text: "Leo could not find the gentle kitten after lunch. Eli said they should look near the garden. They walked together and called its name. A pony hopped across the path and made them stop. Then Eli heard a small sound behind a bench.",
    level: 80,
    kind: "book",
  },
  {
    id: "l080-001",
    text: "A noisy rain began while Mia and Ana were still in the garden. They hurried under the roof and shook water from their coats. Mia found a gentle towel and a kettle for tea. Ana watched the kitten curl up on a dry chair. Thunder made the windows tremble, but they stayed calm.",
    level: 80,
    kind: "book",
  },
  {
    id: "l080-002",
    text: "Ana needed help at the garden, so Remy came after school. Boxes, tools, and a gentle kitten were scattered across the floor. They made a plan before they lifted anything heavy. Remy carried the smaller things while Ana held the door. A clever pony kept getting under their feet.",
    level: 80,
    kind: "book",
  },
  {
    id: "l080-003",
    text: "Nia and Ned went out to the garden after supper. The sky was clear, and the first stars were already out. A gentle wind moved the grass but did not feel cold. They named the bright points they already knew. A kitten rustled in the dark and then grew still.",
    level: 80,
    kind: "book",
  },
  {
    id: "l080-004",
    text: "Owen and Kim walked to the garden with a list and a bag. The market was busy, and the air smelled like bread and oranges. They found the gentle kitten first, just as the list said. Kim kept the coins and counted twice before paying. A tiny pony sat in a crate and made them both smile.",
    level: 80,
    kind: "book",
  },
  {
    id: "l080-005",
    text: "Ana wanted a hideout, and Owen knew a spot by the garden. They dragged a gentle blanket, a crate, and a kitten across the yard. The first try fell over when the wind pushed it. They started again and tied the corners more carefully. A hungry pony tried to steal the snack bag, so they hung it high.",
    level: 80,
    kind: "book",
  },
  {
    id: "l080-006",
    text: "Max and Lila stopped at the garden because the water was too fast. A gentle log lay in the grass, but it looked heavy. They tested the bank with a stick and did not like the mud. Lila spotted stones that almost made a path. The first stone wobbled, so Max went back.",
    level: 80,
    kind: "book",
  },
  {
    id: "l080-007",
    text: "A letter for Ava arrived just after breakfast. The writing was careful, and it was from Tess. It asked Ava to come to the garden before supper. Ava packed a gentle sweater and a small snack. The kitten followed as far as the garden gate.",
    level: 80,
    kind: "book",
  },
  {
    id: "l080-008",
    text: "Sam and Nia decided to clear a corner of the garden. Under the leaves they found a gentle kitten no one remembered. They kept digging, more carefully now. A tiny pony ran out and made them both jump. They laughed and marked the hole with a stick.",
    level: 80,
    kind: "book",
  },
  {
    id: "l080-009",
    text: "Jude had never been to the garden, and the walk there felt long. Nia had been once and promised it was not as huge as it looked. Inside, the air was cool and smelled like paper and soap. A gentle kitten sat on the desk as if it belonged there. Jude stayed close and did not speak at first.",
    level: 80,
    kind: "book",
  },
  {
    id: "l080-010",
    text: "Tess and Cal pushed the small boat from the garden into still water. The morning was gentle, and the oars made a soft slap. A kitten watched from the reeds and did not fly. They stayed close to shore the first time around. Cal learned to steer by pulling one oar more than the other.",
    level: 80,
    kind: "book",
  },
  {
    id: "l080-011",
    text: "Kim and Jude walked farther into the garden than they had meant to. When they turned, every tree looked like the last one. They stopped, because walking faster would not help. A gentle kitten sat on a stump as if nothing were wrong. Jude looked for the sun and pointed toward what should be home.",
    level: 80,
    kind: "book",
  },
  {
    id: "l081-000",
    text: "Pia could not find the gentle kitten after lunch. Remy said they should look near the garden. They walked together and called its name. A pony hopped across the path and made them stop. Then Remy heard a small sound behind a bench.",
    level: 81,
    kind: "book",
  },
  {
    id: "l081-001",
    text: "A noisy rain began while Cal and Pia were still in the garden. They hurried under the roof and shook water from their coats. Cal found a gentle towel and a kettle for tea. Pia watched the kitten curl up on a dry chair. Thunder made the windows tremble, but they stayed calm.",
    level: 81,
    kind: "book",
  },
  {
    id: "l081-002",
    text: "Sam needed help at the garden, so Lila came after school. Boxes, tools, and a gentle kitten were scattered across the floor. They made a plan before they lifted anything heavy. Lila carried the smaller things while Sam held the door. A clever pony kept getting under their feet.",
    level: 81,
    kind: "book",
  },
  {
    id: "l081-003",
    text: "Ned and Mia went out to the garden after supper. The sky was clear, and the first stars were already out. A gentle wind moved the grass but did not feel cold. They named the bright points they already knew. A kitten rustled in the dark and then grew still.",
    level: 81,
    kind: "book",
  },
  {
    id: "l081-004",
    text: "Ivy and Ben walked to the garden with a list and a bag. The market was busy, and the air smelled like bread and oranges. They found the gentle kitten first, just as the list said. Ben kept the coins and counted twice before paying. A tiny pony sat in a crate and made them both smile.",
    level: 81,
    kind: "book",
  },
  {
    id: "l081-005",
    text: "Leo wanted a hideout, and Ava knew a spot by the garden. They dragged a gentle blanket, a crate, and a kitten across the yard. The first try fell over when the wind pushed it. They started again and tied the corners more carefully. A hungry pony tried to steal the snack bag, so they hung it high.",
    level: 81,
    kind: "book",
  },
  {
    id: "l081-006",
    text: "Mia and Leo stopped at the garden because the water was too fast. A gentle log lay in the grass, but it looked heavy. They tested the bank with a stick and did not like the mud. Leo spotted stones that almost made a path. The first stone wobbled, so Mia went back.",
    level: 81,
    kind: "book",
  },
  {
    id: "l081-007",
    text: "A letter for Remy arrived just after breakfast. The writing was careful, and it was from Leo. It asked Remy to come to the garden before supper. Remy packed a gentle sweater and a small snack. The kitten followed as far as the garden gate.",
    level: 81,
    kind: "book",
  },
  {
    id: "l081-008",
    text: "Nia and Zoe decided to clear a corner of the garden. Under the leaves they found a gentle kitten no one remembered. They kept digging, more carefully now. A tiny pony ran out and made them both jump. They laughed and marked the hole with a stick.",
    level: 81,
    kind: "book",
  },
  {
    id: "l081-009",
    text: "Owen had never been to the garden, and the walk there felt long. Max had been once and promised it was not as huge as it looked. Inside, the air was cool and smelled like paper and soap. A gentle kitten sat on the desk as if it belonged there. Owen stayed close and did not speak at first.",
    level: 81,
    kind: "book",
  },
  {
    id: "l081-010",
    text: "Ana and Ivy pushed the small boat from the garden into still water. The morning was gentle, and the oars made a soft slap. A kitten watched from the reeds and did not fly. They stayed close to shore the first time around. Ivy learned to steer by pulling one oar more than the other.",
    level: 81,
    kind: "book",
  },
  {
    id: "l081-011",
    text: "Max and Eli walked farther into the garden than they had meant to. When they turned, every tree looked like the last one. They stopped, because walking faster would not help. A gentle kitten sat on a stump as if nothing were wrong. Eli looked for the sun and pointed toward what should be home.",
    level: 81,
    kind: "book",
  },
  {
    id: "l082-000",
    text: "Tess could not find the gentle kitten after lunch. Ana said they should look near the garden. They walked together and called its name. A pony hopped across the path and made them stop. Then Ana heard a small sound behind a bench.",
    level: 82,
    kind: "book",
  },
  {
    id: "l082-001",
    text: "A noisy rain began while Kim and Ned were still in the garden. They hurried under the roof and shook water from their coats. Kim found a gentle towel and a kettle for tea. Ned watched the kitten curl up on a dry chair. Thunder made the windows tremble, but they stayed calm.",
    level: 82,
    kind: "book",
  },
  {
    id: "l082-002",
    text: "Kim needed help at the garden, so Eli came after school. Boxes, tools, and a gentle kitten were scattered across the floor. They made a plan before they lifted anything heavy. Eli carried the smaller things while Kim held the door. A clever pony kept getting under their feet.",
    level: 82,
    kind: "book",
  },
  {
    id: "l082-003",
    text: "Zoe and Owen went out to the garden after supper. The sky was clear, and the first stars were already out. A gentle wind moved the grass but did not feel cold. They named the bright points they already knew. A kitten rustled in the dark and then grew still.",
    level: 82,
    kind: "book",
  },
  {
    id: "l082-004",
    text: "Ben and Lila walked to the garden with a list and a bag. The market was busy, and the air smelled like bread and oranges. They found the gentle kitten first, just as the list said. Lila kept the coins and counted twice before paying. A tiny pony sat in a crate and made them both smile.",
    level: 82,
    kind: "book",
  },
  {
    id: "l082-005",
    text: "Pia wanted a hideout, and Lila knew a spot by the garden. They dragged a gentle blanket, a crate, and a kitten across the yard. The first try fell over when the wind pushed it. They started again and tied the corners more carefully. A hungry pony tried to steal the snack bag, so they hung it high.",
    level: 82,
    kind: "book",
  },
  {
    id: "l082-006",
    text: "Cal and Tess stopped at the garden because the water was too fast. A gentle log lay in the grass, but it looked heavy. They tested the bank with a stick and did not like the mud. Tess spotted stones that almost made a path. The first stone wobbled, so Cal went back.",
    level: 82,
    kind: "book",
  },
  {
    id: "l082-007",
    text: "A letter for Lila arrived just after breakfast. The writing was careful, and it was from Nia. It asked Lila to come to the garden before supper. Lila packed a gentle sweater and a small snack. The kitten followed as far as the garden gate.",
    level: 82,
    kind: "book",
  },
  {
    id: "l082-008",
    text: "Ned and Cal decided to clear a corner of the garden. Under the leaves they found a gentle kitten no one remembered. They kept digging, more carefully now. A tiny pony ran out and made them both jump. They laughed and marked the hole with a stick.",
    level: 82,
    kind: "book",
  },
  {
    id: "l082-009",
    text: "Ivy had never been to the garden, and the walk there felt long. Jude had been once and promised it was not as huge as it looked. Inside, the air was cool and smelled like paper and soap. A gentle kitten sat on the desk as if it belonged there. Ivy stayed close and did not speak at first.",
    level: 82,
    kind: "book",
  },
  {
    id: "l082-010",
    text: "Leo and Remy pushed the small boat from the garden into still water. The morning was gentle, and the oars made a soft slap. A kitten watched from the reeds and did not fly. They stayed close to shore the first time around. Remy learned to steer by pulling one oar more than the other.",
    level: 82,
    kind: "book",
  },
  {
    id: "l082-011",
    text: "Mia and Pia walked farther into the garden than they had meant to. When they turned, every tree looked like the last one. They stopped, because walking faster would not help. A gentle kitten sat on a stump as if nothing were wrong. Pia looked for the sun and pointed toward what should be home.",
    level: 82,
    kind: "book",
  },
  {
    id: "l083-000",
    text: "Ana could not find the gentle kitten after lunch. Sam said they should look near the garden. They walked together and called its name. A pony hopped across the path and made them stop.\n\nThen Sam heard a small sound behind a bench. The kitten was hiding, hungry and a little afraid. Ana spoke in a gentle voice and held out a hand.",
    level: 83,
    kind: "book",
  },
  {
    id: "l083-001",
    text: "A noisy rain began while Max and Mia were still in the garden. They hurried under the roof and shook water from their coats. Max found a gentle towel and a kettle for tea. Mia watched the kitten curl up on a dry chair.\n\nThunder made the windows tremble, but they stayed calm. They told stories so the time would pass. A lonely pony waited on the porch until they let it in.",
    level: 83,
    kind: "book",
  },
  {
    id: "l083-002",
    text: "Ben needed help at the garden, so Ava came after school. Boxes, tools, and a gentle kitten were scattered across the floor. They made a plan before they lifted anything heavy. Ava carried the smaller things while Ben held the door.\n\nA clever pony kept getting under their feet. They laughed, then set it on a chair with a snack. Slowly the room began to look like a room again.",
    level: 83,
    kind: "book",
  },
  {
    id: "l083-003",
    text: "Sam and Ava went out to the garden after supper. The sky was clear, and the first stars were already out. A gentle wind moved the grass but did not feel cold. They named the bright points they already knew.\n\nA kitten rustled in the dark and then grew still. Ava pointed at a tiny moving light and wondered if it was a plane. Sam said it might be, or it might be a high bird.",
    level: 83,
    kind: "book",
  },
  {
    id: "l083-004",
    text: "Jude and Ava walked to the garden with a list and a bag. The market was busy, and the air smelled like bread and oranges. They found the gentle kitten first, just as the list said. Ava kept the coins and counted twice before paying.\n\nA tiny pony sat in a crate and made them both smile. They did not buy it, but they watched it for a while. At the bakery they chose two warm rolls to eat on the way.",
    level: 83,
    kind: "book",
  },
  {
    id: "l083-005",
    text: "Tess wanted a hideout, and Leo knew a spot by the garden. They dragged a gentle blanket, a crate, and a kitten across the yard. The first try fell over when the wind pushed it. They started again and tied the corners more carefully.\n\nA hungry pony tried to steal the snack bag, so they hung it high. Inside, the light was green and quiet. Tess read while Leo kept watch at the flap.",
    level: 83,
    kind: "book",
  },
  {
    id: "l083-006",
    text: "Kim and Zoe stopped at the garden because the water was too fast. A gentle log lay in the grass, but it looked heavy. They tested the bank with a stick and did not like the mud. Zoe spotted stones that almost made a path.\n\nThe first stone wobbled, so Kim went back. A turtle sat on the far bank as if it were waiting. They moved the log a little so it touched the nearest stone.",
    level: 83,
    kind: "book",
  },
  {
    id: "l083-007",
    text: "A letter for Eli arrived just after breakfast. The writing was careful, and it was from Max. It asked Eli to come to the garden before supper. Eli packed a gentle sweater and a small snack.\n\nThe kitten followed as far as the garden gate. On the way, Eli read the note again to be sure. Max was already waiting on the library steps.",
    level: 83,
    kind: "book",
  },
  {
    id: "l083-008",
    text: "Zoe and Ivy decided to clear a corner of the garden. Under the leaves they found a gentle kitten no one remembered. They kept digging, more carefully now. A tiny pony ran out and made them both jump.\n\nThey laughed and marked the hole with a stick. Ivy went for water so they could wash what they had found. The object was older than they had expected.",
    level: 83,
    kind: "book",
  },
  {
    id: "l083-009",
    text: "Ben had never been to the garden, and the walk there felt long. Eli had been once and promised it was not as huge as it looked. Inside, the air was cool and smelled like paper and soap. A gentle kitten sat on the desk as if it belonged there.\n\nBen stayed close and did not speak at first. A woman showed them where to hang their coats. Soon they were given a small job, which helped.",
    level: 83,
    kind: "book",
  },
  {
    id: "l083-010",
    text: "Pia and Eli pushed the small boat from the garden into still water. The morning was gentle, and the oars made a soft slap. A kitten watched from the reeds and did not fly. They stayed close to shore the first time around.\n\nEli learned to steer by pulling one oar more than the other. When a tiny wave hit, they both laughed and then sat still. The pony on the far bank looked like a wet stone until it moved.",
    level: 83,
    kind: "book",
  },
  {
    id: "l083-011",
    text: "Cal and Ana walked farther into the garden than they had meant to. When they turned, every tree looked like the last one. They stopped, because walking faster would not help. A gentle kitten sat on a stump as if nothing were wrong.\n\nAna looked for the sun and pointed toward what should be home. They made a mark on the path so they would know if they circled. A tiny pony crossed ahead of them and vanished.",
    level: 83,
    kind: "book",
  },
  {
    id: "l084-000",
    text: "Leo could not find the gentle kitten after lunch. Kim said they should look near the garden. They walked together and called its name. A pony hopped across the path and made them stop.\n\nThen Kim heard a small sound behind a bench. The kitten was hiding, hungry and a little afraid. Leo spoke in a gentle voice and held out a hand.",
    level: 84,
    kind: "book",
  },
  {
    id: "l084-001",
    text: "A noisy rain began while Mia and Owen were still in the garden. They hurried under the roof and shook water from their coats. Mia found a gentle towel and a kettle for tea. Owen watched the kitten curl up on a dry chair.\n\nThunder made the windows tremble, but they stayed calm. They told stories so the time would pass. A lonely pony waited on the porch until they let it in.",
    level: 84,
    kind: "book",
  },
  {
    id: "l084-002",
    text: "Owen needed help at the garden, so Remy came after school. Boxes, tools, and a gentle kitten were scattered across the floor. They made a plan before they lifted anything heavy. Remy carried the smaller things while Owen held the door.\n\nA clever pony kept getting under their feet. They laughed, then set it on a chair with a snack. Slowly the room began to look like a room again.",
    level: 84,
    kind: "book",
  },
  {
    id: "l084-003",
    text: "Nia and Lila went out to the garden after supper. The sky was clear, and the first stars were already out. A gentle wind moved the grass but did not feel cold. They named the bright points they already knew.\n\nA kitten rustled in the dark and then grew still. Lila pointed at a tiny moving light and wondered if it was a plane. Nia said it might be, or it might be a high bird.",
    level: 84,
    kind: "book",
  },
  {
    id: "l084-004",
    text: "Owen and Tess walked to the garden with a list and a bag. The market was busy, and the air smelled like bread and oranges. They found the gentle kitten first, just as the list said. Tess kept the coins and counted twice before paying.\n\nA tiny pony sat in a crate and made them both smile. They did not buy it, but they watched it for a while. At the bakery they chose two warm rolls to eat on the way.",
    level: 84,
    kind: "book",
  },
  {
    id: "l084-005",
    text: "Ana wanted a hideout, and Nia knew a spot by the garden. They dragged a gentle blanket, a crate, and a kitten across the yard. The first try fell over when the wind pushed it. They started again and tied the corners more carefully.\n\nA hungry pony tried to steal the snack bag, so they hung it high. Inside, the light was green and quiet. Ana read while Nia kept watch at the flap.",
    level: 84,
    kind: "book",
  },
  {
    id: "l084-006",
    text: "Max and Cal stopped at the garden because the water was too fast. A gentle log lay in the grass, but it looked heavy. They tested the bank with a stick and did not like the mud. Cal spotted stones that almost made a path.\n\nThe first stone wobbled, so Max went back. A turtle sat on the far bank as if it were waiting. They moved the log a little so it touched the nearest stone.",
    level: 84,
    kind: "book",
  },
  {
    id: "l084-007",
    text: "A letter for Ava arrived just after breakfast. The writing was careful, and it was from Jude. It asked Ava to come to the garden before supper. Ava packed a gentle sweater and a small snack.\n\nThe kitten followed as far as the garden gate. On the way, Ava read the note again to be sure. Jude was already waiting on the library steps.",
    level: 84,
    kind: "book",
  },
  {
    id: "l084-008",
    text: "Sam and Remy decided to clear a corner of the garden. Under the leaves they found a gentle kitten no one remembered. They kept digging, more carefully now. A tiny pony ran out and made them both jump.\n\nThey laughed and marked the hole with a stick. Remy went for water so they could wash what they had found. The object was older than they had expected.",
    level: 84,
    kind: "book",
  },
  {
    id: "l084-009",
    text: "Jude had never been to the garden, and the walk there felt long. Remy had been once and promised it was not as huge as it looked. Inside, the air was cool and smelled like paper and soap. A gentle kitten sat on the desk as if it belonged there.\n\nJude stayed close and did not speak at first. A woman showed them where to hang their coats. Soon they were given a small job, which helped.",
    level: 84,
    kind: "book",
  },
  {
    id: "l084-010",
    text: "Tess and Pia pushed the small boat from the garden into still water. The morning was gentle, and the oars made a soft slap. A kitten watched from the reeds and did not fly. They stayed close to shore the first time around.\n\nPia learned to steer by pulling one oar more than the other. When a tiny wave hit, they both laughed and then sat still. The pony on the far bank looked like a wet stone until it moved.",
    level: 84,
    kind: "book",
  },
  {
    id: "l084-011",
    text: "Kim and Sam walked farther into the garden than they had meant to. When they turned, every tree looked like the last one. They stopped, because walking faster would not help. A gentle kitten sat on a stump as if nothing were wrong.\n\nSam looked for the sun and pointed toward what should be home. They made a mark on the path so they would know if they circled. A tiny pony crossed ahead of them and vanished.",
    level: 84,
    kind: "book",
  },
  {
    id: "l085-000",
    text: "Pia could not find the gentle kitten after lunch. Mia said they should look near the garden. They walked together and called its name. A pony hopped across the path and made them stop.\n\nThen Mia heard a small sound behind a bench. The kitten was hiding, hungry and a little afraid. Pia spoke in a gentle voice and held out a hand.",
    level: 85,
    kind: "book",
  },
  {
    id: "l085-001",
    text: "A noisy rain began while Cal and Ben were still in the garden. They hurried under the roof and shook water from their coats. Cal found a gentle towel and a kettle for tea. Ben watched the kitten curl up on a dry chair.\n\nThunder made the windows tremble, but they stayed calm. They told stories so the time would pass. A lonely pony waited on the porch until they let it in.",
    level: 85,
    kind: "book",
  },
  {
    id: "l085-002",
    text: "Ava needed help at the garden, so Lila came after school. Boxes, tools, and a gentle kitten were scattered across the floor. They made a plan before they lifted anything heavy. Lila carried the smaller things while Ava held the door.\n\nA clever pony kept getting under their feet. They laughed, then set it on a chair with a snack. Slowly the room began to look like a room again.",
    level: 85,
    kind: "book",
  },
  {
    id: "l085-003",
    text: "Ned and Leo went out to the garden after supper. The sky was clear, and the first stars were already out. A gentle wind moved the grass but did not feel cold. They named the bright points they already knew.\n\nA kitten rustled in the dark and then grew still. Leo pointed at a tiny moving light and wondered if it was a plane. Ned said it might be, or it might be a high bird.",
    level: 85,
    kind: "book",
  },
  {
    id: "l085-004",
    text: "Ivy and Zoe walked to the garden with a list and a bag. The market was busy, and the air smelled like bread and oranges. They found the gentle kitten first, just as the list said. Zoe kept the coins and counted twice before paying.\n\nA tiny pony sat in a crate and made them both smile. They did not buy it, but they watched it for a while. At the bakery they chose two warm rolls to eat on the way.",
    level: 85,
    kind: "book",
  },
  {
    id: "l085-005",
    text: "Leo wanted a hideout, and Max knew a spot by the garden. They dragged a gentle blanket, a crate, and a kitten across the yard. The first try fell over when the wind pushed it. They started again and tied the corners more carefully.\n\nA hungry pony tried to steal the snack bag, so they hung it high. Inside, the light was green and quiet. Leo read while Max kept watch at the flap.",
    level: 85,
    kind: "book",
  },
  {
    id: "l085-006",
    text: "Mia and Ivy stopped at the garden because the water was too fast. A gentle log lay in the grass, but it looked heavy. They tested the bank with a stick and did not like the mud. Ivy spotted stones that almost made a path.\n\nThe first stone wobbled, so Mia went back. A turtle sat on the far bank as if it were waiting. They moved the log a little so it touched the nearest stone.",
    level: 85,
    kind: "book",
  },
  {
    id: "l085-007",
    text: "A letter for Remy arrived just after breakfast. The writing was careful, and it was from Ivy. It asked Remy to come to the garden before supper. Remy packed a gentle sweater and a small snack.\n\nThe kitten followed as far as the garden gate. On the way, Remy read the note again to be sure. Ivy was already waiting on the library steps.",
    level: 85,
    kind: "book",
  },
  {
    id: "l085-008",
    text: "Nia and Eli decided to clear a corner of the garden. Under the leaves they found a gentle kitten no one remembered. They kept digging, more carefully now. A tiny pony ran out and made them both jump.\n\nThey laughed and marked the hole with a stick. Eli went for water so they could wash what they had found. The object was older than they had expected.",
    level: 85,
    kind: "book",
  },
  {
    id: "l085-009",
    text: "Owen had never been to the garden, and the walk there felt long. Ana had been once and promised it was not as huge as it looked. Inside, the air was cool and smelled like paper and soap. A gentle kitten sat on the desk as if it belonged there.\n\nOwen stayed close and did not speak at first. A woman showed them where to hang their coats. Soon they were given a small job, which helped.",
    level: 85,
    kind: "book",
  },
  {
    id: "l085-010",
    text: "Ana and Ned pushed the small boat from the garden into still water. The morning was gentle, and the oars made a soft slap. A kitten watched from the reeds and did not fly. They stayed close to shore the first time around.\n\nNed learned to steer by pulling one oar more than the other. When a tiny wave hit, they both laughed and then sat still. The pony on the far bank looked like a wet stone until it moved.",
    level: 85,
    kind: "book",
  },
  {
    id: "l085-011",
    text: "Max and Kim walked farther into the garden than they had meant to. When they turned, every tree looked like the last one. They stopped, because walking faster would not help. A gentle kitten sat on a stump as if nothing were wrong.\n\nKim looked for the sun and pointed toward what should be home. They made a mark on the path so they would know if they circled. A tiny pony crossed ahead of them and vanished.",
    level: 85,
    kind: "book",
  },
  {
    id: "l086-000",
    text: "Tess could not find the gentle kitten after lunch. Owen said they should look near the garden. They walked together and called its name. A pony hopped across the path and made them stop.\n\nThen Owen heard a small sound behind a bench. The kitten was hiding, hungry and a little afraid. Tess spoke in a gentle voice and held out a hand. Slowly the kitten came close and let them help.",
    level: 86,
    kind: "book",
  },
  {
    id: "l086-001",
    text: "A noisy rain began while Kim and Lila were still in the garden. They hurried under the roof and shook water from their coats. Kim found a gentle towel and a kettle for tea. Lila watched the kitten curl up on a dry chair.\n\nThunder made the windows tremble, but they stayed calm. They told stories so the time would pass. A lonely pony waited on the porch until they let it in. When the rain grew softer, they looked out at the shiny path.",
    level: 86,
    kind: "book",
  },
  {
    id: "l086-002",
    text: "Tess needed help at the garden, so Eli came after school. Boxes, tools, and a gentle kitten were scattered across the floor. They made a plan before they lifted anything heavy. Eli carried the smaller things while Tess held the door.\n\nA clever pony kept getting under their feet. They laughed, then set it on a chair with a snack. Slowly the room began to look like a room again. Tess found the missing kettle behind a stack of books.",
    level: 86,
    kind: "book",
  },
  {
    id: "l086-003",
    text: "Zoe and Nia went out to the garden after supper. The sky was clear, and the first stars were already out. A gentle wind moved the grass but did not feel cold. They named the bright points they already knew.\n\nA kitten rustled in the dark and then grew still. Nia pointed at a tiny moving light and wondered if it was a plane. Zoe said it might be, or it might be a high bird. They sat without talking for a long, easy while.",
    level: 86,
    kind: "book",
  },
  {
    id: "l086-004",
    text: "Ben and Cal walked to the garden with a list and a bag. The market was busy, and the air smelled like bread and oranges. They found the gentle kitten first, just as the list said. Cal kept the coins and counted twice before paying.\n\nA tiny pony sat in a crate and made them both smile. They did not buy it, but they watched it for a while. At the bakery they chose two warm rolls to eat on the way. The bridge home was crowded, so they waited for a gap.",
    level: 86,
    kind: "book",
  },
  {
    id: "l086-005",
    text: "Pia wanted a hideout, and Cal knew a spot by the garden. They dragged a gentle blanket, a crate, and a kitten across the yard. The first try fell over when the wind pushed it. They started again and tied the corners more carefully.\n\nA hungry pony tried to steal the snack bag, so they hung it high. Inside, the light was green and quiet. Pia read while Cal kept watch at the flap. They made a rule that muddy boots stayed outside.",
    level: 86,
    kind: "book",
  },
  {
    id: "l086-006",
    text: "Cal and Jude stopped at the garden because the water was too fast. A gentle log lay in the grass, but it looked heavy. They tested the bank with a stick and did not like the mud. Jude spotted stones that almost made a path.\n\nThe first stone wobbled, so Cal went back. A turtle sat on the far bank as if it were waiting. They moved the log a little so it touched the nearest stone. This time Cal crossed with slow, careful steps.",
    level: 86,
    kind: "book",
  },
  {
    id: "l086-007",
    text: "A letter for Lila arrived just after breakfast. The writing was careful, and it was from Remy. It asked Lila to come to the garden before supper. Lila packed a gentle sweater and a small snack.\n\nThe kitten followed as far as the garden gate. On the way, Lila read the note again to be sure. Remy was already waiting on the library steps. They talked about the message and why it had to be a letter.",
    level: 86,
    kind: "book",
  },
  {
    id: "l086-008",
    text: "Ned and Pia decided to clear a corner of the garden. Under the leaves they found a gentle kitten no one remembered. They kept digging, more carefully now. A tiny pony ran out and made them both jump.\n\nThey laughed and marked the hole with a stick. Pia went for water so they could wash what they had found. The object was older than they had expected. Mom said it might have belonged to the people who lived here first.",
    level: 86,
    kind: "book",
  },
  {
    id: "l086-009",
    text: "Ivy had never been to the garden, and the walk there felt long. Sam had been once and promised it was not as huge as it looked. Inside, the air was cool and smelled like paper and soap. A gentle kitten sat on the desk as if it belonged there.\n\nIvy stayed close and did not speak at first. A woman showed them where to hang their coats. Soon they were given a small job, which helped. The pony in the window made Ivy smile.",
    level: 86,
    kind: "book",
  },
  {
    id: "l086-010",
    text: "Leo and Mia pushed the small boat from the garden into still water. The morning was gentle, and the oars made a soft slap. A kitten watched from the reeds and did not fly. They stayed close to shore the first time around.\n\nMia learned to steer by pulling one oar more than the other. When a tiny wave hit, they both laughed and then sat still. The pony on the far bank looked like a wet stone until it moved. They turned when the library clock struck, just as they had planned.",
    level: 86,
    kind: "book",
  },
  {
    id: "l086-011",
    text: "Mia and Ben walked farther into the garden than they had meant to. When they turned, every tree looked like the last one. They stopped, because walking faster would not help. A gentle kitten sat on a stump as if nothing were wrong.\n\nBen looked for the sun and pointed toward what should be home. They made a mark on the path so they would know if they circled. A tiny pony crossed ahead of them and vanished. After a while they heard a dog, then a road, then the gate.",
    level: 86,
    kind: "book",
  },
  {
    id: "l087-000",
    text: "Ana could not find the gentle kitten after lunch. Ava said they should look near the garden. They walked together and called its name. A pony hopped across the path and made them stop.\n\nThen Ava heard a small sound behind a bench. The kitten was hiding, hungry and a little afraid. Ana spoke in a gentle voice and held out a hand. Slowly the kitten came close and let them help.",
    level: 87,
    kind: "book",
  },
  {
    id: "l087-001",
    text: "A noisy rain began while Max and Leo were still in the garden. They hurried under the roof and shook water from their coats. Max found a gentle towel and a kettle for tea. Leo watched the kitten curl up on a dry chair.\n\nThunder made the windows tremble, but they stayed calm. They told stories so the time would pass. A lonely pony waited on the porch until they let it in. When the rain grew softer, they looked out at the shiny path.",
    level: 87,
    kind: "book",
  },
  {
    id: "l087-002",
    text: "Zoe needed help at the garden, so Ava came after school. Boxes, tools, and a gentle kitten were scattered across the floor. They made a plan before they lifted anything heavy. Ava carried the smaller things while Zoe held the door.\n\nA clever pony kept getting under their feet. They laughed, then set it on a chair with a snack. Slowly the room began to look like a room again. Zoe found the missing kettle behind a stack of books.",
    level: 87,
    kind: "book",
  },
  {
    id: "l087-003",
    text: "Sam and Max went out to the garden after supper. The sky was clear, and the first stars were already out. A gentle wind moved the grass but did not feel cold. They named the bright points they already knew.\n\nA kitten rustled in the dark and then grew still. Max pointed at a tiny moving light and wondered if it was a plane. Sam said it might be, or it might be a high bird. They sat without talking for a long, easy while.",
    level: 87,
    kind: "book",
  },
  {
    id: "l087-004",
    text: "Jude and Max walked to the garden with a list and a bag. The market was busy, and the air smelled like bread and oranges. They found the gentle kitten first, just as the list said. Max kept the coins and counted twice before paying.\n\nA tiny pony sat in a crate and made them both smile. They did not buy it, but they watched it for a while. At the bakery they chose two warm rolls to eat on the way. The bridge home was crowded, so they waited for a gap.",
    level: 87,
    kind: "book",
  },
  {
    id: "l087-005",
    text: "Tess wanted a hideout, and Ivy knew a spot by the garden. They dragged a gentle blanket, a crate, and a kitten across the yard. The first try fell over when the wind pushed it. They started again and tied the corners more carefully.\n\nA hungry pony tried to steal the snack bag, so they hung it high. Inside, the light was green and quiet. Tess read while Ivy kept watch at the flap. They made a rule that muddy boots stayed outside.",
    level: 87,
    kind: "book",
  },
  {
    id: "l087-006",
    text: "Kim and Eli stopped at the garden because the water was too fast. A gentle log lay in the grass, but it looked heavy. They tested the bank with a stick and did not like the mud. Eli spotted stones that almost made a path.\n\nThe first stone wobbled, so Kim went back. A turtle sat on the far bank as if it were waiting. They moved the log a little so it touched the nearest stone. This time Kim crossed with slow, careful steps.",
    level: 87,
    kind: "book",
  },
  {
    id: "l087-007",
    text: "A letter for Eli arrived just after breakfast. The writing was careful, and it was from Ana. It asked Eli to come to the garden before supper. Eli packed a gentle sweater and a small snack.\n\nThe kitten followed as far as the garden gate. On the way, Eli read the note again to be sure. Ana was already waiting on the library steps. They talked about the message and why it had to be a letter.",
    level: 87,
    kind: "book",
  },
  {
    id: "l087-008",
    text: "Zoe and Ned decided to clear a corner of the garden. Under the leaves they found a gentle kitten no one remembered. They kept digging, more carefully now. A tiny pony ran out and made them both jump.\n\nThey laughed and marked the hole with a stick. Ned went for water so they could wash what they had found. The object was older than they had expected. Mom said it might have belonged to the people who lived here first.",
    level: 87,
    kind: "book",
  },
  {
    id: "l087-009",
    text: "Ben had never been to the garden, and the walk there felt long. Kim had been once and promised it was not as huge as it looked. Inside, the air was cool and smelled like paper and soap. A gentle kitten sat on the desk as if it belonged there.\n\nBen stayed close and did not speak at first. A woman showed them where to hang their coats. Soon they were given a small job, which helped. The pony in the window made Ben smile.",
    level: 87,
    kind: "book",
  },
  {
    id: "l087-010",
    text: "Pia and Kim pushed the small boat from the garden into still water. The morning was gentle, and the oars made a soft slap. A kitten watched from the reeds and did not fly. They stayed close to shore the first time around.\n\nKim learned to steer by pulling one oar more than the other. When a tiny wave hit, they both laughed and then sat still. The pony on the far bank looked like a wet stone until it moved. They turned when the library clock struck, just as they had planned.",
    level: 87,
    kind: "book",
  },
  {
    id: "l087-011",
    text: "Cal and Owen walked farther into the garden than they had meant to. When they turned, every tree looked like the last one. They stopped, because walking faster would not help. A gentle kitten sat on a stump as if nothing were wrong.\n\nOwen looked for the sun and pointed toward what should be home. They made a mark on the path so they would know if they circled. A tiny pony crossed ahead of them and vanished. After a while they heard a dog, then a road, then the gate.",
    level: 87,
    kind: "book",
  },
  {
    id: "l088-000",
    text: "Leo could not find the gentle kitten after lunch. Tess said they should look near the garden. They walked together and called its name. A pony hopped across the path and made them stop.\n\nThen Tess heard a small sound behind a bench. The kitten was hiding, hungry and a little afraid. Leo spoke in a gentle voice and held out a hand. Slowly the kitten came close and let them help.",
    level: 88,
    kind: "book",
  },
  {
    id: "l088-001",
    text: "A noisy rain began while Mia and Nia were still in the garden. They hurried under the roof and shook water from their coats. Mia found a gentle towel and a kettle for tea. Nia watched the kitten curl up on a dry chair.\n\nThunder made the windows tremble, but they stayed calm. They told stories so the time would pass. A lonely pony waited on the porch until they let it in. When the rain grew softer, they looked out at the shiny path.",
    level: 88,
    kind: "book",
  },
  {
    id: "l088-002",
    text: "Nia needed help at the garden, so Remy came after school. Boxes, tools, and a gentle kitten were scattered across the floor. They made a plan before they lifted anything heavy. Remy carried the smaller things while Nia held the door.\n\nA clever pony kept getting under their feet. They laughed, then set it on a chair with a snack. Slowly the room began to look like a room again. Nia found the missing kettle behind a stack of books.",
    level: 88,
    kind: "book",
  },
  {
    id: "l088-003",
    text: "Nia and Cal went out to the garden after supper. The sky was clear, and the first stars were already out. A gentle wind moved the grass but did not feel cold. They named the bright points they already knew.\n\nA kitten rustled in the dark and then grew still. Cal pointed at a tiny moving light and wondered if it was a plane. Nia said it might be, or it might be a high bird. They sat without talking for a long, easy while.",
    level: 88,
    kind: "book",
  },
  {
    id: "l088-004",
    text: "Owen and Jude walked to the garden with a list and a bag. The market was busy, and the air smelled like bread and oranges. They found the gentle kitten first, just as the list said. Jude kept the coins and counted twice before paying.\n\nA tiny pony sat in a crate and made them both smile. They did not buy it, but they watched it for a while. At the bakery they chose two warm rolls to eat on the way. The bridge home was crowded, so they waited for a gap.",
    level: 88,
    kind: "book",
  },
  {
    id: "l088-005",
    text: "Ana wanted a hideout, and Remy knew a spot by the garden. They dragged a gentle blanket, a crate, and a kitten across the yard. The first try fell over when the wind pushed it. They started again and tied the corners more carefully.\n\nA hungry pony tried to steal the snack bag, so they hung it high. Inside, the light was green and quiet. Ana read while Remy kept watch at the flap. They made a rule that muddy boots stayed outside.",
    level: 88,
    kind: "book",
  },
  {
    id: "l088-006",
    text: "Max and Pia stopped at the garden because the water was too fast. A gentle log lay in the grass, but it looked heavy. They tested the bank with a stick and did not like the mud. Pia spotted stones that almost made a path.\n\nThe first stone wobbled, so Max went back. A turtle sat on the far bank as if it were waiting. They moved the log a little so it touched the nearest stone. This time Max crossed with slow, careful steps.",
    level: 88,
    kind: "book",
  },
  {
    id: "l088-007",
    text: "A letter for Ava arrived just after breakfast. The writing was careful, and it was from Sam. It asked Ava to come to the garden before supper. Ava packed a gentle sweater and a small snack.\n\nThe kitten followed as far as the garden gate. On the way, Ava read the note again to be sure. Sam was already waiting on the library steps. They talked about the message and why it had to be a letter.",
    level: 88,
    kind: "book",
  },
  {
    id: "l088-008",
    text: "Sam and Mia decided to clear a corner of the garden. Under the leaves they found a gentle kitten no one remembered. They kept digging, more carefully now. A tiny pony ran out and made them both jump.\n\nThey laughed and marked the hole with a stick. Mia went for water so they could wash what they had found. The object was older than they had expected. Mom said it might have belonged to the people who lived here first.",
    level: 88,
    kind: "book",
  },
  {
    id: "l088-009",
    text: "Jude had never been to the garden, and the walk there felt long. Mia had been once and promised it was not as huge as it looked. Inside, the air was cool and smelled like paper and soap. A gentle kitten sat on the desk as if it belonged there.\n\nJude stayed close and did not speak at first. A woman showed them where to hang their coats. Soon they were given a small job, which helped. The pony in the window made Jude smile.",
    level: 88,
    kind: "book",
  },
  {
    id: "l088-010",
    text: "Tess and Ben pushed the small boat from the garden into still water. The morning was gentle, and the oars made a soft slap. A kitten watched from the reeds and did not fly. They stayed close to shore the first time around.\n\nBen learned to steer by pulling one oar more than the other. When a tiny wave hit, they both laughed and then sat still. The pony on the far bank looked like a wet stone until it moved. They turned when the library clock struck, just as they had planned.",
    level: 88,
    kind: "book",
  },
  {
    id: "l088-011",
    text: "Kim and Ava walked farther into the garden than they had meant to. When they turned, every tree looked like the last one. They stopped, because walking faster would not help. A gentle kitten sat on a stump as if nothing were wrong.\n\nAva looked for the sun and pointed toward what should be home. They made a mark on the path so they would know if they circled. A tiny pony crossed ahead of them and vanished. After a while they heard a dog, then a road, then the gate.",
    level: 88,
    kind: "book",
  },
  {
    id: "l089-000",
    text: "Silas discovered that the curious stallion had vanished from the hillside. Jonah suggested they search the hillside before twilight. They packed a lantern, a whistle, and a folded blanket. A restless spaniel watched them leave the courtyard. At the crossroads they paused and listened for any sound.\n\nDistant bells from the village made the search feel urgent. Silas examined the muddy path for fresh tracks. Jonah noticed a golden thread caught on a low branch. They followed that clue down toward the marsh.",
    level: 89,
    kind: "book",
  },
  {
    id: "l089-001",
    text: "A solemn rain settled over the hillside just as Elena reached the door. Theo pulled them inside and shut the restless shutters. Water drummed on the roof until ordinary talk became difficult. They set a kettle on the stove and wrapped a curious blanket around the stallion. Lightning made the courtyard look ancient and strange.\n\nElena examined a leak near the window and placed a pan beneath it. The spaniel vanished under a bench and would not come out. For an hour they waited, listening, while the storm refused to move on. Then the wind shifted and the rain became a narrow, silver curtain.",
    level: 89,
    kind: "book",
  },
  {
    id: "l089-002",
    text: "Harriet had an anxious morning at the hillside until Theo arrived. A wagon had tipped, and a curious stallion lay among scattered tools. They examined the damage before they moved a single piece. Theo gathered nails and rope while Harriet calmed the restless spaniel. The courtyard was narrow, so every step had to be careful.\n\nTogether they lifted the wagon back onto its wheels. A silent crowd from the village paused at the gate to watch. Harriet offered water and would not let Theo rush. By noon the workshop looked orderly again.",
    level: 89,
    kind: "book",
  },
  {
    id: "l089-003",
    text: "After the lamps were lit, Naomi led Silas to the silent hillside. A vivid belt of stars hung above the distant lighthouse. They brought a curious blanket and a thermos, and they sat without hurry. The stallion made one low sound, then accepted the dark. Silas tried to count the brightest points and soon lost track.\n\nA restless satellite slid between them, too even to be a star. Naomi explained how sailors once used a compass and the sky together. The hillside smelled of orchard leaves and cold stone. Far off, a wagon creaked along the village road and vanished.",
    level: 89,
    kind: "book",
  },
  {
    id: "l089-004",
    text: "Jonah reached the hillside early, while the stalls were still being arranged. Victor carried the satchel and the list, folded so it would not tear. They needed a curious stallion, a kettle, and thread the color of wheat. The harbor wind made the canvas roofs billow like sails. A distant bell told them they should not linger too long.\n\nThey examined fruit with care and chose only what was sound. The spaniel at the potter's stall watched every movement. Jonah counted coins into the merchant's hand and waited for change. At the workshop corner they found the thread after a short search.",
    level: 89,
    kind: "book",
  },
  {
    id: "l089-005",
    text: "Amelia and Naomi chose a narrow space between the hillside wall and the orchard. They measured with a stick so the curious blanket would not sag. A lantern, a satchel, and a folded stallion became the furniture. The first roof collapsed, and they examined why without blaming each other. Rope from the workshop and a spare wagon board solved the problem.\n\nA curious spaniel inspected the doorway and then lost interest. Inside, the courtyard noise grew distant. They posted a solemn sign that said visitors should knock. Naomi brought the compass so they could pretend the fort was a ship.",
    level: 89,
    kind: "book",
  },
  {
    id: "l089-006",
    text: "The hillside had risen overnight, and Marcus stared at the restless water. Elena refused to turn back until they had examined every option. A curious plank from an old wagon lay half buried in the marsh grass. They pulled it free and tested it across the narrowest span. The far end slipped, so they anchored it with a heavy stone.\n\nA silent stallion in the satchel made the crossing feel more serious. Marcus went first, eyes on the hillside rather than the current. Elena waited until the plank stopped trembling, then followed. The spaniel they had seen earlier had already vanished downstream.",
    level: 89,
    kind: "book",
  },
  {
    id: "l089-007",
    text: "The envelope on the table was addressed to Harriet in a solemn, unfamiliar hand. Inside, Marcus asked for a meeting at the hillside before the harbor bells. Harriet felt curious and a little anxious, then packed a curious coat. A folded map had been tucked behind the note, marked with one small cross. The stallion in the courtyard watched Harriet leave as if it understood.\n\nAt the crossroads the wind made the paper flutter, so Harriet held it flat. Marcus waited near the lighthouse with a lantern not yet lit. They examined the map together and discovered a second mark on the back. It was not a secret so much as a careful surprise.",
    level: 89,
    kind: "book",
  },
  {
    id: "l089-008",
    text: "While clearing the hillside, Felix struck something harder than roots. Priya knelt and brushed the soil from a curious stallion. They stopped using the spade and switched to their hands. A silent spaniel watched from the orchard wall as if the work were a play. The object had a mark they did not recognize.\n\nThey carried it to the workshop and examined it under the lantern. Felix thought it might be part of an old compass housing. Priya was less sure and wanted to ask at the village library. They wrapped it in a blanket so it would not knock against the satchel.",
    level: 89,
    kind: "book",
  },
  {
    id: "l089-009",
    text: "The hillside was larger than Camille had imagined, and for a moment they stopped in the courtyard. Camille waited without rushing them, which helped more than words. Inside, a curious stallion occupied a shelf as if it had always been there. Voices echoed in the narrow hall, then softened as a door closed. They were shown a quiet room and asked to wait.\n\nCamille studied the golden lettering on a distant board to keep from fidgeting. A restless spaniel in the yard made a sound that felt like home. When someone finally explained the work, it was simpler than the building had suggested. They completed a small task and were thanked as if it mattered.",
    level: 89,
    kind: "book",
  },
  {
    id: "l089-010",
    text: "At the hillside, Victor checked the oars while Theo studied the curious surface of the water. They shoved off and felt the boat become suddenly alive. A lantern stayed unlit in the bow because the morning was already bright. The stallion in its basket protested, then accepted the motion. They kept to the harbor wall until their strokes matched.\n\nA distant whistle from the lighthouse reminded them of the time. When a narrow wake from a larger boat reached them, they paused and rode it. The spaniel surfaced once, curious, and vanished without a splash. Theo wanted to cross toward the orchard shore, but Victor said not yet.",
    level: 89,
    kind: "book",
  },
  {
    id: "l089-011",
    text: "By late afternoon the hillside had become a maze of similar trunks. Priya admitted they were lost before Silas had to say it. They sat on a curious log and examined their choices without panic. The compass in the satchel, unused until now, became the most important object they carried. A silent stallion watched from a low branch while they argued about east.\n\nThey chose a bearing and walked it, marking trees with a small scrape. The spaniel they startled did not run toward water, which told them something. Distant village sounds arrived like a rumor, then like a fact. When the orchard wall appeared, they did not run; they were too tired and too careful.",
    level: 89,
    kind: "book",
  },
  {
    id: "l090-000",
    text: "Harriet discovered that the curious stallion had vanished from the hillside. Victor suggested they search the hillside before twilight. They packed a lantern, a whistle, and a folded blanket. A restless spaniel watched them leave the courtyard. At the crossroads they paused and listened for any sound.\n\nDistant bells from the village made the search feel urgent. Harriet examined the muddy path for fresh tracks. Victor noticed a golden thread caught on a low branch. They followed that clue down toward the marsh.",
    level: 90,
    kind: "book",
  },
  {
    id: "l090-001",
    text: "A solemn rain settled over the hillside just as Felix reached the door. Naomi pulled them inside and shut the restless shutters. Water drummed on the roof until ordinary talk became difficult. They set a kettle on the stove and wrapped a curious blanket around the stallion. Lightning made the courtyard look ancient and strange.\n\nFelix examined a leak near the window and placed a pan beneath it. The spaniel vanished under a bench and would not come out. For an hour they waited, listening, while the storm refused to move on. Then the wind shifted and the rain became a narrow, silver curtain.",
    level: 90,
    kind: "book",
  },
  {
    id: "l090-002",
    text: "Elena had an anxious morning at the hillside until Camille arrived. A wagon had tipped, and a curious stallion lay among scattered tools. They examined the damage before they moved a single piece. Camille gathered nails and rope while Elena calmed the restless spaniel. The courtyard was narrow, so every step had to be careful.\n\nTogether they lifted the wagon back onto its wheels. A silent crowd from the village paused at the gate to watch. Elena offered water and would not let Camille rush. By noon the workshop looked orderly again.",
    level: 90,
    kind: "book",
  },
  {
    id: "l090-003",
    text: "After the lamps were lit, Victor led Marcus to the silent hillside. A vivid belt of stars hung above the distant lighthouse. They brought a curious blanket and a thermos, and they sat without hurry. The stallion made one low sound, then accepted the dark. Marcus tried to count the brightest points and soon lost track.\n\nA restless satellite slid between them, too even to be a star. Victor explained how sailors once used a compass and the sky together. The hillside smelled of orchard leaves and cold stone. Far off, a wagon creaked along the village road and vanished.",
    level: 90,
    kind: "book",
  },
  {
    id: "l090-004",
    text: "Priya reached the hillside early, while the stalls were still being arranged. Jonah carried the satchel and the list, folded so it would not tear. They needed a curious stallion, a kettle, and thread the color of wheat. The harbor wind made the canvas roofs billow like sails. A distant bell told them they should not linger too long.\n\nThey examined fruit with care and chose only what was sound. The spaniel at the potter's stall watched every movement. Priya counted coins into the merchant's hand and waited for change. At the workshop corner they found the thread after a short search.",
    level: 90,
    kind: "book",
  },
  {
    id: "l090-005",
    text: "Silas and Camille chose a narrow space between the hillside wall and the orchard. They measured with a stick so the curious blanket would not sag. A lantern, a satchel, and a folded stallion became the furniture. The first roof collapsed, and they examined why without blaming each other. Rope from the workshop and a spare wagon board solved the problem.\n\nA curious spaniel inspected the doorway and then lost interest. Inside, the courtyard noise grew distant. They posted a solemn sign that said visitors should knock. Camille brought the compass so they could pretend the fort was a ship.",
    level: 90,
    kind: "book",
  },
  {
    id: "l090-006",
    text: "The hillside had risen overnight, and Elena stared at the restless water. Harriet refused to turn back until they had examined every option. A curious plank from an old wagon lay half buried in the marsh grass. They pulled it free and tested it across the narrowest span. The far end slipped, so they anchored it with a heavy stone.\n\nA silent stallion in the satchel made the crossing feel more serious. Elena went first, eyes on the hillside rather than the current. Harriet waited until the plank stopped trembling, then followed. The spaniel they had seen earlier had already vanished downstream.",
    level: 90,
    kind: "book",
  },
  {
    id: "l090-007",
    text: "The envelope on the table was addressed to Theo in a solemn, unfamiliar hand. Inside, Silas asked for a meeting at the hillside before the harbor bells. Theo felt curious and a little anxious, then packed a curious coat. A folded map had been tucked behind the note, marked with one small cross. The stallion in the courtyard watched Theo leave as if it understood.\n\nAt the crossroads the wind made the paper flutter, so Theo held it flat. Silas waited near the lighthouse with a lantern not yet lit. They examined the map together and discovered a second mark on the back. It was not a secret so much as a careful surprise.",
    level: 90,
    kind: "book",
  },
  {
    id: "l090-008",
    text: "While clearing the hillside, Naomi struck something harder than roots. Amelia knelt and brushed the soil from a curious stallion. They stopped using the spade and switched to their hands. A silent spaniel watched from the orchard wall as if the work were a play. The object had a mark they did not recognize.\n\nThey carried it to the workshop and examined it under the lantern. Naomi thought it might be part of an old compass housing. Amelia was less sure and wanted to ask at the village library. They wrapped it in a blanket so it would not knock against the satchel.",
    level: 90,
    kind: "book",
  },
  {
    id: "l090-009",
    text: "The hillside was larger than Jonah had imagined, and for a moment they stopped in the courtyard. Naomi waited without rushing them, which helped more than words. Inside, a curious stallion occupied a shelf as if it had always been there. Voices echoed in the narrow hall, then softened as a door closed. They were shown a quiet room and asked to wait.\n\nJonah studied the golden lettering on a distant board to keep from fidgeting. A restless spaniel in the yard made a sound that felt like home. When someone finally explained the work, it was simpler than the building had suggested. They completed a small task and were thanked as if it mattered.",
    level: 90,
    kind: "book",
  },
  {
    id: "l090-010",
    text: "At the hillside, Amelia checked the oars while Felix studied the curious surface of the water. They shoved off and felt the boat become suddenly alive. A lantern stayed unlit in the bow because the morning was already bright. The stallion in its basket protested, then accepted the motion. They kept to the harbor wall until their strokes matched.\n\nA distant whistle from the lighthouse reminded them of the time. When a narrow wake from a larger boat reached them, they paused and rode it. The spaniel surfaced once, curious, and vanished without a splash. Felix wanted to cross toward the orchard shore, but Amelia said not yet.",
    level: 90,
    kind: "book",
  },
  {
    id: "l090-011",
    text: "By late afternoon the hillside had become a maze of similar trunks. Marcus admitted they were lost before Marcus had to say it. They sat on a curious log and examined their choices without panic. The compass in the satchel, unused until now, became the most important object they carried. A silent heron watched from a low branch while they argued about east.\n\nThey chose a bearing and walked it, marking trees with a small scrape. The spaniel they startled did not run toward water, which told them something. Distant village sounds arrived like a rumor, then like a fact. When the orchard wall appeared, they did not run; they were too tired and too careful.",
    level: 90,
    kind: "book",
  },
  {
    id: "l091-000",
    text: "Theo discovered that the curious heron had vanished from the hillside. Jonah suggested they search the hillside before twilight. They packed a lantern, a whistle, and a folded blanket. A restless spaniel watched them leave the courtyard. At the crossroads they paused and listened for any sound.\n\nDistant bells from the village made the search feel urgent. Theo examined the muddy path for fresh tracks. Jonah noticed a golden thread caught on a low branch. They followed that clue down toward the marsh.",
    level: 91,
    kind: "book",
  },
  {
    id: "l091-001",
    text: "A solemn rain settled over the hillside just as Naomi reached the door. Camille pulled them inside and shut the restless shutters. Water drummed on the roof until ordinary talk became difficult. They set a kettle on the stove and wrapped a curious blanket around the heron. Lightning made the courtyard look ancient and strange.\n\nNaomi examined a leak near the window and placed a pan beneath it. The spaniel vanished under a bench and would not come out. For an hour they waited, listening, while the storm refused to move on. Then the wind shifted and the rain became a narrow, silver curtain.",
    level: 91,
    kind: "book",
  },
  {
    id: "l091-002",
    text: "Harriet had an anxious morning at the hillside until Jonah arrived. A wagon had tipped, and a curious heron lay among scattered tools. They examined the damage before they moved a single piece. Jonah gathered nails and rope while Harriet calmed the restless spaniel. The courtyard was narrow, so every step had to be careful.\n\nTogether they lifted the wagon back onto its wheels. A silent crowd from the village paused at the gate to watch. Harriet offered water and would not let Jonah rush. By noon the workshop looked orderly again.",
    level: 91,
    kind: "book",
  },
  {
    id: "l091-003",
    text: "After the lamps were lit, Amelia led Silas to the silent hillside. A vivid belt of stars hung above the distant lighthouse. They brought a curious blanket and a thermos, and they sat without hurry. The heron made one low sound, then accepted the dark. Silas tried to count the brightest points and soon lost track.\n\nA restless satellite slid between them, too even to be a star. Amelia explained how sailors once used a compass and the sky together. The hillside smelled of orchard leaves and cold stone. Far off, a wagon creaked along the village road and vanished.",
    level: 91,
    kind: "book",
  },
  {
    id: "l091-004",
    text: "Marcus reached the hillside early, while the stalls were still being arranged. Victor carried the satchel and the list, folded so it would not tear. They needed a curious heron, a kettle, and thread the color of wheat. The harbor wind made the canvas roofs billow like sails. A distant bell told them they should not linger too long.\n\nThey examined fruit with care and chose only what was sound. The spaniel at the potter's stall watched every movement. Marcus counted coins into the merchant's hand and waited for change. At the workshop corner they found the thread after a short search.",
    level: 91,
    kind: "book",
  },
  {
    id: "l091-005",
    text: "Harriet and Naomi chose a narrow space between the hillside wall and the orchard. They measured with a stick so the curious blanket would not sag. A lantern, a satchel, and a folded heron became the furniture. The first roof collapsed, and they examined why without blaming each other. Rope from the workshop and a spare wagon board solved the problem.\n\nA curious spaniel inspected the doorway and then lost interest. Inside, the courtyard noise grew distant. They posted a solemn sign that said visitors should knock. Naomi brought the compass so they could pretend the fort was a ship.",
    level: 91,
    kind: "book",
  },
  {
    id: "l091-006",
    text: "The hillside had risen overnight, and Felix stared at the restless water. Felix refused to turn back until they had examined every option. A curious plank from an old wagon lay half buried in the marsh grass. They pulled it free and tested it across the narrowest span. The far end slipped, so they anchored it with a heavy stone.\n\nA silent heron in the satchel made the crossing feel more serious. Felix went first, eyes on the hillside rather than the current. Felix waited until the plank stopped trembling, then followed. The spaniel they had seen earlier had already vanished downstream.",
    level: 91,
    kind: "book",
  },
  {
    id: "l091-007",
    text: "The envelope on the table was addressed to Camille in a solemn, unfamiliar hand. Inside, Marcus asked for a meeting at the hillside before the harbor bells. Camille felt curious and a little anxious, then packed a curious coat. A folded map had been tucked behind the note, marked with one small cross. The heron in the courtyard watched Camille leave as if it understood.\n\nAt the crossroads the wind made the paper flutter, so Camille held it flat. Marcus waited near the lighthouse with a lantern not yet lit. They examined the map together and discovered a second mark on the back. It was not a secret so much as a careful surprise.",
    level: 91,
    kind: "book",
  },
  {
    id: "l091-008",
    text: "While clearing the hillside, Victor struck something harder than roots. Priya knelt and brushed the soil from a curious heron. They stopped using the spade and switched to their hands. A silent spaniel watched from the orchard wall as if the work were a play. The object had a mark they did not recognize.\n\nThey carried it to the workshop and examined it under the lantern. Victor thought it might be part of an old compass housing. Priya was less sure and wanted to ask at the village library. They wrapped it in a blanket so it would not knock against the satchel.",
    level: 91,
    kind: "book",
  },
  {
    id: "l091-009",
    text: "The hillside was larger than Priya had imagined, and for a moment they stopped in the courtyard. Camille waited without rushing them, which helped more than words. Inside, a curious heron occupied a shelf as if it had always been there. Voices echoed in the narrow hall, then softened as a door closed. They were shown a quiet room and asked to wait.\n\nPriya studied the golden lettering on a distant board to keep from fidgeting. A restless spaniel in the yard made a sound that felt like home. When someone finally explained the work, it was simpler than the building had suggested. They completed a small task and were thanked as if it mattered.",
    level: 91,
    kind: "book",
  },
  {
    id: "l091-010",
    text: "At the hillside, Silas checked the oars while Theo studied the curious surface of the water. They shoved off and felt the boat become suddenly alive. A lantern stayed unlit in the bow because the morning was already bright. The heron in its basket protested, then accepted the motion. They kept to the harbor wall until their strokes matched.\n\nA distant whistle from the lighthouse reminded them of the time. When a narrow wake from a larger boat reached them, they paused and rode it. The spaniel surfaced once, curious, and vanished without a splash. Theo wanted to cross toward the orchard shore, but Silas said not yet.",
    level: 91,
    kind: "book",
  },
  {
    id: "l091-011",
    text: "By late afternoon the hillside had become a maze of similar trunks. Elena admitted they were lost before Silas had to say it. They sat on a curious log and examined their choices without panic. The compass in the satchel, unused until now, became the most important object they carried. A silent heron watched from a low branch while they argued about east.\n\nThey chose a bearing and walked it, marking trees with a small scrape. The spaniel they startled did not run toward water, which told them something. Distant village sounds arrived like a rumor, then like a fact. When the orchard wall appeared, they did not run; they were too tired and too careful.",
    level: 91,
    kind: "book",
  },
  {
    id: "l092-000",
    text: "Camille discovered that the curious heron had vanished from the hillside. Victor suggested they search the hillside before twilight. They packed a lantern, a whistle, and a folded blanket. A restless spaniel watched them leave the courtyard. At the crossroads they paused and listened for any sound.\n\nDistant bells from the village made the search feel urgent. Camille examined the muddy path for fresh tracks. Victor noticed a golden thread caught on a low branch. They followed that clue down toward the marsh. There, silent and anxious, the heron waited under a wagon.",
    level: 92,
    kind: "book",
  },
  {
    id: "l092-001",
    text: "A solemn rain settled over the hillside just as Victor reached the door. Naomi pulled them inside and shut the restless shutters. Water drummed on the roof until ordinary talk became difficult. They set a kettle on the stove and wrapped a curious blanket around the heron. Lightning made the courtyard look ancient and strange.\n\nVictor examined a leak near the window and placed a pan beneath it. The spaniel vanished under a bench and would not come out. For an hour they waited, listening, while the storm refused to move on. Then the wind shifted and the rain became a narrow, silver curtain. Naomi opened the door a little and smelled the wet orchard.",
    level: 92,
    kind: "book",
  },
  {
    id: "l092-002",
    text: "Elena had an anxious morning at the hillside until Priya arrived. A wagon had tipped, and a curious heron lay among scattered tools. They examined the damage before they moved a single piece. Priya gathered nails and rope while Elena calmed the restless spaniel. The courtyard was narrow, so every step had to be careful.\n\nTogether they lifted the wagon back onto its wheels. A silent crowd from the village paused at the gate to watch. Elena offered water and would not let Priya rush. By noon the workshop looked orderly again. They discovered a cracked lantern and set it aside to mend.",
    level: 92,
    kind: "book",
  },
  {
    id: "l092-003",
    text: "After the lamps were lit, Silas led Marcus to the silent hillside. A vivid belt of stars hung above the distant lighthouse. They brought a curious blanket and a thermos, and they sat without hurry. The heron made one low sound, then accepted the dark. Marcus tried to count the brightest points and soon lost track.\n\nA restless satellite slid between them, too even to be a star. Silas explained how sailors once used a compass and the sky together. The hillside smelled of orchard leaves and cold stone. Far off, a wagon creaked along the village road and vanished. They spoke softly so they would not startle the spaniel.",
    level: 92,
    kind: "book",
  },
  {
    id: "l092-004",
    text: "Elena reached the hillside early, while the stalls were still being arranged. Jonah carried the satchel and the list, folded so it would not tear. They needed a curious heron, a kettle, and thread the color of wheat. The harbor wind made the canvas roofs billow like sails. A distant bell told them they should not linger too long.\n\nThey examined fruit with care and chose only what was sound. The spaniel at the potter's stall watched every movement. Elena counted coins into the merchant's hand and waited for change. At the workshop corner they found the thread after a short search. They paused at the courtyard fountain to rearrange the bundle.",
    level: 92,
    kind: "book",
  },
  {
    id: "l092-005",
    text: "Theo and Camille chose a narrow space between the hillside wall and the orchard. They measured with a stick so the curious blanket would not sag. A lantern, a satchel, and a folded heron became the furniture. The first roof collapsed, and they examined why without blaming each other. Rope from the workshop and a spare wagon board solved the problem.\n\nA curious spaniel inspected the doorway and then lost interest. Inside, the courtyard noise grew distant. They posted a solemn sign that said visitors should knock. Camille brought the compass so they could pretend the fort was a ship. Golden dust floated in the single beam of light.",
    level: 92,
    kind: "book",
  },
  {
    id: "l092-006",
    text: "The hillside had risen overnight, and Naomi stared at the restless water. Theo refused to turn back until they had examined every option. A curious plank from an old wagon lay half buried in the marsh grass. They pulled it free and tested it across the narrowest span. The far end slipped, so they anchored it with a heavy stone.\n\nA silent heron in the satchel made the crossing feel more serious. Naomi went first, eyes on the hillside rather than the current. Theo waited until the plank stopped trembling, then followed. The spaniel they had seen earlier had already vanished downstream. Wet boots squelched, but no one had fallen.",
    level: 92,
    kind: "book",
  },
  {
    id: "l092-007",
    text: "The envelope on the table was addressed to Jonah in a solemn, unfamiliar hand. Inside, Silas asked for a meeting at the hillside before the harbor bells. Jonah felt curious and a little anxious, then packed a curious coat. A folded map had been tucked behind the note, marked with one small cross. The heron in the courtyard watched Jonah leave as if it understood.\n\nAt the crossroads the wind made the paper flutter, so Jonah held it flat. Silas waited near the lighthouse with a lantern not yet lit. They examined the map together and discovered a second mark on the back. It was not a secret so much as a careful surprise. Silas had found a quiet orchard path that Jonah had never taken.",
    level: 92,
    kind: "book",
  },
  {
    id: "l092-008",
    text: "While clearing the hillside, Amelia struck something harder than roots. Amelia knelt and brushed the soil from a curious heron. They stopped using the spade and switched to their hands. A silent spaniel watched from the orchard wall as if the work were a play. The object had a mark they did not recognize.\n\nThey carried it to the workshop and examined it under the lantern. Amelia thought it might be part of an old compass housing. Amelia was less sure and wanted to ask at the village library. They wrapped it in a blanket so it would not knock against the satchel. Golden dust still clung to the grooves no matter how they wiped.",
    level: 92,
    kind: "book",
  },
  {
    id: "l092-009",
    text: "The hillside was larger than Marcus had imagined, and for a moment they stopped in the courtyard. Naomi waited without rushing them, which helped more than words. Inside, a curious heron occupied a shelf as if it had always been there. Voices echoed in the narrow hall, then softened as a door closed. They were shown a quiet room and asked to wait.\n\nMarcus studied the golden lettering on a distant board to keep from fidgeting. A restless spaniel in the yard made a sound that felt like home. When someone finally explained the work, it was simpler than the building had suggested. They completed a small task and were thanked as if it mattered. That thank-you changed the size of the place.",
    level: 92,
    kind: "book",
  },
  {
    id: "l092-010",
    text: "At the hillside, Harriet checked the oars while Felix studied the curious surface of the water. They shoved off and felt the boat become suddenly alive. A lantern stayed unlit in the bow because the morning was already bright. The heron in its basket protested, then accepted the motion. They kept to the harbor wall until their strokes matched.\n\nA distant whistle from the lighthouse reminded them of the time. When a narrow wake from a larger boat reached them, they paused and rode it. The spaniel surfaced once, curious, and vanished without a splash. Felix wanted to cross toward the orchard shore, but Harriet said not yet. Skill first, distance later, had been the rule.",
    level: 92,
    kind: "book",
  },
  {
    id: "l092-011",
    text: "By late afternoon the hillside had become a maze of similar trunks. Felix admitted they were lost before Elena had to say it. They sat on a curious log and examined their choices without panic. The compass in the satchel, unused until now, became the most important object they carried. A silent heron watched from a low branch while they argued about east.\n\nThey chose a bearing and walked it, marking trees with a small scrape. The spaniel they startled did not run toward water, which told them something. Distant village sounds arrived like a rumor, then like a fact. When the orchard wall appeared, they did not run; they were too tired and too careful. The courtyard gate clicked with a sound that felt like a sentence ending.",
    level: 92,
    kind: "book",
  },
  {
    id: "l093-000",
    text: "Jonah discovered that the curious heron had vanished from the hillside. Jonah suggested they search the hillside before twilight. They packed a lantern, a whistle, and a folded blanket. A restless spaniel watched them leave the courtyard. At the crossroads they paused and listened for any sound.\n\nDistant bells from the village made the search feel urgent. Jonah examined the muddy path for fresh tracks. Jonah noticed a golden thread caught on a low branch. They followed that clue down toward the marsh. There, silent and anxious, the heron waited under a wagon.",
    level: 93,
    kind: "book",
  },
  {
    id: "l093-001",
    text: "A solemn rain settled over the hillside just as Amelia reached the door. Camille pulled them inside and shut the restless shutters. Water drummed on the roof until ordinary talk became difficult. They set a kettle on the stove and wrapped a curious blanket around the heron. Lightning made the courtyard look ancient and strange.\n\nAmelia examined a leak near the window and placed a pan beneath it. The spaniel vanished under a bench and would not come out. For an hour they waited, listening, while the storm refused to move on. Then the wind shifted and the rain became a narrow, silver curtain. Camille opened the door a little and smelled the wet orchard.",
    level: 93,
    kind: "book",
  },
  {
    id: "l093-002",
    text: "Harriet had an anxious morning at the hillside until Marcus arrived. A wagon had tipped, and a curious heron lay among scattered tools. They examined the damage before they moved a single piece. Marcus gathered nails and rope while Harriet calmed the restless spaniel. The courtyard was narrow, so every step had to be careful.\n\nTogether they lifted the wagon back onto its wheels. A silent crowd from the village paused at the gate to watch. Harriet offered water and would not let Marcus rush. By noon the workshop looked orderly again. They discovered a cracked lantern and set it aside to mend.",
    level: 93,
    kind: "book",
  },
  {
    id: "l093-003",
    text: "After the lamps were lit, Harriet led Silas to the silent hillside. A vivid belt of stars hung above the distant lighthouse. They brought a curious blanket and a thermos, and they sat without hurry. The heron made one low sound, then accepted the dark. Silas tried to count the brightest points and soon lost track.\n\nA restless satellite slid between them, too even to be a star. Harriet explained how sailors once used a compass and the sky together. The hillside smelled of orchard leaves and cold stone. Far off, a wagon creaked along the village road and vanished. They spoke softly so they would not startle the spaniel.",
    level: 93,
    kind: "book",
  },
  {
    id: "l093-004",
    text: "Felix reached the hillside early, while the stalls were still being arranged. Amelia carried the satchel and the list, folded so it would not tear. They needed a curious heron, a kettle, and thread the color of wheat. The harbor wind made the canvas roofs billow like sails. A distant bell told them they should not linger too long.\n\nThey examined fruit with care and chose only what was sound. The spaniel at the potter's stall watched every movement. Felix counted coins into the merchant's hand and waited for change. At the workshop corner they found the thread after a short search. They paused at the courtyard fountain to rearrange the bundle.",
    level: 93,
    kind: "book",
  },
  {
    id: "l093-005",
    text: "Camille and Naomi chose a narrow space between the hillside wall and the orchard. They measured with a stick so the curious blanket would not sag. A lantern, a satchel, and a folded heron became the furniture. The first roof collapsed, and they examined why without blaming each other. Rope from the workshop and a spare wagon board solved the problem.\n\nA curious spaniel inspected the doorway and then lost interest. Inside, the courtyard noise grew distant. They posted a solemn sign that said visitors should knock. Naomi brought the compass so they could pretend the fort was a ship. Golden dust floated in the single beam of light.",
    level: 93,
    kind: "book",
  },
  {
    id: "l093-006",
    text: "The hillside had risen overnight, and Victor stared at the restless water. Felix refused to turn back until they had examined every option. A curious plank from an old wagon lay half buried in the marsh grass. They pulled it free and tested it across the narrowest span. The far end slipped, so they anchored it with a heavy stone.\n\nA silent heron in the satchel made the crossing feel more serious. Victor went first, eyes on the hillside rather than the current. Felix waited until the plank stopped trembling, then followed. The spaniel they had seen earlier had already vanished downstream. Wet boots squelched, but no one had fallen.",
    level: 93,
    kind: "book",
  },
  {
    id: "l093-007",
    text: "The envelope on the table was addressed to Priya in a solemn, unfamiliar hand. Inside, Marcus asked for a meeting at the hillside before the harbor bells. Priya felt curious and a little anxious, then packed a curious coat. A folded map had been tucked behind the note, marked with one small cross. The heron in the courtyard watched Priya leave as if it understood.\n\nAt the crossroads the wind made the paper flutter, so Priya held it flat. Marcus waited near the lighthouse with a lantern not yet lit. They examined the map together and discovered a second mark on the back. It was not a secret so much as a careful surprise. Marcus had found a quiet orchard path that Priya had never taken.",
    level: 93,
    kind: "book",
  },
  {
    id: "l093-008",
    text: "While clearing the hillside, Silas struck something harder than roots. Priya knelt and brushed the soil from a curious heron. They stopped using the spade and switched to their hands. A silent spaniel watched from the orchard wall as if the work were a play. The object had a mark they did not recognize.\n\nThey carried it to the workshop and examined it under the lantern. Silas thought it might be part of an old compass housing. Priya was less sure and wanted to ask at the village library. They wrapped it in a blanket so it would not knock against the satchel. Golden dust still clung to the grooves no matter how they wiped.",
    level: 93,
    kind: "book",
  },
  {
    id: "l093-009",
    text: "The hillside was larger than Elena had imagined, and for a moment they stopped in the courtyard. Camille waited without rushing them, which helped more than words. Inside, a curious heron occupied a shelf as if it had always been there. Voices echoed in the narrow hall, then softened as a door closed. They were shown a quiet room and asked to wait.\n\nElena studied the golden lettering on a distant board to keep from fidgeting. A restless spaniel in the yard made a sound that felt like home. When someone finally explained the work, it was simpler than the building had suggested. They completed a small task and were thanked as if it mattered. That thank-you changed the size of the place.",
    level: 93,
    kind: "book",
  },
  {
    id: "l093-010",
    text: "At the hillside, Theo checked the oars while Theo studied the curious surface of the water. They shoved off and felt the boat become suddenly alive. A lantern stayed unlit in the bow because the morning was already bright. The heron in its basket protested, then accepted the motion. They kept to the harbor wall until their strokes matched.\n\nA distant whistle from the lighthouse reminded them of the time. When a narrow wake from a larger boat reached them, they paused and rode it. The spaniel surfaced once, curious, and vanished without a splash. Theo wanted to cross toward the orchard shore, but Theo said not yet. Skill first, distance later, had been the rule.",
    level: 93,
    kind: "book",
  },
  {
    id: "l093-011",
    text: "By late afternoon the hillside had become a maze of similar trunks. Naomi admitted they were lost before Harriet had to say it. They sat on a curious log and examined their choices without panic. The compass in the satchel, unused until now, became the most important object they carried. A silent heron watched from a low branch while they argued about east.\n\nThey chose a bearing and walked it, marking trees with a small scrape. The spaniel they startled did not run toward water, which told them something. Distant village sounds arrived like a rumor, then like a fact. When the orchard wall appeared, they did not run; they were too tired and too careful. The courtyard gate clicked with a sound that felt like a sentence ending.",
    level: 93,
    kind: "book",
  },
  {
    id: "l094-000",
    text: "Priya discovered that the curious heron had vanished from the hillside. Victor suggested they search the hillside before twilight. They packed a lantern, a whistle, and a folded blanket. A restless spaniel watched them leave the courtyard. At the crossroads they paused and listened for any sound.\n\nDistant bells from the village made the search feel urgent. Priya examined the muddy path for fresh tracks. Victor noticed a golden thread caught on a low branch. They followed that clue down toward the marsh. There, silent and anxious, the heron waited under a wagon.",
    level: 94,
    kind: "book",
  },
  {
    id: "l094-001",
    text: "A solemn rain settled over the hillside just as Silas reached the door. Naomi pulled them inside and shut the restless shutters. Water drummed on the roof until ordinary talk became difficult. They set a kettle on the stove and wrapped a curious blanket around the heron. Lightning made the courtyard look ancient and strange.\n\nSilas examined a leak near the window and placed a pan beneath it. The spaniel vanished under a bench and would not come out. For an hour they waited, listening, while the storm refused to move on. Then the wind shifted and the rain became a narrow, silver curtain. Naomi opened the door a little and smelled the wet orchard.",
    level: 94,
    kind: "book",
  },
  {
    id: "l094-002",
    text: "Elena had an anxious morning at the hillside until Elena arrived. A wagon had tipped, and a curious heron lay among scattered tools. They examined the damage before they moved a single piece. Elena gathered nails and rope while Elena calmed the restless spaniel. The courtyard was narrow, so every step had to be careful.\n\nTogether they lifted the wagon back onto its wheels. A silent crowd from the village paused at the gate to watch. Elena offered water and would not let Elena rush. By noon the workshop looked orderly again. They discovered a cracked lantern and set it aside to mend.",
    level: 94,
    kind: "book",
  },
  {
    id: "l094-003",
    text: "After the lamps were lit, Theo led Marcus to the silent hillside. A vivid belt of stars hung above the distant lighthouse. They brought a curious blanket and a thermos, and they sat without hurry. The heron made one low sound, then accepted the dark. Marcus tried to count the brightest points and soon lost track.\n\nA restless satellite slid between them, too even to be a star. Theo explained how sailors once used a compass and the sky together. The hillside smelled of orchard leaves and cold stone. Far off, a wagon creaked along the village road and vanished. They spoke softly so they would not startle the spaniel.",
    level: 94,
    kind: "book",
  },
  {
    id: "l094-004",
    text: "Naomi reached the hillside early, while the stalls were still being arranged. Priya carried the satchel and the list, folded so it would not tear. They needed a curious heron, a kettle, and thread the color of wheat. The harbor wind made the canvas roofs billow like sails. A distant bell told them they should not linger too long.\n\nThey examined fruit with care and chose only what was sound. The spaniel at the potter's stall watched every movement. Naomi counted coins into the merchant's hand and waited for change. At the workshop corner they found the thread after a short search. They paused at the courtyard fountain to rearrange the bundle.",
    level: 94,
    kind: "book",
  },
  {
    id: "l094-005",
    text: "Jonah and Camille chose a narrow space between the hillside wall and the orchard. They measured with a stick so the curious blanket would not sag. A lantern, a satchel, and a folded heron became the furniture. The first roof collapsed, and they examined why without blaming each other. Rope from the workshop and a spare wagon board solved the problem.\n\nA curious spaniel inspected the doorway and then lost interest. Inside, the courtyard noise grew distant. They posted a solemn sign that said visitors should knock. Camille brought the compass so they could pretend the fort was a ship. Golden dust floated in the single beam of light.",
    level: 94,
    kind: "book",
  },
  {
    id: "l094-006",
    text: "The hillside had risen overnight, and Amelia stared at the restless water. Theo refused to turn back until they had examined every option. A curious plank from an old wagon lay half buried in the marsh grass. They pulled it free and tested it across the narrowest span. The far end slipped, so they anchored it with a heavy stone.\n\nA silent heron in the satchel made the crossing feel more serious. Amelia went first, eyes on the hillside rather than the current. Theo waited until the plank stopped trembling, then followed. The spaniel they had seen earlier had already vanished downstream. Wet boots squelched, but no one had fallen.",
    level: 94,
    kind: "book",
  },
  {
    id: "l094-007",
    text: "The envelope on the table was addressed to Marcus in a solemn, unfamiliar hand. Inside, Silas asked for a meeting at the hillside before the harbor bells. Marcus felt curious and a little anxious, then packed a curious coat. A folded map had been tucked behind the note, marked with one small cross. The heron in the courtyard watched Marcus leave as if it understood.\n\nAt the crossroads the wind made the paper flutter, so Marcus held it flat. Silas waited near the lighthouse with a lantern not yet lit. They examined the map together and discovered a second mark on the back. It was not a secret so much as a careful surprise. Silas had found a quiet orchard path that Marcus had never taken.",
    level: 94,
    kind: "book",
  },
  {
    id: "l094-008",
    text: "While clearing the hillside, Harriet struck something harder than roots. Amelia knelt and brushed the soil from a curious heron. They stopped using the spade and switched to their hands. A silent spaniel watched from the orchard wall as if the work were a play. The object had a mark they did not recognize.\n\nThey carried it to the workshop and examined it under the lantern. Harriet thought it might be part of an old compass housing. Amelia was less sure and wanted to ask at the village library. They wrapped it in a blanket so it would not knock against the satchel. Golden dust still clung to the grooves no matter how they wiped.",
    level: 94,
    kind: "book",
  },
  {
    id: "l094-009",
    text: "The hillside was larger than Felix had imagined, and for a moment they stopped in the courtyard. Victor waited without rushing them, which helped more than words. Inside, a curious heron occupied a shelf as if it had always been there. Voices echoed in the narrow hall, then softened as a door closed. They were shown a quiet room and asked to wait.\n\nFelix studied the golden lettering on a distant board to keep from fidgeting. A restless spaniel in the yard made a sound that felt like home. When someone finally explained the work, it was simpler than the building had suggested. They completed a small task and were thanked as if it mattered. That thank-you changed the size of the place.",
    level: 94,
    kind: "book",
  },
  {
    id: "l094-010",
    text: "At the hillside, Camille checked the oars while Felix studied the curious surface of the water. They shoved off and felt the boat become suddenly alive. A lantern stayed unlit in the bow because the morning was already bright. The heron in its basket protested, then accepted the motion. They kept to the harbor wall until their strokes matched.\n\nA distant whistle from the lighthouse reminded them of the time. When a narrow wake from a larger boat reached them, they paused and rode it. The spaniel surfaced once, curious, and vanished without a splash. Felix wanted to cross toward the orchard shore, but Camille said not yet. Skill first, distance later, had been the rule.",
    level: 94,
    kind: "book",
  },
  {
    id: "l094-011",
    text: "By late afternoon the hillside had become a maze of similar trunks. Victor admitted they were lost before Elena had to say it. They sat on a curious log and examined their choices without panic. The compass in the satchel, unused until now, became the most important object they carried. A silent heron watched from a low branch while they argued about east.\n\nThey chose a bearing and walked it, marking trees with a small scrape. The spaniel they startled did not run toward water, which told them something. Distant village sounds arrived like a rumor, then like a fact. When the orchard wall appeared, they did not run; they were too tired and too careful. The courtyard gate clicked with a sound that felt like a sentence ending.",
    level: 94,
    kind: "book",
  },
  {
    id: "l095-000",
    text: "Marcus discovered that the curious heron had vanished from the hillside. Jonah suggested they search the hillside before twilight. They packed a lantern, a whistle, and a folded blanket. A restless spaniel watched them leave the courtyard.\n\nAt the crossroads they paused and listened for any sound. Distant bells from the village made the search feel urgent. Marcus examined the muddy path for fresh tracks. Jonah noticed a golden thread caught on a low branch. They followed that clue down toward the marsh.\n\nThere, silent and anxious, the heron waited under a wagon. Marcus approached slowly so it would not escape again. The lantern made a narrow circle of light around them. They offered water and wrapped the heron in the blanket.",
    level: 95,
    kind: "book",
  },
  {
    id: "l095-001",
    text: "A solemn rain settled over the hillside just as Harriet reached the door. Camille pulled them inside and shut the restless shutters. Water drummed on the roof until ordinary talk became difficult. They set a kettle on the stove and wrapped a curious blanket around the heron.\n\nLightning made the courtyard look ancient and strange. Harriet examined a leak near the window and placed a pan beneath it. The spaniel vanished under a bench and would not come out. For an hour they waited, listening, while the storm refused to move on. Then the wind shifted and the rain became a narrow, silver curtain.\n\nCamille opened the door a little and smelled the wet orchard. They put on coats and carried the lantern toward the hillside path. Puddles reflected the golden edge of a distant break in the clouds. A silent wagon stood where they had left it, heavier with rain.",
    level: 95,
    kind: "book",
  },
  {
    id: "l095-002",
    text: "Theo had an anxious morning at the hillside until Felix arrived. A wagon had tipped, and a curious heron lay among scattered tools. They examined the damage before they moved a single piece. Felix gathered nails and rope while Theo calmed the restless spaniel.\n\nThe courtyard was narrow, so every step had to be careful. Together they lifted the wagon back onto its wheels. A silent crowd from the village paused at the gate to watch. Theo offered water and would not let Felix rush. By noon the workshop looked orderly again.\n\nThey discovered a cracked lantern and set it aside to mend. The golden light on the hillside made the remaining work easier. Felix swept the last shavings into a bundle. Theo wrote a list of what still needed repair.",
    level: 95,
    kind: "book",
  },
  {
    id: "l095-003",
    text: "After the lamps were lit, Camille led Silas to the silent hillside. A vivid belt of stars hung above the distant lighthouse. They brought a curious blanket and a thermos, and they sat without hurry. The heron made one low sound, then accepted the dark.\n\nSilas tried to count the brightest points and soon lost track. A restless satellite slid between them, too even to be a star. Camille explained how sailors once used a compass and the sky together. The hillside smelled of orchard leaves and cold stone. Far off, a wagon creaked along the village road and vanished.\n\nThey spoke softly so they would not startle the spaniel. When a bank of cloud approached, the stars went out in groups. Silas folded the blanket and kept the lantern shuttered. The walk home felt shorter than the walk out.",
    level: 95,
    kind: "book",
  },
  {
    id: "l095-004",
    text: "Victor reached the hillside early, while the stalls were still being arranged. Amelia carried the satchel and the list, folded so it would not tear. They needed a curious heron, a kettle, and thread the color of wheat. The harbor wind made the canvas roofs billow like sails.\n\nA distant bell told them they should not linger too long. They examined fruit with care and chose only what was sound. The spaniel at the potter's stall watched every movement. Victor counted coins into the merchant's hand and waited for change. At the workshop corner they found the thread after a short search.\n\nThey paused at the courtyard fountain to rearrange the bundle. Nothing rattled, which meant they had packed well. On the hillside path home, the village looked small and busy below them. Amelia admitted the market felt less anxious when they had a plan.",
    level: 95,
    kind: "book",
  },
  {
    id: "l095-005",
    text: "Priya and Naomi chose a narrow space between the hillside wall and the orchard. They measured with a stick so the curious blanket would not sag. A lantern, a satchel, and a folded heron became the furniture. The first roof collapsed, and they examined why without blaming each other.\n\nRope from the workshop and a spare wagon board solved the problem. A curious spaniel inspected the doorway and then lost interest. Inside, the courtyard noise grew distant. They posted a solemn sign that said visitors should knock. Naomi brought the compass so they could pretend the fort was a ship.\n\nGolden dust floated in the single beam of light. When the hillside wind rose, the walls trembled but did not fall. They waited out the gust, then laughed with relief. Priya wrote a list of improvements on the back of an envelope.",
    level: 95,
    kind: "book",
  },
  {
    id: "l095-006",
    text: "The hillside had risen overnight, and Silas stared at the restless water. Felix refused to turn back until they had examined every option. A curious plank from an old wagon lay half buried in the marsh grass. They pulled it free and tested it across the narrowest span.\n\nThe far end slipped, so they anchored it with a heavy stone. A silent heron in the satchel made the crossing feel more serious. Silas went first, eyes on the hillside rather than the current. Felix waited until the plank stopped trembling, then followed. The spaniel they had seen earlier had already vanished downstream.\n\nWet boots squelched, but no one had fallen. They left the plank in place, a gift for whoever came next. Golden light on the canyon wall made the far path look easy. It was not easy, only possible, which was enough.",
    level: 95,
    kind: "book",
  },
  {
    id: "l095-007",
    text: "The envelope on the table was addressed to Elena in a solemn, unfamiliar hand. Inside, Marcus asked for a meeting at the hillside before the harbor bells. Elena felt curious and a little anxious, then packed a curious coat. A folded map had been tucked behind the note, marked with one small cross.\n\nThe heron in the courtyard watched Elena leave as if it understood. At the crossroads the wind made the paper flutter, so Elena held it flat. Marcus waited near the lighthouse with a lantern not yet lit. They examined the map together and discovered a second mark on the back. It was not a secret so much as a careful surprise.\n\nMarcus had found a quiet orchard path that Elena had never taken. They walked it while the spaniel kept to the hedges. Golden evening made the village roofs look close enough to touch. On the return, they agreed that letters can still matter.",
    level: 95,
    kind: "book",
  },
  {
    id: "l095-008",
    text: "While clearing the hillside, Theo struck something harder than roots. Priya knelt and brushed the soil from a curious heron. They stopped using the spade and switched to their hands. A silent spaniel watched from the orchard wall as if the work were a play.\n\nThe object had a mark they did not recognize. They carried it to the workshop and examined it under the lantern. Theo thought it might be part of an old compass housing. Priya was less sure and wanted to ask at the village library. They wrapped it in a blanket so it would not knock against the satchel.\n\nGolden dust still clung to the grooves no matter how they wiped. At the library a woman said it was likely a hinge from a lost gate. That was less glamorous than treasure, and somehow better. They returned it to the courtyard with a note about where it had been found.",
    level: 95,
    kind: "book",
  },
  {
    id: "l095-009",
    text: "The hillside was larger than Naomi had imagined, and for a moment they stopped in the courtyard. Jonah waited without rushing them, which helped more than words. Inside, a curious heron occupied a shelf as if it had always been there. Voices echoed in the narrow hall, then softened as a door closed.\n\nThey were shown a quiet room and asked to wait. Naomi studied the golden lettering on a distant board to keep from fidgeting. A restless spaniel in the yard made a sound that felt like home. When someone finally explained the work, it was simpler than the building had suggested. They completed a small task and were thanked as if it mattered.\n\nThat thank-you changed the size of the place. On the hillside walk back, Naomi admitted the fear had been mostly of not knowing. Jonah said not knowing is a kind of beginning. The village looked ordinary and kind below them.",
    level: 95,
    kind: "book",
  },
  {
    id: "l095-010",
    text: "At the hillside, Jonah checked the oars while Theo studied the curious surface of the water. They shoved off and felt the boat become suddenly alive. A lantern stayed unlit in the bow because the morning was already bright. The heron in its basket protested, then accepted the motion.\n\nThey kept to the harbor wall until their strokes matched. A distant whistle from the lighthouse reminded them of the time. When a narrow wake from a larger boat reached them, they paused and rode it. The spaniel surfaced once, curious, and vanished without a splash. Theo wanted to cross toward the orchard shore, but Jonah said not yet.\n\nSkill first, distance later, had been the rule. They returned in a wide arc and approached the dock against the drift. Tying up took three tries and no embarrassment. Golden light made the wet boards look new.",
    level: 95,
    kind: "book",
  },
  {
    id: "l095-011",
    text: "By late afternoon the hillside had become a maze of similar trunks. Amelia admitted they were lost before Harriet had to say it. They sat on a curious log and examined their choices without panic. The compass in the satchel, unused until now, became the most important object they carried.\n\nA silent heron watched from a low branch while they argued about east. They chose a bearing and walked it, marking trees with a small scrape. The spaniel they startled did not run toward water, which told them something. Distant village sounds arrived like a rumor, then like a fact. When the orchard wall appeared, they did not run; they were too tired and too careful.\n\nThe courtyard gate clicked with a sound that felt like a sentence ending. They told the truth at once, including the part where they had ignored the first doubt. Supper tasted like a reward they had not quite earned. That night Amelia placed the compass on the shelf where it could be seen.",
    level: 95,
    kind: "book",
  },
  {
    id: "l096-000",
    text: "Elena discovered that the curious heron had vanished from the hillside. Victor suggested they search the hillside before twilight. They packed a lantern, a whistle, and a folded blanket. A restless spaniel watched them leave the courtyard.\n\nAt the crossroads they paused and listened for any sound. Distant bells from the village made the search feel urgent. Elena examined the muddy path for fresh tracks. Victor noticed a golden thread caught on a low branch. They followed that clue down toward the marsh.\n\nThere, silent and anxious, the heron waited under a wagon. Elena approached slowly so it would not escape again. The lantern made a narrow circle of light around them. They offered water and wrapped the heron in the blanket.",
    level: 96,
    kind: "book",
  },
  {
    id: "l096-001",
    text: "A solemn rain settled over the hillside just as Theo reached the door. Naomi pulled them inside and shut the restless shutters. Water drummed on the roof until ordinary talk became difficult. They set a kettle on the stove and wrapped a curious blanket around the heron.\n\nLightning made the courtyard look ancient and strange. Theo examined a leak near the window and placed a pan beneath it. The spaniel vanished under a bench and would not come out. For an hour they waited, listening, while the storm refused to move on. Then the wind shifted and the rain became a narrow, silver curtain.\n\nNaomi opened the door a little and smelled the wet orchard. They put on coats and carried the lantern toward the hillside path. Puddles reflected the golden edge of a distant break in the clouds. A silent wagon stood where they had left it, heavier with rain.",
    level: 96,
    kind: "book",
  },
  {
    id: "l096-002",
    text: "Felix had an anxious morning at the hillside until Naomi arrived. A wagon had tipped, and a curious heron lay among scattered tools. They examined the damage before they moved a single piece. Naomi gathered nails and rope while Felix calmed the restless spaniel.\n\nThe courtyard was narrow, so every step had to be careful. Together they lifted the wagon back onto its wheels. A silent crowd from the village paused at the gate to watch. Felix offered water and would not let Naomi rush. By noon the workshop looked orderly again.\n\nThey discovered a cracked lantern and set it aside to mend. The golden light on the hillside made the remaining work easier. Naomi swept the last shavings into a bundle. Felix wrote a list of what still needed repair.",
    level: 96,
    kind: "book",
  },
  {
    id: "l096-003",
    text: "After the lamps were lit, Jonah led Marcus to the silent hillside. A vivid belt of stars hung above the distant lighthouse. They brought a curious blanket and a thermos, and they sat without hurry. The heron made one low sound, then accepted the dark.\n\nMarcus tried to count the brightest points and soon lost track. A restless satellite slid between them, too even to be a star. Jonah explained how sailors once used a compass and the sky together. The hillside smelled of orchard leaves and cold stone. Far off, a wagon creaked along the village road and vanished.\n\nThey spoke softly so they would not startle the spaniel. When a bank of cloud approached, the stars went out in groups. Marcus folded the blanket and kept the lantern shuttered. The walk home felt shorter than the walk out.",
    level: 96,
    kind: "book",
  },
  {
    id: "l096-004",
    text: "Amelia reached the hillside early, while the stalls were still being arranged. Priya carried the satchel and the list, folded so it would not tear. They needed a curious heron, a kettle, and thread the color of wheat. The harbor wind made the canvas roofs billow like sails.\n\nA distant bell told them they should not linger too long. They examined fruit with care and chose only what was sound. The spaniel at the potter's stall watched every movement. Amelia counted coins into the merchant's hand and waited for change. At the workshop corner they found the thread after a short search.\n\nThey paused at the courtyard fountain to rearrange the bundle. Nothing rattled, which meant they had packed well. On the hillside path home, the village looked small and busy below them. Priya admitted the market felt less anxious when they had a plan.",
    level: 96,
    kind: "book",
  },
  {
    id: "l096-005",
    text: "Marcus and Camille chose a narrow space between the hillside wall and the orchard. They measured with a stick so the curious blanket would not sag. A lantern, a satchel, and a folded heron became the furniture. The first roof collapsed, and they examined why without blaming each other.\n\nRope from the workshop and a spare wagon board solved the problem. A curious spaniel inspected the doorway and then lost interest. Inside, the courtyard noise grew distant. They posted a solemn sign that said visitors should knock. Camille brought the compass so they could pretend the fort was a ship.\n\nGolden dust floated in the single beam of light. When the hillside wind rose, the walls trembled but did not fall. They waited out the gust, then laughed with relief. Marcus wrote a list of improvements on the back of an envelope.",
    level: 96,
    kind: "book",
  },
  {
    id: "l096-006",
    text: "The hillside had risen overnight, and Harriet stared at the restless water. Theo refused to turn back until they had examined every option. A curious plank from an old wagon lay half buried in the marsh grass. They pulled it free and tested it across the narrowest span.\n\nThe far end slipped, so they anchored it with a heavy stone. A silent heron in the satchel made the crossing feel more serious. Harriet went first, eyes on the hillside rather than the current. Theo waited until the plank stopped trembling, then followed. The spaniel they had seen earlier had already vanished downstream.\n\nWet boots squelched, but no one had fallen. They left the plank in place, a gift for whoever came next. Golden light on the canyon wall made the far path look easy. It was not easy, only possible, which was enough.",
    level: 96,
    kind: "book",
  },
  {
    id: "l096-007",
    text: "The envelope on the table was addressed to Felix in a solemn, unfamiliar hand. Inside, Harriet asked for a meeting at the hillside before the harbor bells. Felix felt curious and a little anxious, then packed a curious coat. A folded map had been tucked behind the note, marked with one small cross.\n\nThe heron in the courtyard watched Felix leave as if it understood. At the crossroads the wind made the paper flutter, so Felix held it flat. Harriet waited near the lighthouse with a lantern not yet lit. They examined the map together and discovered a second mark on the back. It was not a secret so much as a careful surprise.\n\nHarriet had found a quiet orchard path that Felix had never taken. They walked it while the spaniel kept to the hedges. Golden evening made the village roofs look close enough to touch. On the return, they agreed that letters can still matter.",
    level: 96,
    kind: "book",
  },
  {
    id: "l096-008",
    text: "While clearing the hillside, Camille struck something harder than roots. Amelia knelt and brushed the soil from a curious heron. They stopped using the spade and switched to their hands. A silent spaniel watched from the orchard wall as if the work were a play.\n\nThe object had a mark they did not recognize. They carried it to the workshop and examined it under the lantern. Camille thought it might be part of an old compass housing. Amelia was less sure and wanted to ask at the village library. They wrapped it in a blanket so it would not knock against the satchel.\n\nGolden dust still clung to the grooves no matter how they wiped. At the library a woman said it was likely a hinge from a lost gate. That was less glamorous than treasure, and somehow better. They returned it to the courtyard with a note about where it had been found.",
    level: 96,
    kind: "book",
  },
  {
    id: "l096-009",
    text: "The hillside was larger than Victor had imagined, and for a moment they stopped in the courtyard. Victor waited without rushing them, which helped more than words. Inside, a curious heron occupied a shelf as if it had always been there. Voices echoed in the narrow hall, then softened as a door closed.\n\nThey were shown a quiet room and asked to wait. Victor studied the golden lettering on a distant board to keep from fidgeting. A restless spaniel in the yard made a sound that felt like home. When someone finally explained the work, it was simpler than the building had suggested. They completed a small task and were thanked as if it mattered.\n\nThat thank-you changed the size of the place. On the hillside walk back, Victor admitted the fear had been mostly of not knowing. Victor said not knowing is a kind of beginning. The village looked ordinary and kind below them.",
    level: 96,
    kind: "book",
  },
  {
    id: "l096-010",
    text: "At the hillside, Priya checked the oars while Felix studied the curious surface of the water. They shoved off and felt the boat become suddenly alive. A lantern stayed unlit in the bow because the morning was already bright. The heron in its basket protested, then accepted the motion.\n\nThey kept to the harbor wall until their strokes matched. A distant whistle from the lighthouse reminded them of the time. When a narrow wake from a larger boat reached them, they paused and rode it. The spaniel surfaced once, curious, and vanished without a splash. Felix wanted to cross toward the orchard shore, but Priya said not yet.\n\nSkill first, distance later, had been the rule. They returned in a wide arc and approached the dock against the drift. Tying up took three tries and no embarrassment. Golden light made the wet boards look new.",
    level: 96,
    kind: "book",
  },
  {
    id: "l096-011",
    text: "By late afternoon the hillside had become a maze of similar trunks. Silas admitted they were lost before Elena had to say it. They sat on a curious log and examined their choices without panic. The compass in the satchel, unused until now, became the most important object they carried.\n\nA silent heron watched from a low branch while they argued about east. They chose a bearing and walked it, marking trees with a small scrape. The spaniel they startled did not run toward water, which told them something. Distant village sounds arrived like a rumor, then like a fact. When the orchard wall appeared, they did not run; they were too tired and too careful.\n\nThe courtyard gate clicked with a sound that felt like a sentence ending. They told the truth at once, including the part where they had ignored the first doubt. Supper tasted like a reward they had not quite earned. That night Silas placed the compass on the shelf where it could be seen.",
    level: 96,
    kind: "book",
  },
  {
    id: "l097-000",
    text: "Felix hesitated at the threshold of the observatory, clutching an extraordinary note about the missing chameleon. The handwriting was intricate, and every line demanded meticulous attention. Priya had already begun a relentless search along the peninsula before dawn. A luminous haze hung over the reservoir, making even familiar stones look unfamiliar. They understood that the expedition could not succeed if they separated for long.\n\nBelow the observatory, a tempestuous wind swept the water into astonishing ridges. Felix deciphered a second remark in the margin of the manuscript and changed course. The magnificent chameleon had not wandered; something formidable had startled it. Priya contemplated the tracks near the sanctuary and summoned Victor for help. Together they navigated a labyrinth of hedges that the storm had twisted overnight.\n\nAt last they ascertained the chameleon's hiding place beneath an abandoned arch. It was melancholy and exhausted, yet it recognized Felix's voice at once. They wrapped it in a dense cloak and illuminated the path with a shielded lantern. The peregrine that had followed them kept a respectful distance until the courtyard.",
    level: 97,
    kind: "book",
  },
  {
    id: "l097-001",
    text: "A tempestuous downpour struck the observatory with relentless force just as Camille arrived. The magnificent doors of the sanctuary shuddered, and Camille struggled to bar them. Rain illuminated by lightning turned the reservoir into an astonishing, broken mirror. They abandoned the outer steps and retreated into the archive with the magnificent chameleon. Every corridor sounded like a subterranean river, and conversation became almost impossible.\n\nCamille investigated a leak above an intricate manuscript and moved the pages in time. Victor contemplated the barometer and predicted the storm would endure until twilight. A melancholy peregrine had followed them inside and now trembled beside a stone bench. They wrapped it in a dense cloak and waited for the formidable thunder to recede. When a luminous gap finally opened, they navigated the flooded courtyard with extreme care.\n\nThe peninsula path had become a shallow labyrinth of rivulets and fallen branches. Camille ascertained that the conservatory glass had held, though one pane was cracked. They deciphered faint footprints leading toward the observatory and chose not to follow. Safety, not curiosity, had to govern the remainder of the expedition.",
    level: 97,
    kind: "book",
  },
  {
    id: "l097-002",
    text: "Theo's workshop at the observatory was in formidable disarray when Victor arrived. An avalanche of crates had collapsed, burying an intricate chameleon beneath canvas. They investigated the wreckage with meticulous care so nothing fragile would shatter. Victor summoned extra hands from the cathedral steps, but Victor insisted on a plan first. A relentless drip from the conservatory roof threatened the remaining manuscripts.\n\nThey navigated the labyrinth of fallen timber and established a clear aisle. Theo contemplated the cracked axle and ascertained that it could still be saved. The magnificent chameleon was extraordinary but not irreplaceable; the people were. Together they endured an hour of lifting that left their shoulders luminous with dust. A melancholy peregrine watched from the sanctuary wall until the noise subsided.\n\nVictor negotiated with a passing wagoner for a sturdier beam. By twilight the observatory of clutter had become a usable room again. They abandoned haste and checked every shelf twice. The peninsula wind cooled the courtyard as they locked the archive door.",
    level: 97,
    kind: "book",
  },
  {
    id: "l097-003",
    text: "Priya and Silas climbed the promontory above the observatory to study the extraordinary night. The constellation they sought was intricate and easily lost among neighboring lights. A luminous haze from the distant cathedral made the lower sky less useful. They spread a meticulous star chart on a formidable slab of stone. Victor had lent them a manuscript of annotations that Priya now deciphered.\n\nThe magnificent wind was tempestuous at the ridge, so they anchored the pages with the lantern. A melancholy owl called from the sanctuary woods and then fell silent. Silas contemplated the reservoir below, where reflected stars shattered and reformed. They ascertained the correct azimuth only after the expedition's third careful measurement. The chameleon in its carrying sling remained astonishingly still, as if it understood the work.\n\nWhen a bank of cloud advanced, they abandoned the remaining observations without argument. Navigating the labyrinth of switchbacks in the dark required the shielded lamp. The peregrine that had followed at a distance stopped at the observatory gate. Inside the archive they recorded times, magnitudes, and the color of the seeing.",
    level: 97,
    kind: "book",
  },
  {
    id: "l097-004",
    text: "Silas entered the observatory with a meticulous list and an extraordinary amount of patience. The amphitheater of stalls was already formidable, and the air smelled of spice and wet stone. Amelia navigated toward the conservatory merchants who sold the magnificent chameleon they required. A tempestuous argument at a neighboring table made them choose a quieter aisle. They investigated each sample with the same care they would give a laboratory specimen.\n\nVictor had asked for a manuscript of recipes, which Silas eventually ascertained in the archive stall. The lantern-lit peninsula of book tables felt like a sanctuary amid the noise. They deciphered prices written in several hands and refused the first astonishing demand. A melancholy peregrine sat on a crate as if it were the market's unofficial witness. When the satchel was full, they negotiated a fair total and counted the remaining coins twice.\n\nLeaving, they endured the crush near the cathedral steps without dropping a parcel. The reservoir road home was luminous with late sun, and the wind had finally relented. Amelia contemplated how much of the expedition had been waiting rather than buying. They abandoned nothing on the path, though a rolled chart tried to slip free.",
    level: 97,
    kind: "book",
  },
  {
    id: "l097-005",
    text: "Elena proposed an extraordinary refuge on the leeward side of the observatory. Naomi agreed, provided the structure was meticulous enough to endure a tempestuous night. They gathered canvas, cord, a formidable crate, and the magnificent chameleon from the archive loft. The first design was intricate and promptly failed, which they treated as useful information. Victor offered advice from the conservatory steps but did not take over the work.\n\nTogether they navigated the problem of tension, anchoring each corner to stone. A luminous interior resulted when they angled a shielded lantern toward the roof. The peregrine investigated, then abandoned the doorway as insufficiently interesting. They contemplated names until Elena suggested one that was astonishing in its simplicity. Maps from a manuscript of old expeditions were pinned along the inner wall.\n\nWhen wind struck the peninsula, the sanctuary flexed and then held. They ascertained the weak point and reinforced it before pride could make them careless. Night converted the fort into a laboratory of shadows and whispered plans. They recorded what still needed mending so tomorrow's work would not begin in confusion.",
    level: 97,
    kind: "book",
  },
  {
    id: "l097-006",
    text: "Overnight rain had turned the observatory into a formidable, luminous torrent. Theo contemplated retreat, but Felix argued that the expedition had already come too far. They investigated the banks with meticulous patience, refusing the first tempting stone. An abandoned beam from the old mill lay in the reeds like an answer they had not earned yet. Together they navigated it into position and ascertained that the far ledge would hold.\n\nThe magnificent chameleon in the satchel seemed an extraordinary responsibility above that water. Victor waited on the opposite promontory, unable to help except by staying visible. Theo crossed first, enduring the flex of wood and the astonishing noise below. Felix followed only when the beam had ceased its restless shivering. A melancholy peregrine watched from a midstream rock and did not move.\n\nThey abandoned the idea of retrieving the beam; it would serve the next traveler. On the sanctuary side they sat until their breath and the river sounded separate again. The cathedral of trees closed overhead, cooler and darker than the bank they had left. They deciphered the map's next mark and found they were still on course.",
    level: 97,
    kind: "book",
  },
  {
    id: "l097-007",
    text: "An extraordinary envelope awaited Naomi on the observatory desk, sealed with unfamiliar wax. The manuscript inside was from Elena, and its request was meticulous: come to the observatory at twilight. A second page contained an intricate map of the peninsula, annotated in two colors. Naomi contemplated the magnificent implications, then packed a lantern, a compass, and a dense cloak. The chameleon remaining in the sanctuary seemed to sense that this was not an ordinary errand.\n\nNavigating the laboratory corridor, Naomi deciphered a postscript that changed the meeting point. Elena was already at the amphitheater steps, restless but relieved. They ascertained that the map described not a treasure but a safe route around a collapsed wall. Naomi had discovered the damage that morning and needed them to warn the archive keepers. A formidable wind off the reservoir made conversation difficult, so they used the chart as they walked.\n\nThe peregrine that accompanied them kept to the luminous edge of the path. At the cathedral gate they delivered the warning and refused any payment. The expedition home was melancholy and quiet, as necessary tasks often are. They abandoned the idea of turning the letter into a story; it had already been enough.",
    level: 97,
    kind: "book",
  },
  {
    id: "l097-008",
    text: "Jonah was turning soil at the observatory when the spade rang against something extraordinary. Priya insisted they proceed with meticulous care, as if the ground were an archive. What emerged was an intricate, magnificent chameleon whose purpose was not immediately obvious. They abandoned further digging until they could illuminate the object properly. In the laboratory of the conservatory bench, they brushed away a century of grit.\n\nNaomi contemplated the markings and thought they resembled a constellation rather than a maker's stamp. A melancholy peregrine kept vigil on the sanctuary wall throughout the examination. They deciphered enough to ascertain that the piece had belonged to a surveying expedition. The peninsula's old maps, stored in the cathedral loft, showed a similar instrument. Rather than keep it, they negotiated its transfer to the observatory collection.\n\nThe formidable joy of discovery, they realized, does not require ownership. They returned to the garden and restored every clod they had displaced. Luminous evening made the freshly turned earth look almost ceremonial. Their hands remained stained, a record the soap would only slowly erase.",
    level: 97,
    kind: "book",
  },
  {
    id: "l097-009",
    text: "Amelia paused on the threshold of the observatory, astonished by its magnificent scale. Jonah did not hurry them; formidable buildings are best entered at their own pace. The interior was a luminous labyrinth of corridors, glass, and hushed conversation. An intricate magnificent chameleon occupied a pedestal as if it were the institution's quiet heart. Naomi met them with a manuscript of instructions that Amelia deciphered more slowly than usual.\n\nA melancholy echo made even small sounds seem ceremonial. They were led to a laboratory annex where the actual work turned out to be humanly sized. Completing the first task, they ascertained that competence is a cure for awe. The peregrine visible through the conservatory glass looked like an ambassador from ordinary life. When they left, the amphitheater of steps no longer felt like a judgment.\n\nThe peninsula wind on the way home was tempestuous and oddly comforting. Jonah contemplated how often fear is simply the mind trying to map a new archive. They abandoned the idea that they had to understand everything on the first day. Night converted the memory of the building from threat into a place that could be returned to.",
    level: 97,
    kind: "book",
  },
  {
    id: "l097-010",
    text: "Marcus inspected the hull at the observatory with meticulous attention before they embarked. Theo contemplated the extraordinary calm of the reservoir and did not trust it completely. They shoved off into a luminous, barely rippled expanse that still required respect. The magnificent chameleon rode in a sealed crate, an astonishing passenger for such a small craft. Stroke by stroke they navigated away from the sanctuary wall toward deeper water.\n\nA tempestuous gust arrived without warning and turned the bow a formidable few degrees. They endured it by shipping one oar and letting the boat find its new line. Naomi, watching from the promontory, raised a hand when they had gone far enough. The peregrine that surfaced beside them seemed like a brief, melancholy escort. They ascertained their position against the cathedral spire and began the return.\n\nApproaching the dock, they abandoned pride and took an extra circle to line up properly. The landing was not magnificent, only competent, which was the point of the expedition. They recorded wind, time, and drift in a damp notebook from the archive pouch. Rope burns and wet sleeves were the only injuries, and they counted that as success.",
    level: 97,
    kind: "book",
  },
  {
    id: "l097-011",
    text: "Harriet recognized the extraordinary fact first: the observatory no longer matched any memory they trusted. Harriet contemplated the magnificent canopy and refused the urge to hurry. They investigated their last certain landmark, an intricate root like a cathedral door, and could not find it again. The compass, neglected at the start of the expedition, now governed every decision. A formidable quiet settled; even the chameleon in the understory had stopped moving.\n\nThey navigated by bearing rather than by hope, marking the labyrinth so they could detect a circle. Naomi would already be waiting at the sanctuary, which made delay feel like a kind of theft. When a melancholy peregrine crossed their path, they noted the direction it fled and used that as weak evidence of water. Luminous gaps in the canopy eventually revealed the observatory ridge, astonishingly farther left than expected. They ascertained a new course and endured the last mile without conversation.\n\nThe archive of their mistakes would be written down that night, not hidden. At the peninsula wall they abandoned dignity and sat until their legs would hold a civil walk home. Truth, told immediately, turned fear into a usable lesson instead of a secret. They placed the map and compass together on the laboratory shelf as a single instrument.",
    level: 97,
    kind: "book",
  },
  {
    id: "l098-000",
    text: "Naomi hesitated at the threshold of the observatory, clutching an extraordinary note about the missing chameleon. The handwriting was intricate, and every line demanded meticulous attention. Amelia had already begun a relentless search along the peninsula before dawn. A luminous haze hung over the reservoir, making even familiar stones look unfamiliar. They understood that the expedition could not succeed if they separated for long.\n\nBelow the observatory, a tempestuous wind swept the water into astonishing ridges. Naomi deciphered a second remark in the margin of the manuscript and changed course. The magnificent chameleon had not wandered; something formidable had startled it. Amelia contemplated the tracks near the sanctuary and summoned Naomi for help. Together they navigated a labyrinth of hedges that the storm had twisted overnight.\n\nAt last they ascertained the chameleon's hiding place beneath an abandoned arch. It was melancholy and exhausted, yet it recognized Naomi's voice at once. They wrapped it in a dense cloak and illuminated the path with a shielded lantern. The peregrine that had followed them kept a respectful distance until the courtyard.",
    level: 98,
    kind: "book",
  },
  {
    id: "l098-001",
    text: "A tempestuous downpour struck the observatory with relentless force just as Jonah arrived. The magnificent doors of the sanctuary shuddered, and Naomi struggled to bar them. Rain illuminated by lightning turned the reservoir into an astonishing, broken mirror. They abandoned the outer steps and retreated into the archive with the magnificent chameleon. Every corridor sounded like a subterranean river, and conversation became almost impossible.\n\nJonah investigated a leak above an intricate manuscript and moved the pages in time. Naomi contemplated the barometer and predicted the storm would endure until twilight. A melancholy peregrine had followed them inside and now trembled beside a stone bench. They wrapped it in a dense cloak and waited for the formidable thunder to recede. When a luminous gap finally opened, they navigated the flooded courtyard with extreme care.\n\nThe peninsula path had become a shallow labyrinth of rivulets and fallen branches. Naomi ascertained that the conservatory glass had held, though one pane was cracked. They deciphered faint footprints leading toward the observatory and chose not to follow. Safety, not curiosity, had to govern the remainder of the expedition.",
    level: 98,
    kind: "book",
  },
  {
    id: "l098-002",
    text: "Felix's workshop at the observatory was in formidable disarray when Amelia arrived. An avalanche of crates had collapsed, burying an intricate chameleon beneath canvas. They investigated the wreckage with meticulous care so nothing fragile would shatter. Naomi summoned extra hands from the cathedral steps, but Amelia insisted on a plan first. A relentless drip from the conservatory roof threatened the remaining manuscripts.\n\nThey navigated the labyrinth of fallen timber and established a clear aisle. Felix contemplated the cracked axle and ascertained that it could still be saved. The magnificent chameleon was extraordinary but not irreplaceable; the people were. Together they endured an hour of lifting that left their shoulders luminous with dust. A melancholy peregrine watched from the sanctuary wall until the noise subsided.\n\nAmelia negotiated with a passing wagoner for a sturdier beam. By twilight the observatory of clutter had become a usable room again. They abandoned haste and checked every shelf twice. The peninsula wind cooled the courtyard as they locked the archive door.",
    level: 98,
    kind: "book",
  },
  {
    id: "l098-003",
    text: "Marcus and Marcus climbed the promontory above the observatory to study the extraordinary night. The constellation they sought was intricate and easily lost among neighboring lights. A luminous haze from the distant cathedral made the lower sky less useful. They spread a meticulous star chart on a formidable slab of stone. Felix had lent them a manuscript of annotations that Marcus now deciphered.\n\nThe magnificent wind was tempestuous at the ridge, so they anchored the pages with the lantern. A melancholy owl called from the sanctuary woods and then fell silent. Marcus contemplated the reservoir below, where reflected stars shattered and reformed. They ascertained the correct azimuth only after the expedition's third careful measurement. The chameleon in its carrying sling remained astonishingly still, as if it understood the work.\n\nWhen a bank of cloud advanced, they abandoned the remaining observations without argument. Navigating the labyrinth of switchbacks in the dark required the shielded lamp. The peregrine that had followed at a distance stopped at the observatory gate. Inside the archive they recorded times, magnitudes, and the color of the seeing.",
    level: 98,
    kind: "book",
  },
  {
    id: "l098-004",
    text: "Harriet entered the observatory with a meticulous list and an extraordinary amount of patience. The amphitheater of stalls was already formidable, and the air smelled of spice and wet stone. Priya navigated toward the conservatory merchants who sold the magnificent chameleon they required. A tempestuous argument at a neighboring table made them choose a quieter aisle. They investigated each sample with the same care they would give a laboratory specimen.\n\nFelix had asked for a manuscript of recipes, which Harriet eventually ascertained in the archive stall. The lantern-lit peninsula of book tables felt like a sanctuary amid the noise. They deciphered prices written in several hands and refused the first astonishing demand. A melancholy peregrine sat on a crate as if it were the market's unofficial witness. When the satchel was full, they negotiated a fair total and counted the remaining coins twice.\n\nLeaving, they endured the crush near the cathedral steps without dropping a parcel. The reservoir road home was luminous with late sun, and the wind had finally relented. Priya contemplated how much of the expedition had been waiting rather than buying. They abandoned nothing on the path, though a rolled chart tried to slip free.",
    level: 98,
    kind: "book",
  },
  {
    id: "l098-005",
    text: "Felix proposed an extraordinary refuge on the leeward side of the observatory. Jonah agreed, provided the structure was meticulous enough to endure a tempestuous night. They gathered canvas, cord, a formidable crate, and the magnificent chameleon from the archive loft. The first design was intricate and promptly failed, which they treated as useful information. Felix offered advice from the conservatory steps but did not take over the work.\n\nTogether they navigated the problem of tension, anchoring each corner to stone. A luminous interior resulted when they angled a shielded lantern toward the roof. The peregrine investigated, then abandoned the doorway as insufficiently interesting. They contemplated names until Felix suggested one that was astonishing in its simplicity. Maps from a manuscript of old expeditions were pinned along the inner wall.\n\nWhen wind struck the peninsula, the sanctuary flexed and then held. They ascertained the weak point and reinforced it before pride could make them careless. Night converted the fort into a laboratory of shadows and whispered plans. They recorded what still needed mending so tomorrow's work would not begin in confusion.",
    level: 98,
    kind: "book",
  },
  {
    id: "l098-006",
    text: "Overnight rain had turned the observatory into a formidable, luminous torrent. Camille contemplated retreat, but Theo argued that the expedition had already come too far. They investigated the banks with meticulous patience, refusing the first tempting stone. An abandoned beam from the old mill lay in the reeds like an answer they had not earned yet. Together they navigated it into position and ascertained that the far ledge would hold.\n\nThe magnificent chameleon in the satchel seemed an extraordinary responsibility above that water. Felix waited on the opposite promontory, unable to help except by staying visible. Camille crossed first, enduring the flex of wood and the astonishing noise below. Theo followed only when the beam had ceased its restless shivering. A melancholy peregrine watched from a midstream rock and did not move.\n\nThey abandoned the idea of retrieving the beam; it would serve the next traveler. On the sanctuary side they sat until their breath and the river sounded separate again. The cathedral of trees closed overhead, cooler and darker than the bank they had left. They deciphered the map's next mark and found they were still on course.",
    level: 98,
    kind: "book",
  },
  {
    id: "l098-007",
    text: "An extraordinary envelope awaited Victor on the observatory desk, sealed with unfamiliar wax. The manuscript inside was from Harriet, and its request was meticulous: come to the observatory at twilight. A second page contained an intricate map of the peninsula, annotated in two colors. Victor contemplated the magnificent implications, then packed a lantern, a compass, and a dense cloak. The chameleon remaining in the sanctuary seemed to sense that this was not an ordinary errand.\n\nNavigating the laboratory corridor, Victor deciphered a postscript that changed the meeting point. Harriet was already at the amphitheater steps, restless but relieved. They ascertained that the map described not a treasure but a safe route around a collapsed wall. Felix had discovered the damage that morning and needed them to warn the archive keepers. A formidable wind off the reservoir made conversation difficult, so they used the chart as they walked.\n\nThe peregrine that accompanied them kept to the luminous edge of the path. At the cathedral gate they delivered the warning and refused any payment. The expedition home was melancholy and quiet, as necessary tasks often are. They abandoned the idea of turning the letter into a story; it had already been enough.",
    level: 98,
    kind: "book",
  },
  {
    id: "l098-008",
    text: "Priya was turning soil at the observatory when the spade rang against something extraordinary. Amelia insisted they proceed with meticulous care, as if the ground were an archive. What emerged was an intricate, magnificent chameleon whose purpose was not immediately obvious. They abandoned further digging until they could illuminate the object properly. In the laboratory of the conservatory bench, they brushed away a century of grit.\n\nFelix contemplated the markings and thought they resembled a constellation rather than a maker's stamp. A melancholy peregrine kept vigil on the sanctuary wall throughout the examination. They deciphered enough to ascertain that the piece had belonged to a surveying expedition. The peninsula's old maps, stored in the cathedral loft, showed a similar instrument. Rather than keep it, they negotiated its transfer to the observatory collection.\n\nThe formidable joy of discovery, they realized, does not require ownership. They returned to the garden and restored every clod they had displaced. Luminous evening made the freshly turned earth look almost ceremonial. Their hands remained stained, a record the soap would only slowly erase.",
    level: 98,
    kind: "book",
  },
  {
    id: "l098-009",
    text: "Silas paused on the threshold of the observatory, astonished by its magnificent scale. Victor did not hurry them; formidable buildings are best entered at their own pace. The interior was a luminous labyrinth of corridors, glass, and hushed conversation. An intricate magnificent chameleon occupied a pedestal as if it were the institution's quiet heart. Felix met them with a manuscript of instructions that Silas deciphered more slowly than usual.\n\nA melancholy echo made even small sounds seem ceremonial. They were led to a laboratory annex where the actual work turned out to be humanly sized. Completing the first task, they ascertained that competence is a cure for awe. The peregrine visible through the conservatory glass looked like an ambassador from ordinary life. When they left, the amphitheater of steps no longer felt like a judgment.\n\nThe peninsula wind on the way home was tempestuous and oddly comforting. Victor contemplated how often fear is simply the mind trying to map a new archive. They abandoned the idea that they had to understand everything on the first day. Night converted the memory of the building from threat into a place that could be returned to.",
    level: 98,
    kind: "book",
  },
  {
    id: "l098-010",
    text: "Elena inspected the hull at the observatory with meticulous attention before they embarked. Felix contemplated the extraordinary calm of the reservoir and did not trust it completely. They shoved off into a luminous, barely rippled expanse that still required respect. The magnificent chameleon rode in a sealed crate, an astonishing passenger for such a small craft. Stroke by stroke they navigated away from the sanctuary wall toward deeper water.\n\nA tempestuous gust arrived without warning and turned the bow a formidable few degrees. They endured it by shipping one oar and letting the boat find its new line. Felix, watching from the promontory, raised a hand when they had gone far enough. The peregrine that surfaced beside them seemed like a brief, melancholy escort. They ascertained their position against the cathedral spire and began the return.\n\nApproaching the dock, they abandoned pride and took an extra circle to line up properly. The landing was not magnificent, only competent, which was the point of the expedition. They recorded wind, time, and drift in a damp notebook from the archive pouch. Rope burns and wet sleeves were the only injuries, and they counted that as success.",
    level: 98,
    kind: "book",
  },
  {
    id: "l098-011",
    text: "Theo recognized the extraordinary fact first: the observatory no longer matched any memory they trusted. Elena contemplated the magnificent canopy and refused the urge to hurry. They investigated their last certain landmark, an intricate root like a cathedral door, and could not find it again. The compass, neglected at the start of the expedition, now governed every decision. A formidable quiet settled; even the albatross in the understory had stopped moving.\n\nThey navigated by bearing rather than by hope, marking the labyrinth so they could detect a circle. Elena would already be waiting at the sanctuary, which made delay feel like a kind of theft. When a melancholy peregrine crossed their path, they noted the direction it fled and used that as weak evidence of water. Luminous gaps in the canopy eventually revealed the observatory ridge, astonishingly farther left than expected. They ascertained a new course and endured the last mile without conversation.\n\nThe archive of their mistakes would be written down that night, not hidden. At the peninsula wall they abandoned dignity and sat until their legs would hold a civil walk home. Truth, told immediately, turned fear into a usable lesson instead of a secret. They placed the map and compass together on the laboratory shelf as a single instrument.",
    level: 98,
    kind: "book",
  },
  {
    id: "l099-000",
    text: "Victor hesitated at the threshold of the observatory, clutching an extraordinary note about the missing albatross. The handwriting was intricate, and every line demanded meticulous attention. Priya had already begun a relentless search along the peninsula before dawn. A luminous haze hung over the reservoir, making even familiar stones look unfamiliar. They understood that the expedition could not succeed if they separated for long.\n\nBelow the observatory, a tempestuous wind swept the water into astonishing ridges. Victor deciphered a second remark in the margin of the manuscript and changed course. The magnificent albatross had not wandered; something formidable had startled it. Priya contemplated the tracks near the sanctuary and summoned Elena for help. Together they navigated a labyrinth of hedges that the storm had twisted overnight.\n\nAt last they ascertained the albatross's hiding place beneath an abandoned arch. It was melancholy and exhausted, yet it recognized Victor's voice at once. They wrapped it in a dense cloak and illuminated the path with a shielded lantern. The peregrine that had followed them kept a respectful distance until the courtyard.",
    level: 99,
    kind: "book",
  },
  {
    id: "l099-001",
    text: "A tempestuous downpour struck the observatory with relentless force just as Priya arrived. The magnificent doors of the sanctuary shuddered, and Camille struggled to bar them. Rain illuminated by lightning turned the reservoir into an astonishing, broken mirror. They abandoned the outer steps and retreated into the archive with the magnificent albatross. Every corridor sounded like a subterranean river, and conversation became almost impossible.\n\nPriya investigated a leak above an intricate manuscript and moved the pages in time. Elena contemplated the barometer and predicted the storm would endure until twilight. A melancholy peregrine had followed them inside and now trembled beside a stone bench. They wrapped it in a dense cloak and waited for the formidable thunder to recede. When a luminous gap finally opened, they navigated the flooded courtyard with extreme care.\n\nThe peninsula path had become a shallow labyrinth of rivulets and fallen branches. Camille ascertained that the conservatory glass had held, though one pane was cracked. They deciphered faint footprints leading toward the observatory and chose not to follow. Safety, not curiosity, had to govern the remainder of the expedition.",
    level: 99,
    kind: "book",
  },
  {
    id: "l099-002",
    text: "Theo's workshop at the observatory was in formidable disarray when Silas arrived. An avalanche of crates had collapsed, burying an intricate albatross beneath canvas. They investigated the wreckage with meticulous care so nothing fragile would shatter. Elena summoned extra hands from the cathedral steps, but Silas insisted on a plan first. A relentless drip from the conservatory roof threatened the remaining manuscripts.\n\nThey navigated the labyrinth of fallen timber and established a clear aisle. Theo contemplated the cracked axle and ascertained that it could still be saved. The magnificent albatross was extraordinary but not irreplaceable; the people were. Together they endured an hour of lifting that left their shoulders luminous with dust. A melancholy peregrine watched from the sanctuary wall until the noise subsided.\n\nSilas negotiated with a passing wagoner for a sturdier beam. By twilight the observatory of clutter had become a usable room again. They abandoned haste and checked every shelf twice. The peninsula wind cooled the courtyard as they locked the archive door.",
    level: 99,
    kind: "book",
  },
  {
    id: "l099-003",
    text: "Elena and Silas climbed the promontory above the observatory to study the extraordinary night. The constellation they sought was intricate and easily lost among neighboring lights. A luminous haze from the distant cathedral made the lower sky less useful. They spread a meticulous star chart on a formidable slab of stone. Elena had lent them a manuscript of annotations that Elena now deciphered.\n\nThe magnificent wind was tempestuous at the ridge, so they anchored the pages with the lantern. A melancholy owl called from the sanctuary woods and then fell silent. Silas contemplated the reservoir below, where reflected stars shattered and reformed. They ascertained the correct azimuth only after the expedition's third careful measurement. The albatross in its carrying sling remained astonishingly still, as if it understood the work.\n\nWhen a bank of cloud advanced, they abandoned the remaining observations without argument. Navigating the labyrinth of switchbacks in the dark required the shielded lamp. The peregrine that had followed at a distance stopped at the observatory gate. Inside the archive they recorded times, magnitudes, and the color of the seeing.",
    level: 99,
    kind: "book",
  },
  {
    id: "l099-004",
    text: "Theo entered the observatory with a meticulous list and an extraordinary amount of patience. The amphitheater of stalls was already formidable, and the air smelled of spice and wet stone. Amelia navigated toward the conservatory merchants who sold the magnificent albatross they required. A tempestuous argument at a neighboring table made them choose a quieter aisle. They investigated each sample with the same care they would give a laboratory specimen.\n\nElena had asked for a manuscript of recipes, which Theo eventually ascertained in the archive stall. The lantern-lit peninsula of book tables felt like a sanctuary amid the noise. They deciphered prices written in several hands and refused the first astonishing demand. A melancholy peregrine sat on a crate as if it were the market's unofficial witness. When the satchel was full, they negotiated a fair total and counted the remaining coins twice.\n\nLeaving, they endured the crush near the cathedral steps without dropping a parcel. The reservoir road home was luminous with late sun, and the wind had finally relented. Amelia contemplated how much of the expedition had been waiting rather than buying. They abandoned nothing on the path, though a rolled chart tried to slip free.",
    level: 99,
    kind: "book",
  },
  {
    id: "l099-005",
    text: "Naomi proposed an extraordinary refuge on the leeward side of the observatory. Victor agreed, provided the structure was meticulous enough to endure a tempestuous night. They gathered canvas, cord, a formidable crate, and the magnificent albatross from the archive loft. The first design was intricate and promptly failed, which they treated as useful information. Elena offered advice from the conservatory steps but did not take over the work.\n\nTogether they navigated the problem of tension, anchoring each corner to stone. A luminous interior resulted when they angled a shielded lantern toward the roof. The peregrine investigated, then abandoned the doorway as insufficiently interesting. They contemplated names until Naomi suggested one that was astonishing in its simplicity. Maps from a manuscript of old expeditions were pinned along the inner wall.\n\nWhen wind struck the peninsula, the sanctuary flexed and then held. They ascertained the weak point and reinforced it before pride could make them careless. Night converted the fort into a laboratory of shadows and whispered plans. They recorded what still needed mending so tomorrow's work would not begin in confusion.",
    level: 99,
    kind: "book",
  },
  {
    id: "l099-006",
    text: "Overnight rain had turned the observatory into a formidable, luminous torrent. Jonah contemplated retreat, but Felix argued that the expedition had already come too far. They investigated the banks with meticulous patience, refusing the first tempting stone. An abandoned beam from the old mill lay in the reeds like an answer they had not earned yet. Together they navigated it into position and ascertained that the far ledge would hold.\n\nThe magnificent albatross in the satchel seemed an extraordinary responsibility above that water. Elena waited on the opposite promontory, unable to help except by staying visible. Jonah crossed first, enduring the flex of wood and the astonishing noise below. Felix followed only when the beam had ceased its restless shivering. A melancholy peregrine watched from a midstream rock and did not move.\n\nThey abandoned the idea of retrieving the beam; it would serve the next traveler. On the sanctuary side they sat until their breath and the river sounded separate again. The cathedral of trees closed overhead, cooler and darker than the bank they had left. They deciphered the map's next mark and found they were still on course.",
    level: 99,
    kind: "book",
  },
  {
    id: "l099-007",
    text: "An extraordinary envelope awaited Amelia on the observatory desk, sealed with unfamiliar wax. The manuscript inside was from Elena, and its request was meticulous: come to the observatory at twilight. A second page contained an intricate map of the peninsula, annotated in two colors. Amelia contemplated the magnificent implications, then packed a lantern, a compass, and a dense cloak. The albatross remaining in the sanctuary seemed to sense that this was not an ordinary errand.\n\nNavigating the laboratory corridor, Amelia deciphered a postscript that changed the meeting point. Elena was already at the amphitheater steps, restless but relieved. They ascertained that the map described not a treasure but a safe route around a collapsed wall. Marcus had discovered the damage that morning and needed them to warn the archive keepers. A formidable wind off the reservoir made conversation difficult, so they used the chart as they walked.\n\nThe peregrine that accompanied them kept to the luminous edge of the path. At the cathedral gate they delivered the warning and refused any payment. The expedition home was melancholy and quiet, as necessary tasks often are. They abandoned the idea of turning the letter into a story; it had already been enough.",
    level: 99,
    kind: "book",
  },
  {
    id: "l099-008",
    text: "Marcus was turning soil at the observatory when the spade rang against something extraordinary. Priya insisted they proceed with meticulous care, as if the ground were an archive. What emerged was an intricate, magnificent albatross whose purpose was not immediately obvious. They abandoned further digging until they could illuminate the object properly. In the laboratory of the conservatory bench, they brushed away a century of grit.\n\nMarcus contemplated the markings and thought they resembled a constellation rather than a maker's stamp. A melancholy peregrine kept vigil on the sanctuary wall throughout the examination. They deciphered enough to ascertain that the piece had belonged to a surveying expedition. The peninsula's old maps, stored in the cathedral loft, showed a similar instrument. Rather than keep it, they negotiated its transfer to the observatory collection.\n\nThe formidable joy of discovery, they realized, does not require ownership. They returned to the garden and restored every clod they had displaced. Luminous evening made the freshly turned earth look almost ceremonial. Their hands remained stained, a record the soap would only slowly erase.",
    level: 99,
    kind: "book",
  },
  {
    id: "l099-009",
    text: "Harriet paused on the threshold of the observatory, astonished by its magnificent scale. Jonah did not hurry them; formidable buildings are best entered at their own pace. The interior was a luminous labyrinth of corridors, glass, and hushed conversation. An intricate magnificent albatross occupied a pedestal as if it were the institution's quiet heart. Marcus met them with a manuscript of instructions that Harriet deciphered more slowly than usual.\n\nA melancholy echo made even small sounds seem ceremonial. They were led to a laboratory annex where the actual work turned out to be humanly sized. Completing the first task, they ascertained that competence is a cure for awe. The peregrine visible through the conservatory glass looked like an ambassador from ordinary life. When they left, the amphitheater of steps no longer felt like a judgment.\n\nThe peninsula wind on the way home was tempestuous and oddly comforting. Jonah contemplated how often fear is simply the mind trying to map a new archive. They abandoned the idea that they had to understand everything on the first day. Night converted the memory of the building from threat into a place that could be returned to.",
    level: 99,
    kind: "book",
  },
  {
    id: "l099-010",
    text: "Felix inspected the hull at the observatory with meticulous attention before they embarked. Camille contemplated the extraordinary calm of the reservoir and did not trust it completely. They shoved off into a luminous, barely rippled expanse that still required respect. The magnificent albatross rode in a sealed crate, an astonishing passenger for such a small craft. Stroke by stroke they navigated away from the sanctuary wall toward deeper water.\n\nA tempestuous gust arrived without warning and turned the bow a formidable few degrees. They endured it by shipping one oar and letting the boat find its new line. Marcus, watching from the promontory, raised a hand when they had gone far enough. The peregrine that surfaced beside them seemed like a brief, melancholy escort. They ascertained their position against the cathedral spire and began the return.\n\nApproaching the dock, they abandoned pride and took an extra circle to line up properly. The landing was not magnificent, only competent, which was the point of the expedition. They recorded wind, time, and drift in a damp notebook from the archive pouch. Rope burns and wet sleeves were the only injuries, and they counted that as success.",
    level: 99,
    kind: "book",
  },
  {
    id: "l099-011",
    text: "Camille recognized the extraordinary fact first: the observatory no longer matched any memory they trusted. Harriet contemplated the magnificent canopy and refused the urge to hurry. They investigated their last certain landmark, an intricate root like a cathedral door, and could not find it again. The compass, neglected at the start of the expedition, now governed every decision. A formidable quiet settled; even the albatross in the understory had stopped moving.\n\nThey navigated by bearing rather than by hope, marking the labyrinth so they could detect a circle. Marcus would already be waiting at the sanctuary, which made delay feel like a kind of theft. When a melancholy peregrine crossed their path, they noted the direction it fled and used that as weak evidence of water. Luminous gaps in the canopy eventually revealed the observatory ridge, astonishingly farther left than expected. They ascertained a new course and endured the last mile without conversation.\n\nThe archive of their mistakes would be written down that night, not hidden. At the peninsula wall they abandoned dignity and sat until their legs would hold a civil walk home. Truth, told immediately, turned fear into a usable lesson instead of a secret. They placed the map and compass together on the laboratory shelf as a single instrument.",
    level: 99,
    kind: "book",
  },
  {
    id: "l100-000",
    text: "Amelia hesitated at the threshold of the observatory, clutching an extraordinary note about the missing albatross. The handwriting was intricate, and every line demanded meticulous attention. Amelia had already begun a relentless search along the peninsula before dawn. A luminous haze hung over the reservoir, making even familiar stones look unfamiliar. They understood that the expedition could not succeed if they separated for long.\n\nBelow the observatory, a tempestuous wind swept the water into astonishing ridges. Amelia deciphered a second remark in the margin of the manuscript and changed course. The magnificent albatross had not wandered; something formidable had startled it. Amelia contemplated the tracks near the sanctuary and summoned Marcus for help. Together they navigated a labyrinth of hedges that the storm had twisted overnight. At last they ascertained the albatross's hiding place beneath an abandoned arch.\n\nIt was melancholy and exhausted, yet it recognized Amelia's voice at once. They wrapped it in a dense cloak and illuminated the path with a shielded lantern. The peregrine that had followed them kept a respectful distance until the courtyard. Marcus negotiated a safer route around the collapsed wall of the archive. By the time they endured the final climb, the constellation above the observatory had begun to fade.",
    level: 100,
    kind: "book",
  },
  {
    id: "l100-001",
    text: "A tempestuous downpour struck the observatory with relentless force just as Marcus arrived. The magnificent doors of the sanctuary shuddered, and Naomi struggled to bar them. Rain illuminated by lightning turned the reservoir into an astonishing, broken mirror. They abandoned the outer steps and retreated into the archive with the magnificent albatross. Every corridor sounded like a subterranean river, and conversation became almost impossible.\n\nMarcus investigated a leak above an intricate manuscript and moved the pages in time. Marcus contemplated the barometer and predicted the storm would endure until twilight. A melancholy peregrine had followed them inside and now trembled beside a stone bench. They wrapped it in a dense cloak and waited for the formidable thunder to recede. When a luminous gap finally opened, they navigated the flooded courtyard with extreme care. The peninsula path had become a shallow labyrinth of rivulets and fallen branches.\n\nNaomi ascertained that the conservatory glass had held, though one pane was cracked. They deciphered faint footprints leading toward the observatory and chose not to follow. Safety, not curiosity, had to govern the remainder of the expedition. By nightfall the cathedral bells were audible again above the remaining wind. They sat in the laboratory's dry alcove and listened to the last drops strike the roof.",
    level: 100,
    kind: "book",
  },
  {
    id: "l100-002",
    text: "Felix's workshop at the observatory was in formidable disarray when Harriet arrived. An avalanche of crates had collapsed, burying an intricate albatross beneath canvas. They investigated the wreckage with meticulous care so nothing fragile would shatter. Marcus summoned extra hands from the cathedral steps, but Harriet insisted on a plan first. A relentless drip from the conservatory roof threatened the remaining manuscripts.\n\nThey navigated the labyrinth of fallen timber and established a clear aisle. Felix contemplated the cracked axle and ascertained that it could still be saved. The magnificent albatross was extraordinary but not irreplaceable; the people were. Together they endured an hour of lifting that left their shoulders luminous with dust. A melancholy peregrine watched from the sanctuary wall until the noise subsided. Harriet negotiated with a passing wagoner for a sturdier beam.\n\nBy twilight the observatory of clutter had become a usable room again. They abandoned haste and checked every shelf twice. The peninsula wind cooled the courtyard as they locked the archive door. Felix offered thanks in a voice that was quiet and astonishingly steady. Work shared, they realized, can turn even a disastrous morning into an expedition worth remembering.",
    level: 100,
    kind: "book",
  },
  {
    id: "l100-003",
    text: "Felix and Elena climbed the promontory above the observatory to study the extraordinary night. The constellation they sought was intricate and easily lost among neighboring lights. A luminous haze from the distant cathedral made the lower sky less useful. They spread a meticulous star chart on a formidable slab of stone. Priya had lent them a manuscript of annotations that Felix now deciphered.\n\nThe magnificent wind was tempestuous at the ridge, so they anchored the pages with the lantern. A melancholy owl called from the sanctuary woods and then fell silent. Elena contemplated the reservoir below, where reflected stars shattered and reformed. They ascertained the correct azimuth only after the expedition's third careful measurement. The albatross in its carrying sling remained astonishingly still, as if it understood the work. When a bank of cloud advanced, they abandoned the remaining observations without argument.\n\nNavigating the labyrinth of switchbacks in the dark required the shielded lamp. The peregrine that had followed at a distance stopped at the observatory gate. Inside the archive they recorded times, magnitudes, and the color of the seeing. Felix wrote that the night had been magnificent even though the record was incomplete. Some knowledge, they agreed, is gathered slowly, and the sky does not hurry for anyone.",
    level: 100,
    kind: "book",
  },
  {
    id: "l100-004",
    text: "Camille entered the observatory with a meticulous list and an extraordinary amount of patience. The amphitheater of stalls was already formidable, and the air smelled of spice and wet stone. Priya navigated toward the conservatory merchants who sold the magnificent albatross they required. A tempestuous argument at a neighboring table made them choose a quieter aisle. They investigated each sample with the same care they would give a laboratory specimen.\n\nPriya had asked for a manuscript of recipes, which Camille eventually ascertained in the archive stall. The lantern-lit peninsula of book tables felt like a sanctuary amid the noise. They deciphered prices written in several hands and refused the first astonishing demand. A melancholy peregrine sat on a crate as if it were the market's unofficial witness. When the satchel was full, they negotiated a fair total and counted the remaining coins twice. Leaving, they endured the crush near the cathedral steps without dropping a parcel.\n\nThe reservoir road home was luminous with late sun, and the wind had finally relented. Priya contemplated how much of the expedition had been waiting rather than buying. They abandoned nothing on the path, though a rolled chart tried to slip free. At the observatory kitchen they unpacked in silence, checking every item against the list. Commerce, they concluded, is a kind of careful conversation, and they had spoken it well.",
    level: 100,
    kind: "book",
  },
  {
    id: "l100-005",
    text: "Victor proposed an extraordinary refuge on the leeward side of the observatory. Jonah agreed, provided the structure was meticulous enough to endure a tempestuous night. They gathered canvas, cord, a formidable crate, and the magnificent albatross from the archive loft. The first design was intricate and promptly failed, which they treated as useful information. Priya offered advice from the conservatory steps but did not take over the work.\n\nTogether they navigated the problem of tension, anchoring each corner to stone. A luminous interior resulted when they angled a shielded lantern toward the roof. The peregrine investigated, then abandoned the doorway as insufficiently interesting. They contemplated names until Victor suggested one that was astonishing in its simplicity. Maps from a manuscript of old expeditions were pinned along the inner wall. When wind struck the peninsula, the sanctuary flexed and then held.\n\nThey ascertained the weak point and reinforced it before pride could make them careless. Night converted the fort into a laboratory of shadows and whispered plans. They recorded what still needed mending so tomorrow's work would not begin in confusion. Leaving, they felt the melancholy that follows any place you have made and must briefly desert. A fort, they concluded, is less a building than a promise you keep with your own hands.",
    level: 100,
    kind: "book",
  },
  {
    id: "l100-006",
    text: "Overnight rain had turned the observatory into a formidable, luminous torrent. Priya contemplated retreat, but Theo argued that the expedition had already come too far. They investigated the banks with meticulous patience, refusing the first tempting stone. An abandoned beam from the old mill lay in the reeds like an answer they had not earned yet. Together they navigated it into position and ascertained that the far ledge would hold.\n\nThe magnificent albatross in the satchel seemed an extraordinary responsibility above that water. Priya waited on the opposite promontory, unable to help except by staying visible. Priya crossed first, enduring the flex of wood and the astonishing noise below. Theo followed only when the beam had ceased its restless shivering. A melancholy peregrine watched from a midstream rock and did not move. They abandoned the idea of retrieving the beam; it would serve the next traveler.\n\nOn the sanctuary side they sat until their breath and the river sounded separate again. The cathedral of trees closed overhead, cooler and darker than the bank they had left. They deciphered the map's next mark and found they were still on course. Crossing had not been magnificent, only necessary, which felt like a truer kind of victory. Some obstacles, they wrote later, are laboratories in which you discover whether you can wait.",
    level: 100,
    kind: "book",
  },
  {
    id: "l100-007",
    text: "An extraordinary envelope awaited Silas on the observatory desk, sealed with unfamiliar wax. The manuscript inside was from Harriet, and its request was meticulous: come to the observatory at twilight. A second page contained an intricate map of the peninsula, annotated in two colors. Silas contemplated the magnificent implications, then packed a lantern, a compass, and a dense cloak. The albatross remaining in the sanctuary seemed to sense that this was not an ordinary errand.\n\nNavigating the laboratory corridor, Silas deciphered a postscript that changed the meeting point. Harriet was already at the amphitheater steps, restless but relieved. They ascertained that the map described not a treasure but a safe route around a collapsed wall. Priya had discovered the damage that morning and needed them to warn the archive keepers. A formidable wind off the reservoir made conversation difficult, so they used the chart as they walked. The peregrine that accompanied them kept to the luminous edge of the path.\n\nAt the cathedral gate they delivered the warning and refused any payment. The expedition home was melancholy and quiet, as necessary tasks often are. They abandoned the idea of turning the letter into a story; it had already been enough. Silas filed the manuscript in the archive, knowing they might need its notes again. Some letters, they realized, are not invitations so much as instruments of care.",
    level: 100,
    kind: "book",
  },
  {
    id: "l100-008",
    text: "Elena was turning soil at the observatory when the spade rang against something extraordinary. Amelia insisted they proceed with meticulous care, as if the ground were an archive. What emerged was an intricate, magnificent albatross whose purpose was not immediately obvious. They abandoned further digging until they could illuminate the object properly. In the laboratory of the conservatory bench, they brushed away a century of grit.\n\nPriya contemplated the markings and thought they resembled a constellation rather than a maker's stamp. A melancholy peregrine kept vigil on the sanctuary wall throughout the examination. They deciphered enough to ascertain that the piece had belonged to a surveying expedition. The peninsula's old maps, stored in the cathedral loft, showed a similar instrument. Rather than keep it, they negotiated its transfer to the observatory collection. The formidable joy of discovery, they realized, does not require ownership.\n\nThey returned to the garden and restored every clod they had displaced. Luminous evening made the freshly turned earth look almost ceremonial. Their hands remained stained, a record the soap would only slowly erase. What the ground had kept, it had kept patiently, and they had been lucky listeners. Tomorrow they would plant, because an astonishing find should not stop the ordinary work of growing things.",
    level: 100,
    kind: "book",
  },
  {
    id: "l100-009",
    text: "Theo paused on the threshold of the observatory, astonished by its magnificent scale. Victor did not hurry them; formidable buildings are best entered at their own pace. The interior was a luminous labyrinth of corridors, glass, and hushed conversation. An intricate magnificent albatross occupied a pedestal as if it were the institution's quiet heart. Priya met them with a manuscript of instructions that Theo deciphered more slowly than usual.\n\nA melancholy echo made even small sounds seem ceremonial. They were led to a laboratory annex where the actual work turned out to be humanly sized. Completing the first task, they ascertained that competence is a cure for awe. The peregrine visible through the conservatory glass looked like an ambassador from ordinary life. When they left, the amphitheater of steps no longer felt like a judgment. The peninsula wind on the way home was tempestuous and oddly comforting.\n\nVictor contemplated how often fear is simply the mind trying to map a new archive. They abandoned the idea that they had to understand everything on the first day. Night converted the memory of the building from threat into a place that could be returned to. Theo recorded the visit in a careful paragraph so the details would not dissolve. Every extraordinary room, they concluded, becomes ordinary the second time you keep your promise to enter it.",
    level: 100,
    kind: "book",
  },
  {
    id: "l100-010",
    text: "Naomi inspected the hull at the observatory with meticulous attention before they embarked. Naomi contemplated the extraordinary calm of the reservoir and did not trust it completely. They shoved off into a luminous, barely rippled expanse that still required respect. The magnificent albatross rode in a sealed crate, an astonishing passenger for such a small craft. Stroke by stroke they navigated away from the sanctuary wall toward deeper water.\n\nA tempestuous gust arrived without warning and turned the bow a formidable few degrees. They endured it by shipping one oar and letting the boat find its new line. Priya, watching from the promontory, raised a hand when they had gone far enough. The peregrine that surfaced beside them seemed like a brief, melancholy escort. They ascertained their position against the cathedral spire and began the return. Approaching the dock, they abandoned pride and took an extra circle to line up properly.\n\nThe landing was not magnificent, only competent, which was the point of the expedition. They recorded wind, time, and drift in a damp notebook from the archive pouch. Rope burns and wet sleeves were the only injuries, and they counted that as success. Night would convert the memory into something smoother than the morning had been. A boat, they concluded, is a laboratory in which you learn how little hurry the water allows.",
    level: 100,
    kind: "book",
  },
  {
    id: "l100-011",
    text: "Jonah recognized the extraordinary fact first: the observatory no longer matched any memory they trusted. Elena contemplated the magnificent canopy and refused the urge to hurry. They investigated their last certain landmark, an intricate root like a cathedral door, and could not find it again. The compass, neglected at the start of the expedition, now governed every decision. A formidable quiet settled; even the albatross in the understory had stopped moving.\n\nThey navigated by bearing rather than by hope, marking the labyrinth so they could detect a circle. Jonah would already be waiting at the sanctuary, which made delay feel like a kind of theft. When a melancholy peregrine crossed their path, they noted the direction it fled and used that as weak evidence of water. Luminous gaps in the canopy eventually revealed the observatory ridge, astonishingly farther left than expected. They ascertained a new course and endured the last mile without conversation. The archive of their mistakes would be written down that night, not hidden.\n\nAt the peninsula wall they abandoned dignity and sat until their legs would hold a civil walk home. Truth, told immediately, turned fear into a usable lesson instead of a secret. They placed the map and compass together on the laboratory shelf as a single instrument. Being lost had been tempestuous inside the mind; the forest itself had only been indifferent. The way home, they concluded, is a knowledge you practice before you desperately need it.",
    level: 100,
    kind: "book",
  },
] as unknown as ReadingText[];

export const corpusById: Record<string, ReadingText> = Object.fromEntries(corpus.map((item) => [item.id, item]));

export const textsAtLevel = (level: number): ReadingText[] => corpus.filter((item) => item.level === level);

export const sampleTextAtLevel = (level: number): ReadingText | undefined => textsAtLevel(level)[0];
